var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _circle, _path753, _text, _circle2, _path754, _text2, _circle3, _path755, _text3, _circle4, _path756, _text4, _circle5, _path757, _text5, _circle6, _path758, _text6, _circle7, _path759, _text7, _circle8, _path760, _text8, _circle9, _path761, _text9, _circle10, _path762, _text10, _circle11, _path763, _text11, _circle12, _path764, _text12, _text13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF1Blueprint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "47 84 851 650",
    preserveAspectRatio: "xMaxYMid meet",
    className: "bp-car",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ln-construct",
    d: "M771.4,600.0 L229.0,221.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ln-construct",
    d: "M463.8,570.1 L710.6,400.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ln-construct",
    d: "M172.4,327.0 L408.1,218.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M340.1,236.9 C338.0,235.3 331.9,230.8 328.0,226.9 C324.1,223.1 320.3,218.6 316.5,213.9 C312.8,209.1 309.1,203.6 305.6,198.5 C302.1,193.5 297.1,186.2 295.4,183.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M295.4,183.7 L259.4,198.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M305.6,198.5 L295.4,183.7 L259.4,198.5 L269.7,213.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M320.3,230.4 L287.6,186.9 L286.7,176.6 L297.0,191.6 L308.0,207.0 L319.6,220.2 Z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M320.3,230.4 L287.6,186.9 L286.7,176.6 L297.0,191.6 L308.0,207.0 L319.6,220.2 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M316.5,213.9 L305.6,198.5 L269.7,213.7 L280.8,229.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M328.0,226.9 L316.5,213.9 L280.8,229.3 L292.3,242.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M308.1,235.7 L275.4,192.0 L274.4,181.6 L284.7,196.7 L295.8,212.2 L307.3,225.5 Z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M308.1,235.7 L275.4,192.0 L274.4,181.6 L284.7,196.7 L295.8,212.2 L307.3,225.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M302.8,189.5 L315.1,184.4 L298.0,171.1 L285.7,176.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M340.1,236.9 L328.0,226.9 L292.3,242.8 L304.2,253.1 Z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M232.2,209.7 L259.4,198.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M290.3,194.6 L302.8,189.5 L285.7,176.1 L273.3,181.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M323.7,190.8 L324.0,186.7 L324.8,182.9 L325.9,179.6 L327.5,176.9 L329.4,174.6 L331.7,173.0 L366.2,158.7 L368.9,157.7 L371.8,157.3 L375.0,157.6 L378.2,158.6 L381.6,160.2 L385.1,162.4 L388.5,165.3 L391.8,168.7 L394.9,172.5 L397.9,176.8 L400.6,181.5 L400.9,182.0 L403.0,186.4 L404.8,190.9 L405.0,191.4 L406.6,196.5 L407.8,201.6 L408.6,206.5 L408.9,211.3 L408.8,215.7 L408.2,219.8 L407.1,223.4 L405.7,226.6 L403.9,229.2 L401.7,231.1 L399.2,232.5 L365.5,248.2 L362.9,248.9 L360.0,248.9 L356.9,248.3 L353.7,247.1 L350.5,245.2 L347.2,242.9 L344.0,239.9 L340.9,236.5 L339.5,235.0 L336.8,231.5 L334.3,227.7 L331.9,223.7 L329.8,219.5 L328.0,215.1 L326.5,210.7 L325.3,206.2 L324.5,201.9 L324.3,199.9 L323.8,195.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M408.9,211.3 L408.6,206.5 L374.2,222.1 L374.6,226.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M408.6,206.5 L407.8,201.6 L373.4,217.0 L374.2,222.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M407.8,201.6 L406.6,196.5 L372.1,211.9 L373.4,217.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M406.6,196.5 L405.0,191.4 L370.4,206.7 L372.1,211.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M405.0,191.4 L403.0,186.3 L368.3,201.6 L370.4,206.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232222",
      stroke: "#232222",
      strokeWidth: 0.8
    },
    d: "M403.0,186.3 L400.6,181.5 L365.8,196.6 L368.3,201.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M400.6,181.5 L397.9,176.8 L363.1,191.9 L365.8,196.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M397.9,176.8 L394.9,172.5 L360.1,187.5 L363.1,191.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M394.9,172.5 L391.8,168.7 L356.9,183.5 L360.1,187.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M391.8,168.7 L388.5,165.3 L353.6,180.0 L356.9,183.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M388.5,165.3 L385.1,162.4 L350.2,177.1 L353.6,180.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M385.1,162.4 L381.6,160.2 L346.8,174.7 L350.2,177.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M381.6,160.2 L378.2,158.6 L343.4,173.1 L346.8,174.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M378.2,158.6 L375.0,157.6 L340.2,172.0 L343.4,173.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M375.0,157.6 L371.8,157.3 L337.1,171.7 L340.2,172.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#201f1f",
      stroke: "#201f1f",
      strokeWidth: 0.8
    },
    d: "M371.8,157.3 L368.9,157.7 L334.3,172.0 L337.1,171.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M368.9,157.7 L366.2,158.7 L331.7,173.0 L334.3,172.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M399.2,232.5 L401.7,231.1 L367.9,246.8 L365.5,248.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M401.7,231.1 L403.9,229.2 L370.0,244.8 L367.9,246.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M403.9,229.2 L405.7,226.6 L371.8,242.3 L370.0,244.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M405.7,226.6 L407.1,223.4 L373.1,239.1 L371.8,242.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M407.1,223.4 L408.2,219.8 L374.1,235.5 L373.1,239.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M408.2,219.8 L408.8,215.7 L374.6,231.4 L374.1,235.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M408.8,215.7 L408.9,211.3 L374.6,226.9 L374.6,231.4 Z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M408.9,211.3 L374.6,226.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M406.6,196.5 L372.1,211.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M400.6,181.5 L365.8,196.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M391.8,168.7 L356.9,183.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M381.6,160.2 L346.8,174.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M371.8,157.3 L337.1,171.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M401.7,231.1 L367.9,246.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M407.1,223.4 L373.1,239.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M369.8,226.2 L369.4,221.9 L368.6,217.4 L367.5,212.7 L365.9,208.1 L364.0,203.5 L361.9,199.0 L359.4,194.7 L356.7,190.8 L353.8,187.2 L350.9,184.1 L347.8,181.5 L344.8,179.3 L341.8,177.8 L338.8,176.9 L336.1,176.5 L333.5,176.8 L331.2,177.7 L329.1,179.1 L327.4,181.1 L326.0,183.6 L324.9,186.6 L324.3,190.0 L324.0,193.7 L324.1,197.7 L324.5,201.9 L325.3,206.2 L326.5,210.7 L328.0,215.1 L329.8,219.5 L331.9,223.7 L334.3,227.7 L336.8,231.5 L339.5,235.0 L342.3,238.0 L345.2,240.7 L348.2,242.8 L351.1,244.5 L354.0,245.6 L356.7,246.1 L359.3,246.1 L361.7,245.4 L363.9,244.2 L365.7,242.4 L367.3,240.1 L368.5,237.3 L369.3,234.0 L369.7,230.3 Z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M369.8,226.2 C369.7,224.8 369.6,223.4 369.4,221.9 C369.2,220.4 369.0,218.9 368.6,217.4 C368.3,215.8 367.9,214.3 367.5,212.7 C367.0,211.2 366.5,209.6 365.9,208.1 C365.4,206.5 364.7,205.0 364.0,203.5 C363.4,201.9 362.6,200.4 361.9,199.0 C361.1,197.5 360.2,196.1 359.4,194.7 C358.5,193.4 357.6,192.1 356.7,190.8 C355.8,189.5 354.8,188.3 353.8,187.2 C352.9,186.1 351.9,185.1 350.9,184.1 C349.9,183.1 348.8,182.2 347.8,181.5 C346.8,180.7 345.8,180.0 344.8,179.3 C343.8,178.7 342.7,178.2 341.8,177.8 C340.8,177.4 339.8,177.1 338.8,176.9 C337.9,176.7 337.0,176.6 336.1,176.5 C335.2,176.5 334.3,176.6 333.5,176.8 C332.7,177.0 331.9,177.3 331.2,177.7 C330.5,178.1 329.8,178.6 329.1,179.1 C328.5,179.7 327.9,180.4 327.4,181.1 C326.9,181.9 326.4,182.7 326.0,183.6 C325.6,184.6 325.2,185.5 324.9,186.6 C324.7,187.7 324.4,188.8 324.3,190.0 C324.1,191.1 324.0,192.4 324.0,193.7 C323.9,195.0 324.0,196.3 324.1,197.7 C324.2,199.0 324.3,200.4 324.5,201.9 C324.7,203.3 325.0,204.8 325.3,206.2 C325.7,207.7 326.1,209.2 326.5,210.7 C327.0,212.1 327.5,213.6 328.0,215.1 C328.6,216.6 329.2,218.0 329.8,219.5 C330.5,220.9 331.2,222.3 331.9,223.7 C332.7,225.1 333.4,226.4 334.3,227.7 C335.1,229.1 335.9,230.3 336.8,231.5 C337.7,232.7 338.6,233.9 339.5,235.0 C340.4,236.1 341.4,237.1 342.3,238.0 C343.3,239.0 344.3,239.9 345.2,240.7 C346.2,241.5 347.2,242.2 348.2,242.8 C349.2,243.5 350.1,244.0 351.1,244.5 C352.1,244.9 353.0,245.3 354.0,245.6 C354.9,245.8 355.8,246.0 356.7,246.1 C357.6,246.2 358.5,246.2 359.3,246.1 C360.1,245.9 361.0,245.7 361.7,245.4 C362.5,245.1 363.2,244.7 363.9,244.2 C364.5,243.7 365.2,243.1 365.7,242.4 C366.3,241.7 366.8,240.9 367.3,240.1 C367.7,239.2 368.1,238.3 368.5,237.3 C368.8,236.2 369.1,235.1 369.3,234.0 C369.5,232.8 369.7,231.5 369.7,230.3 C369.8,229.0 369.8,227.6 369.8,226.2 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M362.4,221.6 L362.2,218.7 L361.6,215.6 L360.8,212.4 L359.8,209.2 L358.5,206.1 L357.0,203.0 L355.3,200.1 L353.5,197.4 L351.5,195.0 L349.5,192.8 L347.4,191.0 L345.3,189.5 L343.2,188.5 L341.2,187.8 L339.3,187.6 L337.6,187.7 L336.0,188.3 L334.5,189.3 L333.3,190.6 L332.3,192.3 L331.6,194.3 L331.1,196.7 L330.9,199.2 L331.0,202.0 L331.3,204.9 L331.8,207.9 L332.6,211.0 L333.7,214.1 L334.9,217.1 L336.4,220.0 L338.0,222.8 L339.8,225.5 L341.6,227.8 L343.6,230.0 L345.6,231.8 L347.7,233.3 L349.7,234.4 L351.7,235.1 L353.6,235.5 L355.3,235.4 L357.0,234.9 L358.5,234.1 L359.7,232.8 L360.8,231.2 L361.6,229.2 L362.1,227.0 L362.4,224.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M358.7,235.9 L343.5,235.4 L301.6,254.3 L308.2,258.9 Z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M362.4,221.6 C362.4,220.7 362.3,219.7 362.2,218.7 C362.0,217.7 361.9,216.6 361.6,215.6 C361.4,214.5 361.1,213.5 360.8,212.4 C360.5,211.3 360.2,210.3 359.8,209.2 C359.4,208.2 359.0,207.1 358.5,206.1 C358.0,205.0 357.5,204.0 357.0,203.0 C356.5,202.0 355.9,201.0 355.3,200.1 C354.7,199.2 354.1,198.3 353.5,197.4 C352.8,196.6 352.2,195.7 351.5,195.0 C350.9,194.2 350.2,193.5 349.5,192.8 C348.8,192.1 348.1,191.5 347.4,191.0 C346.7,190.4 346.0,190.0 345.3,189.5 C344.6,189.1 343.9,188.8 343.2,188.5 C342.6,188.2 341.9,188.0 341.2,187.8 C340.6,187.6 340.0,187.6 339.3,187.6 C338.7,187.5 338.1,187.6 337.6,187.7 C337.0,187.8 336.5,188.0 336.0,188.3 C335.5,188.6 335.0,188.9 334.5,189.3 C334.1,189.7 333.7,190.1 333.3,190.6 C333.0,191.1 332.6,191.7 332.3,192.3 C332.1,192.9 331.8,193.6 331.6,194.3 C331.4,195.1 331.2,195.8 331.1,196.7 C331.0,197.5 330.9,198.3 330.9,199.2 C330.9,200.1 330.9,201.0 331.0,202.0 C331.0,202.9 331.1,203.9 331.3,204.9 C331.4,205.9 331.6,206.9 331.8,207.9 C332.1,208.9 332.3,209.9 332.6,211.0 C332.9,212.0 333.3,213.0 333.7,214.1 C334.1,215.1 334.5,216.1 334.9,217.1 C335.4,218.1 335.9,219.1 336.4,220.0 C336.9,221.0 337.4,221.9 338.0,222.8 C338.6,223.7 339.2,224.6 339.8,225.5 C340.4,226.3 341.0,227.1 341.6,227.8 C342.3,228.6 342.9,229.3 343.6,230.0 C344.3,230.6 344.9,231.2 345.6,231.8 C346.3,232.3 347.0,232.8 347.7,233.3 C348.3,233.7 349.0,234.1 349.7,234.4 C350.4,234.7 351.0,234.9 351.7,235.1 C352.3,235.3 352.9,235.4 353.6,235.5 C354.2,235.5 354.8,235.5 355.3,235.4 C355.9,235.3 356.5,235.2 357.0,234.9 C357.5,234.7 358.0,234.4 358.5,234.1 C358.9,233.7 359.3,233.3 359.7,232.8 C360.1,232.3 360.5,231.8 360.8,231.2 C361.1,230.6 361.4,229.9 361.6,229.2 C361.8,228.5 362.0,227.8 362.1,227.0 C362.3,226.2 362.4,225.3 362.4,224.4 C362.5,223.5 362.5,222.6 362.4,221.6 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M359.3,219.7 C359.3,218.9 359.2,218.1 359.1,217.3 C359.0,216.5 358.9,215.6 358.7,214.8 C358.5,214.0 358.3,213.1 358.0,212.3 C357.8,211.4 357.5,210.5 357.2,209.7 C356.9,208.8 356.5,208.0 356.1,207.2 C355.8,206.3 355.4,205.5 354.9,204.7 C354.5,203.9 354.0,203.1 353.6,202.4 C353.1,201.6 352.6,200.9 352.1,200.2 C351.6,199.5 351.1,198.9 350.5,198.2 C350.0,197.6 349.5,197.0 348.9,196.5 C348.3,196.0 347.8,195.5 347.2,195.0 C346.7,194.6 346.1,194.2 345.5,193.9 C345.0,193.5 344.4,193.2 343.9,193.0 C343.3,192.8 342.8,192.6 342.3,192.5 C341.7,192.3 341.2,192.3 340.7,192.2 C340.2,192.2 339.8,192.3 339.3,192.4 C338.8,192.5 338.4,192.6 338.0,192.8 C337.6,193.0 337.2,193.3 336.9,193.6 C336.5,193.9 336.2,194.3 335.9,194.7 C335.6,195.1 335.3,195.6 335.1,196.1 C334.8,196.6 334.6,197.1 334.5,197.7 C334.3,198.3 334.2,198.9 334.1,199.5 C334.0,200.2 333.9,200.9 333.9,201.6 C333.9,202.3 333.9,203.1 333.9,203.8 C334.0,204.6 334.1,205.4 334.2,206.2 C334.3,207.0 334.4,207.8 334.6,208.6 C334.8,209.4 335.0,210.3 335.3,211.1 C335.5,211.9 335.8,212.8 336.1,213.6 C336.4,214.4 336.8,215.2 337.1,216.1 C337.5,216.9 337.9,217.7 338.3,218.4 C338.7,219.2 339.2,220.0 339.6,220.7 C340.1,221.4 340.6,222.1 341.0,222.8 C341.5,223.5 342.1,224.1 342.6,224.8 C343.1,225.4 343.6,225.9 344.2,226.5 C344.7,227.0 345.2,227.5 345.8,227.9 C346.3,228.4 346.9,228.8 347.4,229.1 C348.0,229.5 348.5,229.8 349.1,230.0 C349.6,230.3 350.1,230.5 350.7,230.6 C351.2,230.8 351.7,230.9 352.2,230.9 C352.7,230.9 353.2,230.9 353.6,230.8 C354.1,230.8 354.5,230.6 355.0,230.4 C355.4,230.3 355.8,230.0 356.1,229.7 C356.5,229.5 356.9,229.1 357.2,228.7 C357.5,228.3 357.8,227.9 358.0,227.4 C358.3,226.9 358.5,226.4 358.7,225.8 C358.8,225.2 359.0,224.6 359.1,224.0 C359.2,223.3 359.3,222.6 359.3,221.9 C359.4,221.2 359.4,220.5 359.3,219.7 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#0e0e0e"
    },
    d: "M349.6,213.6 L349.5,213.0 L349.4,212.4 L349.2,211.8 L349.0,211.2 L348.8,210.6 L348.5,210.0 L348.2,209.5 L347.8,209.0 L347.5,208.5 L347.1,208.1 L346.7,207.7 L346.3,207.4 L345.9,207.2 L345.5,207.1 L345.1,207.0 L344.8,207.1 L344.5,207.2 L344.2,207.3 L343.9,207.6 L343.7,207.9 L343.6,208.3 L343.5,208.7 L343.5,209.2 L343.5,209.8 L343.5,210.3 L343.6,210.9 L343.8,211.5 L344.0,212.1 L344.2,212.7 L344.5,213.3 L344.8,213.9 L345.2,214.4 L345.5,214.8 L345.9,215.3 L346.3,215.6 L346.7,215.9 L347.1,216.1 L347.5,216.2 L347.9,216.3 L348.2,216.3 L348.5,216.2 L348.8,216.0 L349.1,215.8 L349.3,215.4 L349.4,215.1 L349.5,214.6 L349.6,214.1 Z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M349.6,213.6 C349.5,213.4 349.5,213.2 349.5,213.0 C349.5,212.8 349.4,212.6 349.4,212.4 C349.3,212.2 349.3,212.0 349.2,211.8 C349.2,211.6 349.1,211.4 349.0,211.2 C349.0,211.0 348.9,210.8 348.8,210.6 C348.7,210.4 348.6,210.2 348.5,210.0 C348.4,209.8 348.3,209.6 348.2,209.5 C348.1,209.3 348.0,209.1 347.8,209.0 C347.7,208.8 347.6,208.6 347.5,208.5 C347.3,208.3 347.2,208.2 347.1,208.1 C346.9,207.9 346.8,207.8 346.7,207.7 C346.5,207.6 346.4,207.5 346.3,207.4 C346.1,207.3 346.0,207.3 345.9,207.2 C345.7,207.2 345.6,207.1 345.5,207.1 C345.4,207.1 345.2,207.0 345.1,207.0 C345.0,207.0 344.9,207.0 344.8,207.1 C344.7,207.1 344.6,207.1 344.5,207.2 C344.4,207.2 344.3,207.3 344.2,207.3 C344.1,207.4 344.0,207.5 343.9,207.6 C343.9,207.7 343.8,207.8 343.7,207.9 C343.7,208.0 343.6,208.2 343.6,208.3 C343.6,208.4 343.5,208.6 343.5,208.7 C343.5,208.9 343.5,209.1 343.5,209.2 C343.4,209.4 343.4,209.6 343.5,209.8 C343.5,210.0 343.5,210.2 343.5,210.3 C343.5,210.5 343.6,210.7 343.6,210.9 C343.7,211.1 343.7,211.3 343.8,211.5 C343.8,211.7 343.9,211.9 344.0,212.1 C344.1,212.3 344.1,212.5 344.2,212.7 C344.3,212.9 344.4,213.1 344.5,213.3 C344.6,213.5 344.7,213.7 344.8,213.9 C344.9,214.0 345.1,214.2 345.2,214.4 C345.3,214.5 345.4,214.7 345.5,214.8 C345.7,215.0 345.8,215.1 345.9,215.3 C346.1,215.4 346.2,215.5 346.3,215.6 C346.5,215.7 346.6,215.8 346.7,215.9 C346.9,216.0 347.0,216.0 347.1,216.1 C347.3,216.2 347.4,216.2 347.5,216.2 C347.6,216.3 347.8,216.3 347.9,216.3 C348.0,216.3 348.1,216.3 348.2,216.3 C348.3,216.3 348.4,216.2 348.5,216.2 C348.6,216.1 348.7,216.1 348.8,216.0 C348.9,215.9 349.0,215.9 349.1,215.8 C349.1,215.7 349.2,215.6 349.3,215.4 C349.3,215.3 349.4,215.2 349.4,215.1 C349.4,214.9 349.5,214.8 349.5,214.6 C349.5,214.5 349.5,214.3 349.6,214.1 C349.6,213.9 349.6,213.8 349.6,213.6 Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M359.3,219.7 L350.1,213.9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M354.9,204.7 L348.8,209.7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M345.5,193.9 L346.2,206.7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M336.9,193.6 L343.8,206.6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M333.9,203.8 L343.0,209.5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M338.3,218.4 L344.2,213.6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M347.4,229.1 L346.8,216.6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M356.1,229.7 L349.2,216.7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M323.7,190.8 L324.0,186.7 L324.8,182.9 L325.9,179.6 L327.5,176.9 L329.4,174.6 L331.7,173.0 L366.2,158.7 L368.9,157.7 L371.8,157.3 L375.0,157.6 L378.2,158.6 L381.6,160.2 L385.1,162.4 L388.5,165.3 L391.8,168.7 L394.9,172.5 L397.9,176.8 L400.6,181.5 L400.9,182.0 L403.0,186.4 L404.8,190.9 L405.0,191.4 L406.6,196.5 L407.8,201.6 L408.6,206.5 L408.9,211.3 L408.8,215.7 L408.2,219.8 L407.1,223.4 L405.7,226.6 L403.9,229.2 L401.7,231.1 L399.2,232.5 L365.5,248.2 L362.9,248.9 L360.0,248.9 L356.9,248.3 L353.7,247.1 L350.5,245.2 L347.2,242.9 L344.0,239.9 L340.9,236.5 L339.5,235.0 L336.8,231.5 L334.3,227.7 L331.9,223.7 L329.8,219.5 L328.0,215.1 L326.5,210.7 L325.3,206.2 L324.5,201.9 L324.3,199.9 L323.8,195.2 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M325.8,182.7 L323.0,140.7 L293.9,120.0 L289.6,121.4 L293.5,168.4 L308.4,179.4 Z"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M325.8,182.7 L323.0,140.7 L293.9,120.0 L289.6,121.4 L293.5,168.4 L308.4,179.4 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M277.7,199.9 L290.3,194.6 L273.3,181.1 L260.7,186.2 Z"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M348.5,223.9 L292.0,232.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M383.6,247.0 L358.7,235.9 L308.2,258.9 L328.6,272.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M304.1,157.8 L316.7,152.8 L292.0,134.5 L279.5,139.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M264.9,205.2 L277.7,199.9 L260.7,186.2 L248.0,191.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M300.6,244.5 L301.8,242.6 L282.8,230.4 L281.9,231.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M298.9,246.1 L300.6,244.5 L281.9,231.8 L280.5,233.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M301.8,242.6 L302.5,240.5 L283.4,228.8 L282.8,230.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M296.4,247.7 L298.9,246.1 L280.5,233.1 L278.5,234.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M302.5,240.5 L302.8,237.8 L283.6,226.6 L283.4,228.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M294.6,141.7 L307.2,136.8 L290.9,122.1 L278.4,126.8 Z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M193.7,225.6 L232.2,209.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M290.0,250.8 L296.4,247.7 L278.5,234.4 L273.4,236.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M302.8,237.8 L302.5,231.5 L283.3,221.7 L283.6,226.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M204.2,241.3 L193.7,225.6 L232.2,209.7 L242.6,225.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M291.4,162.9 L304.1,157.8 L279.5,139.3 L266.8,144.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M283.6,253.5 L290.0,250.8 L273.4,236.7 L268.3,238.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M302.5,231.5 L301.8,225.2 L282.7,216.8 L283.3,221.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M251.9,210.6 L264.9,205.2 L248.0,191.4 L235.1,196.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M215.3,257.6 L204.2,241.3 L242.6,225.1 L253.7,241.1 Z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M348.5,223.9 L332.8,257.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M280.9,254.1 L283.6,253.5 L268.3,238.9 L266.2,239.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M281.8,146.6 L294.6,141.7 L278.4,126.8 L265.6,131.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M301.8,225.2 L301.1,223.0 L282.1,215.0 L282.7,216.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M279.1,254.1 L280.9,254.1 L266.2,239.3 L264.7,239.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M317.0,253.2 L318.5,251.1 L301.8,242.6 L300.6,244.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M301.1,223.0 L300.1,221.6 L281.3,214.0 L282.1,215.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M318.5,251.1 L319.5,248.6 L302.5,240.5 L301.8,242.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M314.8,255.2 L317.0,253.2 L300.6,244.5 L298.9,246.1 Z"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M347.3,201.5 L295.7,210.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M248.5,262.1 L215.5,216.6 L214.1,206.1 L224.6,221.7 L235.8,237.9 L247.4,251.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M277.6,253.4 L279.1,254.1 L264.7,239.3 L263.5,238.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M319.5,248.6 L319.9,245.5 L302.8,237.8 L302.5,240.5 Z"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M248.5,262.1 L215.5,216.6 L214.1,206.1 L224.6,221.7 L235.8,237.9 L247.4,251.8 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M311.7,257.3 L314.8,255.2 L298.9,246.1 L296.4,247.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M300.1,221.6 L298.7,220.9 L280.2,213.4 L281.3,214.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M226.8,271.7 L215.3,257.6 L253.7,241.1 L265.2,254.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M276.6,252.1 L277.6,253.4 L263.5,238.8 L262.7,237.7 Z"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M346.7,223.2 L318.9,222.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M278.5,168.0 L291.4,162.9 L266.8,144.1 L253.9,149.0 Z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M262.7,237.7 L263.5,238.8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M277.6,253.4 L263.5,238.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M298.7,220.9 L296.8,220.8 L278.7,213.3 L280.2,213.4 Z"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M280.2,213.4 L278.7,213.3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M298.7,220.9 L280.2,213.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M238.7,216.1 L251.9,210.6 L235.1,196.6 L221.9,201.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M319.9,245.5 L319.6,238.3 L302.5,231.5 L302.8,237.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M303.5,261.2 L311.7,257.3 L296.4,247.7 L290.0,250.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M409.2,258.5 L383.6,247.0 L328.6,272.8 L349.7,287.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M275.8,249.8 L276.6,252.1 L262.7,237.7 L262.1,236.0 Z"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M262.1,236.0 L262.7,237.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M296.8,220.8 L294.2,221.3 L276.6,213.8 L278.7,213.3 Z"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M278.7,213.3 L276.6,213.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M268.8,151.6 L281.8,146.6 L265.6,131.7 L252.7,136.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M275.0,243.6 L275.8,249.8 L262.1,236.0 L261.4,231.1 Z"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M261.4,231.1 L262.1,236.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M294.2,221.3 L287.7,224.0 L271.4,215.9 L276.6,213.8 Z"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M275.2,216.4 L256.7,165.9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M276.6,213.8 L271.4,215.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M319.6,238.3 L318.9,231.2 L301.8,225.2 L302.5,231.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M295.3,264.7 L303.5,261.2 L290.0,250.8 L283.6,253.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M235.4,268.0 L202.3,222.0 L200.8,211.5 L211.3,227.2 L222.5,243.5 L234.1,257.5 Z"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M235.4,268.0 L202.3,222.0 L200.8,211.5 L211.3,227.2 L222.5,243.5 L234.1,257.5 Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M271.5,217.9 L253.0,167.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M238.7,282.7 L226.8,271.7 L265.2,254.8 L277.1,265.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M333.6,262.2 L335.5,259.7 L318.5,251.1 L317.0,253.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M335.5,259.7 L336.7,256.8 L319.5,248.6 L318.5,251.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M331.0,264.5 L333.6,262.2 L317.0,253.2 L314.8,255.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M265.4,173.3 L278.5,168.0 L253.9,149.0 L240.9,154.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M274.6,237.1 L275.0,243.6 L261.4,231.1 L261.0,226.1 Z"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M261.0,226.1 L261.4,231.1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M275.0,243.6 L261.4,231.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M287.7,224.0 L281.1,227.0 L266.2,218.2 L271.4,215.9 Z"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M271.4,215.9 L266.2,218.2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M287.7,224.0 L271.4,215.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M336.7,256.8 L337.3,253.3 L319.9,245.5 L319.5,248.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M225.4,221.7 L238.7,216.1 L221.9,201.9 L208.6,207.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M318.9,231.2 L318.0,228.6 L301.1,223.0 L301.8,225.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M327.2,267.0 L331.0,264.5 L314.8,255.2 L311.7,257.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M292.0,265.6 L295.3,264.7 L283.6,253.5 L280.9,254.1 Z"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M238.7,282.7 C236.7,280.9 230.7,275.9 226.8,271.7 C222.9,267.6 219.1,262.7 215.3,257.6 C211.5,252.6 207.8,246.7 204.2,241.3 C200.5,236.0 195.4,228.2 193.7,225.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M274.9,234.4 L274.6,237.1 L261.0,226.1 L261.3,223.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M281.1,227.0 L278.6,228.6 L264.2,219.5 L266.2,218.2 Z"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M347.3,201.5 L323.1,227.5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M261.3,223.9 L261.0,226.1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M266.2,218.2 L264.2,219.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M318.0,228.6 L316.8,227.0 L300.1,221.6 L301.1,223.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M255.7,156.7 L268.8,151.6 L252.7,136.5 L239.5,141.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M275.6,232.2 L274.9,234.4 L261.3,223.9 L261.8,222.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M289.6,265.7 L292.0,265.6 L280.9,254.1 L279.1,254.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M278.6,228.6 L276.8,230.3 L262.8,220.8 L264.2,219.5 Z"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M261.8,222.2 L261.3,223.9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M264.2,219.5 L262.8,220.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M276.8,230.3 L275.6,232.2 L261.8,222.2 L262.8,220.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M337.3,253.3 L337.1,245.2 L319.6,238.3 L319.9,245.5 Z"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M262.8,220.8 L261.8,222.2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M275.6,232.2 L261.8,222.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M317.3,271.8 L327.2,267.0 L311.7,257.3 L303.5,261.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M316.8,227.0 L315.0,226.3 L298.7,220.9 L300.1,221.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M287.8,265.0 L289.6,265.7 L279.1,254.1 L277.6,253.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M315.0,226.3 L312.7,226.3 L296.8,220.8 L298.7,220.9 Z"
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M298.7,220.9 L296.8,220.8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M315.0,226.3 L298.7,220.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1a",
      stroke: "#1b1b1a",
      strokeWidth: 0.8
    },
    d: "M286.5,263.6 L287.8,265.0 L277.6,253.4 L276.6,252.1 Z"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M276.6,252.1 L277.6,253.4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M287.8,265.0 L277.6,253.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M252.1,178.6 L265.4,173.3 L240.9,154.0 L227.7,159.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M349.4,268.6 L351.7,265.8 L335.5,259.7 L333.6,262.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M351.7,265.8 L353.3,262.7 L336.7,256.8 L335.5,259.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M312.7,226.3 L309.4,227.1 L294.2,221.3 L296.8,220.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M211.8,227.3 L225.4,221.7 L208.6,207.3 L195.2,212.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M337.1,245.2 L336.3,237.2 L318.9,231.2 L319.6,238.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M346.1,271.4 L349.4,268.6 L333.6,262.2 L331.0,264.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M231.7,293.7 L234.9,284.4 L279.9,264.1 L286.5,268.8 Z"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M296.8,220.8 L294.2,221.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M285.5,261.0 L286.5,263.6 L276.6,252.1 L275.8,249.8 Z"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M211.8,227.3 C214.1,226.4 220.9,223.5 225.4,221.7 C229.9,219.8 234.3,217.9 238.7,216.1 C243.2,214.3 247.6,212.4 251.9,210.6 C256.3,208.8 260.6,207.0 264.9,205.2 C269.2,203.4 273.5,201.7 277.7,199.9 C281.9,198.1 286.1,196.4 290.3,194.6 C294.5,192.9 298.6,191.2 302.8,189.5 C306.9,187.8 313.0,185.2 315.1,184.4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M195.2,212.7 C197.4,211.8 204.2,209.1 208.6,207.3 C213.1,205.5 217.5,203.7 221.9,201.9 C226.3,200.1 230.7,198.3 235.1,196.6 C239.4,194.8 243.7,193.1 248.0,191.4 C252.3,189.6 256.5,187.9 260.7,186.2 C265.0,184.5 269.2,182.8 273.3,181.1 C277.5,179.4 281.6,177.7 285.7,176.1 C289.8,174.4 295.9,171.9 298.0,171.1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M275.8,249.8 L276.6,252.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M425.1,268.8 L409.2,258.5 L349.7,287.2 L365.7,298.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M353.3,262.7 L354.1,258.9 L337.3,253.3 L336.7,256.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M307.3,276.2 L317.3,271.8 L303.5,261.2 L295.3,264.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M341.3,274.4 L346.1,271.4 L331.0,264.5 L327.2,267.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M242.3,161.9 L255.7,156.7 L239.5,141.5 L226.2,146.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M309.4,227.1 L301.1,230.6 L287.7,224.0 L294.2,221.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M284.6,253.9 L285.5,261.0 L275.8,249.8 L275.0,243.6 Z"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M294.2,221.3 L287.7,224.0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M275.0,243.6 L275.8,249.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M336.3,237.2 L335.3,234.3 L318.0,228.6 L318.9,231.2 Z"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M240.3,272.1 L264.7,244.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M354.1,258.9 L354.0,250.2 L337.1,245.2 L337.3,253.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M303.3,277.4 L307.3,276.2 L295.3,264.7 L292.0,265.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M335.3,234.3 L333.8,232.6 L316.8,227.0 L318.0,228.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M329.0,280.4 L341.3,274.4 L327.2,267.0 L317.3,271.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M368.2,272.0 L370.1,268.6 L353.3,262.7 L351.7,265.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M365.4,275.2 L368.2,272.0 L351.7,265.8 L349.4,268.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M238.6,183.9 L252.1,178.6 L227.7,159.1 L214.3,164.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M370.1,268.6 L371.1,264.5 L354.1,258.9 L353.3,262.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M301.1,230.6 L292.7,234.5 L281.1,227.0 L287.7,224.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M361.4,278.4 L365.4,275.2 L349.4,268.6 L346.1,271.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M284.2,246.5 L284.6,253.9 L275.0,243.6 L274.6,237.1 Z"
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M287.7,224.0 L281.1,227.0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M301.1,230.6 L287.7,224.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M300.4,277.6 L303.3,277.4 L292.0,265.6 L289.6,265.7 Z"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M274.6,237.1 L275.0,243.6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M284.6,253.9 L275.0,243.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M333.8,232.6 L331.7,231.9 L315.0,226.3 L316.8,227.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M354.0,250.2 L353.2,241.8 L336.3,237.2 L337.1,245.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M355.6,281.9 L361.4,278.4 L346.1,271.4 L341.3,274.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M228.8,167.2 L242.3,161.9 L226.2,146.5 L212.7,151.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M298.2,276.9 L300.4,277.6 L289.6,265.7 L287.8,265.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M331.7,231.9 L328.9,232.0 L312.7,226.3 L315.0,226.3 Z"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M331.7,231.9 L315.0,226.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M292.7,234.5 L289.4,236.5 L278.6,228.6 L281.1,227.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M284.6,243.3 L284.2,246.5 L274.6,237.1 L274.9,234.4 Z"
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M281.1,227.0 L278.6,228.6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M274.9,234.4 L274.6,237.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M371.1,264.5 L371.1,255.3 L354.0,250.2 L354.1,258.9 Z"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M606.6,445.3 L594.8,410.1 L583.8,377.2 L564.7,363.5 L546.0,350.2 L527.9,337.3 L510.3,324.7 L493.2,312.5 L475.5,301.2 L458.3,290.1 L441.5,279.3 L425.1,268.8 L409.2,258.5 L383.6,247.0 L358.7,235.9 L343.5,235.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M289.4,236.5 L287.2,238.6 L276.8,230.3 L278.6,228.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M285.6,240.8 L284.6,243.3 L274.9,234.4 L275.6,232.2 Z"
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M278.6,228.6 L276.8,230.3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M275.6,232.2 L274.9,234.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M287.2,238.6 L285.6,240.8 L275.6,232.2 L276.8,230.3 Z"
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M276.8,230.3 L275.6,232.2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M285.6,240.8 L275.6,232.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M296.6,275.3 L298.2,276.9 L287.8,265.0 L286.5,263.6 Z"
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M286.5,263.6 L287.8,265.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M328.9,232.0 L324.9,233.1 L309.4,227.1 L312.7,226.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M316.5,286.1 L329.0,280.4 L317.3,271.8 L307.3,276.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M353.2,241.8 L352.1,238.8 L335.3,234.3 L336.3,237.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M384.9,278.4 L387.1,274.6 L370.1,268.6 L368.2,272.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M381.6,281.9 L384.9,278.4 L368.2,272.0 L365.4,275.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M441.5,279.3 L425.1,268.8 L365.7,298.1 L382.0,309.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1e1e",
      stroke: "#1f1e1e",
      strokeWidth: 0.8
    },
    d: "M295.5,272.5 L296.6,275.3 L286.5,263.6 L285.5,261.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M246.7,311.2 L231.7,293.7 L286.5,268.8 L306.8,283.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M224.9,189.4 L238.6,183.9 L214.3,164.2 L200.7,169.4 Z"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M296.6,275.3 L286.5,263.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M387.1,274.6 L388.4,270.3 L371.1,264.5 L370.1,268.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M340.9,289.2 L355.6,281.9 L341.3,274.4 L329.0,280.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M376.9,285.5 L381.6,281.9 L365.4,275.2 L361.4,278.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M352.1,238.8 L350.2,237.2 L333.8,232.6 L335.3,234.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M324.9,233.1 L314.8,237.4 L301.1,230.6 L309.4,227.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M371.1,255.3 L370.4,246.4 L353.2,241.8 L354.0,250.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M215.1,172.5 L228.8,167.2 L212.7,151.6 L199.0,156.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M311.4,287.8 L316.5,286.1 L307.3,276.2 L303.3,277.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M370.2,289.5 L376.9,285.5 L361.4,278.4 L355.6,281.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M294.5,264.5 L295.5,272.5 L285.5,261.0 L284.6,253.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1d1d",
      stroke: "#1e1d1d",
      strokeWidth: 0.8
    },
    d: "M350.2,237.2 L347.7,236.5 L331.7,231.9 L333.8,232.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M388.4,270.3 L388.5,260.6 L371.1,255.3 L371.1,264.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M307.8,288.3 L311.4,287.8 L303.3,277.4 L300.4,277.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M347.7,236.5 L344.2,236.9 L328.9,232.0 L331.7,231.9 Z"
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M331.7,231.9 L328.9,232.0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M347.7,236.5 L331.7,231.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M370.4,246.4 L369.0,243.4 L352.1,238.8 L353.2,241.8 Z"
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M240.3,272.1 L297.9,273.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M221.6,226.2 L216.1,182.7 L187.7,159.9 L183.9,161.1 L190.8,209.7 L205.4,221.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M402.8,285.5 L405.4,281.5 L387.1,274.6 L384.9,278.4 Z"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M221.6,226.2 L216.1,182.7 L187.7,159.9 L183.9,161.1 L190.8,209.7 L205.4,221.8 Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M237.6,249.1 L268.0,222.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M399.0,289.3 L402.8,285.5 L384.9,278.4 L381.6,281.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M314.8,237.4 L304.6,242.1 L292.7,234.5 L301.1,230.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M211.1,194.9 L224.9,189.4 L200.7,169.4 L186.9,174.7 Z"
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M314.8,237.4 L301.1,230.6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M211.1,194.9 C213.4,194.0 220.4,191.2 224.9,189.4 C229.5,187.6 234.1,185.7 238.6,183.9 C243.1,182.1 247.6,180.3 252.1,178.6 C256.6,176.8 261.0,175.0 265.4,173.3 C269.8,171.5 274.1,169.8 278.5,168.0 C282.8,166.3 287.1,164.6 291.4,162.9 C295.7,161.2 299.9,159.5 304.1,157.8 C308.3,156.1 314.6,153.6 316.7,152.8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M186.9,174.7 C189.2,173.8 196.2,171.2 200.7,169.4 C205.3,167.7 209.8,166.0 214.3,164.2 C218.8,162.5 223.3,160.8 227.7,159.1 C232.1,157.4 236.6,155.7 240.9,154.0 C245.3,152.4 249.6,150.7 253.9,149.0 C258.3,147.4 262.5,145.7 266.8,144.1 C271.0,142.5 275.3,140.9 279.5,139.3 C283.7,137.7 289.9,135.3 292.0,134.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M405.4,281.5 L406.8,276.9 L388.4,270.3 L387.1,274.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M294.1,256.2 L294.5,264.5 L284.6,253.9 L284.2,246.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M323.1,230.0 L322.9,228.0 L313.8,225.0 L314.1,226.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M305.1,287.8 L307.8,288.3 L300.4,277.6 L298.2,276.9 Z"
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M294.5,264.5 L284.6,253.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M325.9,296.2 L340.9,289.2 L329.0,280.4 L316.5,286.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M344.2,236.9 L339.2,238.4 L324.9,233.1 L328.9,232.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M393.7,293.3 L399.0,289.3 L381.6,281.9 L376.9,285.5 Z"
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M328.9,232.0 L324.9,233.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M369.0,243.4 L366.9,241.7 L350.2,237.2 L352.1,238.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M322.9,228.0 L322.4,227.0 L313.4,224.1 L313.8,225.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M388.5,260.6 L387.8,251.2 L370.4,246.4 L371.1,255.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M353.0,298.2 L370.2,289.5 L355.6,281.9 L340.9,289.2 Z"
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M242.1,269.8 L285.4,237.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M322.4,227.0 L321.7,226.3 L312.8,223.6 L313.4,224.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M201.2,177.9 L215.1,172.5 L199.0,156.7 L185.1,161.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M303.2,286.2 L305.1,287.8 L298.2,276.9 L296.6,275.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M304.6,242.1 L300.6,244.6 L289.4,236.5 L292.7,234.5 Z"
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M201.2,177.9 C203.5,177.0 210.5,174.3 215.1,172.5 C219.7,170.7 224.3,168.9 228.8,167.2 C233.4,165.4 237.9,163.7 242.3,161.9 C246.8,160.2 251.3,158.5 255.7,156.7 C260.1,155.0 264.5,153.3 268.8,151.6 C273.2,150.0 277.5,148.3 281.8,146.6 C286.1,145.0 290.4,143.3 294.6,141.7 C298.8,140.0 305.1,137.6 307.2,136.8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M185.1,161.9 C187.4,161.1 194.4,158.4 199.0,156.7 C203.6,155.0 208.2,153.3 212.7,151.6 C217.2,149.8 221.7,148.2 226.2,146.5 C230.7,144.8 235.1,143.1 239.5,141.5 C243.9,139.8 248.3,138.2 252.7,136.5 C257.0,134.9 261.3,133.3 265.6,131.7 C269.9,130.0 274.1,128.4 278.4,126.8 C282.6,125.3 288.8,122.9 290.9,122.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1d",
      stroke: "#1e1e1d",
      strokeWidth: 0.8
    },
    d: "M321.7,226.3 L320.8,226.0 L312.0,223.4 L312.8,223.6 Z"
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M312.8,223.6 L312.0,223.4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M321.7,226.3 L312.8,223.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M294.7,252.6 L294.1,256.2 L284.2,246.5 L284.6,243.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M406.8,276.9 L407.1,266.9 L388.5,260.6 L388.4,270.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1e1e",
      stroke: "#1f1e1e",
      strokeWidth: 0.8
    },
    d: "M366.9,241.7 L363.9,241.3 L347.7,236.5 L350.2,237.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M320.8,226.0 L319.6,226.1 L310.9,223.5 L312.0,223.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M386.1,297.9 L393.7,293.3 L376.9,285.5 L370.2,289.5 Z"
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M350.2,237.2 L347.7,236.5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M366.9,241.7 L350.2,237.2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M312.0,223.4 L310.9,223.5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M320.8,226.0 L312.0,223.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M300.6,244.6 L297.8,247.0 L287.2,238.6 L289.4,236.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M295.9,249.6 L294.7,252.6 L284.6,243.3 L285.6,240.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M297.8,247.0 L295.9,249.6 L285.6,240.8 L287.2,238.6 Z"
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M295.9,249.6 L285.6,240.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M319.6,226.1 L318.1,226.4 L309.6,223.8 L310.9,223.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M458.3,290.1 L441.5,279.3 L382.0,309.3 L398.8,320.8 Z"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M310.9,223.5 L309.6,223.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M301.8,283.3 L303.2,286.2 L296.6,275.3 L295.5,272.5 Z"
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M295.5,272.5 L296.6,275.3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M303.2,286.2 L296.6,275.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M339.2,238.4 L326.6,243.9 L314.8,237.4 L324.9,233.1 Z"
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M324.9,233.1 L314.8,237.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M387.8,251.2 L386.3,248.0 L369.0,243.4 L370.4,246.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M318.1,226.4 L315.4,227.5 L307.2,224.8 L309.6,223.8 Z"
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M309.6,223.8 L307.2,224.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M319.8,298.4 L325.9,296.2 L316.5,286.1 L311.4,287.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M363.9,241.3 L359.7,241.9 L344.2,236.9 L347.7,236.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M421.0,292.7 L423.9,288.5 L405.4,281.5 L402.8,285.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M315.4,227.5 L312.7,228.8 L304.8,225.9 L307.2,224.8 Z"
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M307.2,224.8 L304.8,225.9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M315.4,227.5 L307.2,224.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M416.8,296.9 L421.0,292.7 L402.8,285.5 L399.0,289.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M423.9,288.5 L425.6,283.7 L406.8,276.9 L405.4,281.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M308.4,234.3 L308.5,236.5 L301.0,232.4 L300.9,230.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M332.3,233.4 L332.0,231.0 L322.9,228.0 L323.1,230.0 Z"
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M300.9,230.6 L301.0,232.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M312.7,228.8 L311.2,229.8 L303.4,226.8 L304.8,225.9 Z"
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M304.8,225.9 L303.4,226.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M308.7,233.0 L308.4,234.3 L300.9,230.6 L301.2,229.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M386.3,248.0 L383.8,246.4 L366.9,241.7 L369.0,243.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M311.2,229.8 L310.1,230.8 L302.4,227.6 L303.4,226.8 Z"
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M301.2,229.5 L300.9,230.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M300.8,274.8 L301.8,283.3 L295.5,272.5 L294.5,264.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M309.3,231.8 L308.7,233.0 L301.2,229.5 L301.7,228.5 Z"
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M303.4,226.8 L302.4,227.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M310.1,230.8 L309.3,231.8 L301.7,228.5 L302.4,227.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M407.1,266.9 L406.4,257.2 L387.8,251.2 L388.5,260.6 Z"
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M294.5,264.5 L295.5,272.5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M301.7,228.5 L301.2,229.5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M302.4,227.6 L301.7,228.5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M310.1,230.8 L302.4,227.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M332.0,231.0 L331.5,229.8 L322.4,227.0 L322.9,228.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M410.9,301.3 L416.8,296.9 L399.0,289.3 L393.7,293.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M315.4,299.2 L319.8,298.4 L311.4,287.8 L307.8,288.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M359.7,241.9 L353.7,243.8 L339.2,238.4 L344.2,236.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M331.5,229.8 L330.8,229.1 L321.7,226.3 L322.4,227.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M335.4,306.6 L353.0,298.2 L340.9,289.2 L325.9,296.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M366.6,307.9 L386.1,297.9 L370.2,289.5 L353.0,298.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M262.3,329.4 L246.7,311.2 L306.8,283.1 L327.7,297.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M330.8,229.1 L329.8,228.7 L320.8,226.0 L321.7,226.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M425.6,283.7 L426.0,273.3 L407.1,266.9 L406.8,276.9 Z"
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M321.7,226.3 L320.8,226.0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M237.6,249.1 L295.1,239.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M383.8,246.4 L380.3,246.1 L363.9,241.3 L366.9,241.7 Z"
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M366.9,241.7 L363.9,241.3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M383.8,246.4 L366.9,241.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M326.6,243.9 L313.8,249.9 L304.6,242.1 L314.8,237.4 Z"
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M314.8,237.4 L304.6,242.1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M326.6,243.9 L314.8,237.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M329.8,228.7 L328.5,228.7 L319.6,226.1 L320.8,226.0 Z"
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M320.8,226.0 L319.6,226.1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M329.8,228.7 L320.8,226.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M312.2,298.9 L315.4,299.2 L307.8,288.3 L305.1,287.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M402.3,306.4 L410.9,301.3 L393.7,293.3 L386.1,297.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M328.5,228.7 L326.8,229.1 L318.1,226.4 L319.6,226.1 Z"
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M319.6,226.1 L318.1,226.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M406.4,257.2 L404.8,254.0 L386.3,248.0 L387.8,251.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M300.4,265.9 L300.8,274.8 L294.5,264.5 L294.1,256.2 Z"
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M294.1,256.2 L294.5,264.5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M300.8,274.8 L294.5,264.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M326.8,229.1 L323.8,230.3 L315.4,227.5 L318.1,226.4 Z"
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M318.1,226.4 L315.4,227.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M380.3,246.1 L375.5,247.0 L359.7,241.9 L363.9,241.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M309.9,297.4 L312.2,298.9 L305.1,287.8 L303.2,286.2 Z"
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M363.9,241.3 L359.7,241.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M439.5,300.1 L442.7,295.6 L423.9,288.5 L421.0,292.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M353.7,243.8 L338.6,250.5 L326.6,243.9 L339.2,238.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M442.7,295.6 L444.6,290.5 L425.6,283.7 L423.9,288.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M341.7,236.9 L341.4,234.1 L332.0,231.0 L332.3,233.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M434.8,304.6 L439.5,300.1 L421.0,292.7 L416.8,296.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M313.8,249.9 L308.7,252.9 L300.6,244.6 L304.6,242.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M323.8,230.3 L320.8,231.8 L312.7,228.8 L315.4,227.5 Z"
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M304.6,242.1 L300.6,244.6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M315.4,227.5 L312.7,228.8"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M323.8,230.3 L315.4,227.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M316.1,238.1 L316.1,240.6 L308.5,236.5 L308.4,234.3 Z"
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M308.4,234.3 L308.5,236.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M404.8,254.0 L402.1,252.5 L383.8,246.4 L386.3,248.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M320.8,231.8 L319.2,232.8 L311.2,229.8 L312.7,228.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M301.2,262.0 L300.4,265.9 L294.1,256.2 L294.7,252.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M341.4,234.1 L340.8,232.7 L331.5,229.8 L332.0,231.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M426.0,273.3 L425.4,263.3 L406.4,257.2 L407.1,266.9 Z"
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M312.7,228.8 L311.2,229.8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M294.7,252.6 L294.1,256.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M328.3,309.3 L335.4,306.6 L325.9,296.2 L319.8,298.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M316.4,236.6 L316.1,238.1 L308.4,234.3 L308.7,233.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M308.3,294.4 L309.9,297.4 L303.2,286.2 L301.8,283.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M308.7,252.9 L305.2,255.8 L297.8,247.0 L300.6,244.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M475.5,301.2 L458.3,290.1 L398.8,320.8 L416.0,332.6 Z"
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M308.7,233.0 L308.4,234.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M319.2,232.8 L317.9,234.0 L310.1,230.8 L311.2,229.8 Z"
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M309.9,297.4 L303.2,286.2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M300.6,244.6 L297.8,247.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M317.0,235.2 L316.4,236.6 L308.7,233.0 L309.3,231.8 Z"
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M311.2,229.8 L310.1,230.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M317.9,234.0 L317.0,235.2 L309.3,231.8 L310.1,230.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M428.3,309.4 L434.8,304.6 L416.8,296.9 L410.9,301.3 Z"
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M309.3,231.8 L308.7,233.0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M310.1,230.8 L309.3,231.8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M317.9,234.0 L310.1,230.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M302.8,258.7 L301.2,262.0 L294.7,252.6 L295.9,249.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M305.2,255.8 L302.8,258.7 L295.9,249.6 L297.8,247.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M340.8,232.7 L340.0,231.9 L330.8,229.1 L331.5,229.8 Z"
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M295.9,249.6 L294.7,252.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M375.5,247.0 L368.5,249.4 L353.7,243.8 L359.7,241.9 Z"
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M297.8,247.0 L295.9,249.6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M302.8,258.7 L295.9,249.6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M359.7,241.9 L353.7,243.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M444.6,290.5 L445.3,279.8 L426.0,273.3 L425.6,283.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M340.0,231.9 L338.9,231.4 L329.8,228.7 L330.8,229.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M402.1,252.5 L398.1,252.3 L380.3,246.1 L383.8,246.4 Z"
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M402.1,252.5 L383.8,246.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M338.9,231.4 L337.5,231.4 L328.5,228.7 L329.8,228.7 Z"
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M338.9,231.4 L329.8,228.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M380.5,317.8 L402.3,306.4 L386.1,297.9 L366.6,307.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M323.2,310.4 L328.3,309.3 L319.8,298.4 L315.4,299.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M173.1,253.7 L173.2,249.9 L173.5,246.1 L174.2,242.7 L175.2,240.0 L176.7,237.8 L178.6,236.3 L219.3,219.5 L221.6,218.6 L224.2,218.4 L227.0,219.0 L230.1,220.2 L233.3,222.2 L236.6,224.8 L239.2,227.3 L242.3,230.2 L245.2,233.6 L248.2,237.4 L250.9,241.7 L253.5,246.2 L255.9,250.9 L257.9,255.8 L259.7,260.7 L261.1,265.5 L262.2,270.2 L262.8,274.7 L263.1,278.8 L263.2,282.3 L263.0,286.5 L262.5,290.2 L261.4,293.3 L260.0,295.9 L258.3,297.8 L256.1,299.0 L216.6,317.4 L214.3,317.8 L211.7,317.6 L208.9,316.7 L206.0,315.2 L202.9,313.0 L199.9,310.6 L197.0,308.1 L194.2,305.1 L191.3,301.7 L188.6,297.9 L185.9,293.7 L183.4,289.3 L181.2,284.8 L179.1,280.1 L177.3,275.3 L175.8,270.6 L174.6,266.0 L173.7,261.6 L173.2,257.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M222.4,296.1 L221.6,291.0 L262.2,272.7 L262.9,277.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M221.6,291.0 L220.3,285.7 L261.0,267.4 L262.2,272.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M220.3,285.7 L218.6,280.2 L259.4,262.0 L261.0,267.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M218.6,280.2 L216.5,274.7 L257.5,256.6 L259.4,262.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M216.5,274.7 L214.1,269.2 L255.2,251.2 L257.5,256.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232222",
      stroke: "#232222",
      strokeWidth: 0.8
    },
    d: "M214.1,269.2 L211.4,263.8 L252.5,245.9 L255.2,251.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M211.4,263.8 L208.5,258.6 L249.6,240.8 L252.5,245.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M208.5,258.6 L205.3,253.8 L246.5,236.1 L249.6,240.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M205.3,253.8 L202.1,249.4 L243.3,231.8 L246.5,236.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M202.1,249.4 L198.8,245.4 L240.0,228.0 L243.3,231.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M198.8,245.4 L195.4,242.1 L236.6,224.8 L240.0,228.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M195.4,242.1 L192.2,239.4 L233.3,222.2 L236.6,224.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M192.2,239.4 L189.0,237.3 L230.1,220.2 L233.3,222.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M189.0,237.3 L186.0,236.0 L227.0,219.0 L230.1,220.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M186.0,236.0 L183.2,235.4 L224.2,218.4 L227.0,219.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#201f1f",
      stroke: "#201f1f",
      strokeWidth: 0.8
    },
    d: "M183.2,235.4 L180.7,235.5 L221.6,218.6 L224.2,218.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M180.7,235.5 L178.6,236.3 L219.3,219.5 L221.6,218.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M216.6,317.4 L218.6,316.2 L258.3,297.8 L256.1,299.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M218.6,316.2 L220.2,314.3 L260.0,295.9 L258.3,297.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M220.2,314.3 L221.5,311.8 L261.4,293.3 L260.0,295.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M221.5,311.8 L222.4,308.7 L262.5,290.2 L261.4,293.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M222.4,308.7 L222.8,305.0 L263.0,286.5 L262.5,290.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M222.8,305.0 L222.8,300.7 L263.2,282.3 L263.0,286.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M222.8,300.7 L222.4,296.1 L262.9,277.6 L263.2,282.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M346.6,317.6 L366.6,307.9 L353.0,298.2 L335.4,306.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M337.5,231.4 L335.6,231.8 L326.8,229.1 L328.5,228.7 Z"
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M222.4,296.1 L262.9,277.6"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M218.6,280.2 L259.4,262.0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M211.4,263.8 L252.5,245.9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M202.1,249.4 L243.3,231.8"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M192.2,239.4 L233.3,222.2"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M183.2,235.4 L224.2,218.4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M218.6,316.2 L258.3,297.8"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M222.4,308.7 L262.5,290.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M217.3,295.3 L216.5,290.8 L215.3,286.0 L213.8,281.1 L212.0,276.1 L209.8,271.1 L207.4,266.3 L204.7,261.6 L201.9,257.3 L199.0,253.3 L196.0,249.8 L193.0,246.8 L190.1,244.3 L187.3,242.5 L184.6,241.3 L182.1,240.7 L179.8,240.8 L177.9,241.5 L176.2,242.8 L174.9,244.7 L173.9,247.2 L173.3,250.2 L173.1,253.7 L173.2,257.5 L173.7,261.6 L174.6,266.0 L175.8,270.6 L177.3,275.3 L179.1,280.1 L181.2,284.8 L183.4,289.3 L185.9,293.7 L188.6,297.9 L191.3,301.7 L194.2,305.1 L197.0,308.1 L199.9,310.6 L202.6,312.6 L205.3,314.0 L207.8,314.8 L210.1,315.0 L212.1,314.5 L213.9,313.4 L215.4,311.8 L216.5,309.5 L217.3,306.7 L217.7,303.3 L217.7,299.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M307.2,285.4 L308.3,294.4 L301.8,283.3 L300.8,274.8 Z"
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M217.3,295.3 C217.1,293.8 216.8,292.3 216.5,290.8 C216.2,289.2 215.8,287.6 215.3,286.0 C214.9,284.4 214.4,282.7 213.8,281.1 C213.3,279.4 212.6,277.7 212.0,276.1 C211.3,274.4 210.6,272.7 209.8,271.1 C209.0,269.5 208.2,267.8 207.4,266.3 C206.5,264.7 205.6,263.1 204.7,261.6 C203.8,260.1 202.9,258.7 201.9,257.3 C201.0,255.9 200.0,254.6 199.0,253.3 C198.0,252.1 197.0,250.9 196.0,249.8 C195.0,248.7 194.0,247.7 193.0,246.8 C192.0,245.9 191.1,245.0 190.1,244.3 C189.1,243.6 188.2,243.0 187.3,242.5 C186.3,242.0 185.4,241.6 184.6,241.3 C183.7,241.0 182.9,240.8 182.1,240.7 C181.3,240.6 180.5,240.6 179.8,240.8 C179.1,240.9 178.5,241.1 177.9,241.5 C177.3,241.8 176.7,242.3 176.2,242.8 C175.7,243.4 175.3,244.0 174.9,244.7 C174.5,245.5 174.2,246.3 173.9,247.2 C173.7,248.1 173.5,249.1 173.3,250.2 C173.2,251.3 173.1,252.4 173.1,253.7 C173.1,254.9 173.1,256.2 173.2,257.5 C173.3,258.8 173.5,260.2 173.7,261.6 C173.9,263.1 174.2,264.5 174.6,266.0 C174.9,267.5 175.3,269.1 175.8,270.6 C176.2,272.2 176.7,273.8 177.3,275.3 C177.8,276.9 178.4,278.5 179.1,280.1 C179.7,281.6 180.4,283.2 181.2,284.8 C181.9,286.3 182.7,287.8 183.4,289.3 C184.2,290.8 185.1,292.3 185.9,293.7 C186.8,295.2 187.7,296.5 188.6,297.9 C189.5,299.2 190.4,300.5 191.3,301.7 C192.3,302.9 193.2,304.0 194.2,305.1 C195.1,306.2 196.1,307.2 197.0,308.1 C198.0,309.0 198.9,309.9 199.9,310.6 C200.8,311.3 201.7,312.0 202.6,312.6 C203.5,313.1 204.4,313.6 205.3,314.0 C206.1,314.3 207.0,314.6 207.8,314.8 C208.6,314.9 209.4,315.0 210.1,315.0 C210.8,314.9 211.5,314.8 212.1,314.5 C212.8,314.3 213.4,313.9 213.9,313.4 C214.5,313.0 215.0,312.4 215.4,311.8 C215.8,311.1 216.2,310.3 216.5,309.5 C216.9,308.6 217.1,307.7 217.3,306.7 C217.5,305.6 217.6,304.5 217.7,303.3 C217.8,302.1 217.8,300.8 217.7,299.5 C217.6,298.2 217.5,296.7 217.3,295.3 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M418.9,315.1 L428.3,309.4 L410.9,301.3 L402.3,306.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M210.3,289.9 L209.7,286.8 L208.9,283.5 L207.9,280.1 L206.6,276.7 L205.1,273.3 L203.5,270.0 L201.7,266.9 L199.8,263.9 L197.8,261.2 L195.7,258.8 L193.7,256.7 L191.7,255.0 L189.7,253.7 L187.9,252.8 L186.2,252.4 L184.6,252.4 L183.2,252.9 L182.1,253.8 L181.2,255.1 L180.5,256.8 L180.0,258.8 L179.9,261.2 L179.9,263.8 L180.3,266.7 L180.9,269.7 L181.7,272.9 L182.7,276.2 L184.0,279.5 L185.4,282.7 L187.0,285.9 L188.7,289.0 L190.6,291.8 L192.5,294.5 L194.4,296.9 L196.4,298.9 L198.4,300.6 L200.3,302.0 L202.1,302.9 L203.9,303.5 L205.4,303.6 L206.8,303.2 L208.1,302.5 L209.1,301.3 L209.8,299.7 L210.3,297.7 L210.6,295.4 L210.6,292.8 Z"
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M210.3,289.9 C210.2,288.9 210.0,287.8 209.7,286.8 C209.5,285.7 209.2,284.6 208.9,283.5 C208.6,282.4 208.3,281.3 207.9,280.1 C207.5,279.0 207.1,277.9 206.6,276.7 C206.1,275.6 205.7,274.5 205.1,273.3 C204.6,272.2 204.0,271.1 203.5,270.0 C202.9,268.9 202.3,267.9 201.7,266.9 C201.1,265.8 200.4,264.8 199.8,263.9 C199.1,262.9 198.4,262.0 197.8,261.2 C197.1,260.3 196.4,259.5 195.7,258.8 C195.0,258.0 194.4,257.3 193.7,256.7 C193.0,256.1 192.3,255.5 191.7,255.0 C191.0,254.5 190.4,254.1 189.7,253.7 C189.1,253.3 188.5,253.1 187.9,252.8 C187.3,252.6 186.7,252.5 186.2,252.4 C185.6,252.4 185.1,252.4 184.6,252.4 C184.1,252.5 183.7,252.7 183.2,252.9 C182.8,253.1 182.4,253.4 182.1,253.8 C181.7,254.2 181.4,254.6 181.2,255.1 C180.9,255.6 180.7,256.2 180.5,256.8 C180.3,257.4 180.1,258.1 180.0,258.8 C179.9,259.6 179.9,260.4 179.9,261.2 C179.8,262.0 179.9,262.9 179.9,263.8 C180.0,264.7 180.1,265.7 180.3,266.7 C180.4,267.7 180.6,268.7 180.9,269.7 C181.1,270.8 181.4,271.9 181.7,272.9 C182.0,274.0 182.3,275.1 182.7,276.2 C183.1,277.3 183.5,278.4 184.0,279.5 C184.4,280.6 184.9,281.7 185.4,282.7 C185.9,283.8 186.4,284.9 187.0,285.9 C187.6,287.0 188.1,288.0 188.7,289.0 C189.3,290.0 189.9,290.9 190.6,291.8 C191.2,292.8 191.8,293.6 192.5,294.5 C193.1,295.3 193.8,296.1 194.4,296.9 C195.1,297.6 195.8,298.3 196.4,298.9 C197.1,299.5 197.7,300.1 198.4,300.6 C199.0,301.1 199.7,301.6 200.3,302.0 C200.9,302.4 201.5,302.7 202.1,302.9 C202.7,303.2 203.3,303.4 203.9,303.5 C204.4,303.6 204.9,303.6 205.4,303.6 C205.9,303.5 206.4,303.4 206.8,303.2 C207.3,303.0 207.7,302.8 208.1,302.5 C208.4,302.1 208.8,301.7 209.1,301.3 C209.4,300.8 209.6,300.3 209.8,299.7 C210.0,299.1 210.2,298.4 210.3,297.7 C210.5,297.0 210.6,296.2 210.6,295.4 C210.6,294.6 210.6,293.7 210.6,292.8 C210.5,291.8 210.4,290.9 210.3,289.9 Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M207.3,287.6 C207.2,286.8 207.0,285.9 206.9,285.1 C206.7,284.2 206.5,283.3 206.2,282.4 C206.0,281.6 205.7,280.6 205.4,279.7 C205.1,278.8 204.7,277.9 204.3,277.0 C204.0,276.1 203.6,275.2 203.2,274.3 C202.7,273.4 202.3,272.5 201.8,271.6 C201.4,270.8 200.9,269.9 200.4,269.1 C199.9,268.3 199.4,267.5 198.8,266.7 C198.3,265.9 197.8,265.2 197.2,264.5 C196.7,263.8 196.1,263.2 195.6,262.6 C195.0,262.0 194.5,261.4 194.0,260.9 C193.4,260.4 192.9,259.9 192.3,259.5 C191.8,259.1 191.3,258.8 190.8,258.5 C190.3,258.2 189.8,257.9 189.3,257.8 C188.8,257.6 188.3,257.5 187.9,257.4 C187.5,257.4 187.0,257.4 186.6,257.4 C186.2,257.5 185.9,257.6 185.5,257.8 C185.2,258.0 184.9,258.2 184.6,258.5 C184.3,258.8 184.1,259.2 183.8,259.5 C183.6,259.9 183.4,260.4 183.3,260.9 C183.1,261.4 183.0,262.0 182.9,262.5 C182.8,263.1 182.8,263.8 182.8,264.4 C182.8,265.1 182.8,265.8 182.8,266.6 C182.9,267.3 183.0,268.1 183.1,268.9 C183.2,269.7 183.4,270.5 183.6,271.4 C183.8,272.2 184.0,273.1 184.2,273.9 C184.5,274.8 184.8,275.7 185.1,276.6 C185.4,277.4 185.7,278.3 186.1,279.2 C186.4,280.1 186.8,281.0 187.2,281.9 C187.7,282.7 188.1,283.6 188.5,284.4 C189.0,285.3 189.5,286.1 189.9,286.9 C190.4,287.7 190.9,288.5 191.4,289.2 C191.9,290.0 192.5,290.7 193.0,291.4 C193.5,292.0 194.0,292.7 194.6,293.3 C195.1,293.9 195.6,294.4 196.2,294.9 C196.7,295.5 197.2,295.9 197.8,296.3 C198.3,296.7 198.8,297.1 199.3,297.4 C199.8,297.7 200.3,298.0 200.8,298.2 C201.3,298.4 201.7,298.5 202.2,298.6 C202.6,298.7 203.0,298.7 203.4,298.7 C203.8,298.6 204.2,298.5 204.6,298.4 C204.9,298.2 205.3,298.0 205.5,297.7 C205.8,297.5 206.1,297.2 206.3,296.8 C206.6,296.4 206.8,296.0 207.0,295.5 C207.1,295.0 207.3,294.5 207.4,293.9 C207.5,293.3 207.5,292.7 207.6,292.0 C207.6,291.4 207.6,290.6 207.5,289.9 C207.5,289.2 207.4,288.4 207.3,287.6 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M425.4,263.3 L423.6,260.1 L404.8,254.0 L406.4,257.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#0e0e0e"
    },
    d: "M198.0,280.4 L197.9,279.8 L197.7,279.2 L197.5,278.5 L197.3,277.9 L197.0,277.2 L196.7,276.6 L196.3,276.0 L196.0,275.4 L195.6,274.9 L195.2,274.4 L194.8,274.0 L194.4,273.7 L194.0,273.4 L193.7,273.3 L193.4,273.2 L193.1,273.2 L192.8,273.3 L192.6,273.4 L192.4,273.7 L192.2,274.0 L192.1,274.4 L192.1,274.8 L192.1,275.3 L192.2,275.9 L192.3,276.5 L192.4,277.1 L192.6,277.7 L192.9,278.4 L193.2,279.0 L193.5,279.7 L193.8,280.3 L194.2,280.8 L194.6,281.3 L195.0,281.8 L195.3,282.2 L195.7,282.5 L196.1,282.8 L196.5,283.0 L196.8,283.1 L197.1,283.1 L197.4,283.0 L197.6,282.8 L197.8,282.6 L197.9,282.3 L198.0,281.9 L198.1,281.4 L198.0,280.9 Z"
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M198.0,280.4 C198.0,280.2 197.9,280.0 197.9,279.8 C197.8,279.6 197.8,279.4 197.7,279.2 C197.7,278.9 197.6,278.7 197.5,278.5 C197.4,278.3 197.4,278.1 197.3,277.9 C197.2,277.6 197.1,277.4 197.0,277.2 C196.9,277.0 196.8,276.8 196.7,276.6 C196.6,276.4 196.4,276.2 196.3,276.0 C196.2,275.8 196.1,275.6 196.0,275.4 C195.8,275.2 195.7,275.1 195.6,274.9 C195.5,274.7 195.3,274.6 195.2,274.4 C195.1,274.3 194.9,274.2 194.8,274.0 C194.7,273.9 194.5,273.8 194.4,273.7 C194.3,273.6 194.2,273.5 194.0,273.4 C193.9,273.4 193.8,273.3 193.7,273.3 C193.6,273.2 193.5,273.2 193.4,273.2 C193.3,273.2 193.2,273.2 193.1,273.2 C193.0,273.2 192.9,273.2 192.8,273.3 C192.7,273.3 192.6,273.4 192.6,273.4 C192.5,273.5 192.4,273.6 192.4,273.7 C192.3,273.8 192.3,273.9 192.2,274.0 C192.2,274.1 192.2,274.2 192.1,274.4 C192.1,274.5 192.1,274.7 192.1,274.8 C192.1,275.0 192.1,275.2 192.1,275.3 C192.1,275.5 192.1,275.7 192.2,275.9 C192.2,276.1 192.2,276.3 192.3,276.5 C192.3,276.7 192.4,276.9 192.4,277.1 C192.5,277.3 192.6,277.5 192.6,277.7 C192.7,278.0 192.8,278.2 192.9,278.4 C193.0,278.6 193.1,278.8 193.2,279.0 C193.3,279.2 193.4,279.5 193.5,279.7 C193.6,279.9 193.7,280.1 193.8,280.3 C193.9,280.5 194.1,280.6 194.2,280.8 C194.3,281.0 194.4,281.2 194.6,281.3 C194.7,281.5 194.8,281.7 195.0,281.8 C195.1,281.9 195.2,282.1 195.3,282.2 C195.5,282.3 195.6,282.4 195.7,282.5 C195.8,282.6 196.0,282.7 196.1,282.8 C196.2,282.9 196.3,282.9 196.5,283.0 C196.6,283.0 196.7,283.0 196.8,283.1 C196.9,283.1 197.0,283.1 197.1,283.1 C197.2,283.1 197.3,283.0 197.4,283.0 C197.4,283.0 197.5,282.9 197.6,282.8 C197.7,282.8 197.7,282.7 197.8,282.6 C197.8,282.5 197.9,282.4 197.9,282.3 C198.0,282.2 198.0,282.0 198.0,281.9 C198.0,281.8 198.0,281.6 198.1,281.4 C198.1,281.3 198.1,281.1 198.0,280.9 C198.0,280.8 198.0,280.6 198.0,280.4 Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M207.3,287.6 L198.5,280.8"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M201.8,271.6 L196.9,276.3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M192.3,259.5 L194.3,273.0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M184.6,258.5 L192.1,272.6"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M183.1,268.9 L191.7,275.5"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M188.5,284.4 L193.2,279.9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M197.8,296.3 L195.8,283.3"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M205.5,297.7 L198.0,283.6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M173.1,253.7 L173.2,249.9 L173.5,246.1 L174.2,242.7 L175.2,240.0 L176.7,237.8 L178.6,236.3 L219.3,219.5 L221.6,218.6 L224.2,218.4 L227.0,219.0 L230.1,220.2 L233.3,222.2 L236.6,224.8 L239.2,227.3 L242.3,230.2 L245.2,233.6 L248.2,237.4 L250.9,241.7 L253.5,246.2 L255.9,250.9 L257.9,255.8 L259.7,260.7 L261.1,265.5 L262.2,270.2 L262.8,274.7 L263.1,278.8 L263.2,282.3 L263.0,286.5 L262.5,290.2 L261.4,293.3 L260.0,295.9 L258.3,297.8 L256.1,299.0 L216.6,317.4 L214.3,317.8 L211.7,317.6 L208.9,316.7 L206.0,315.2 L202.9,313.0 L199.9,310.6 L197.0,308.1 L194.2,305.1 L191.3,301.7 L188.6,297.9 L185.9,293.7 L183.4,289.3 L181.2,284.8 L179.1,280.1 L177.3,275.3 L175.8,270.6 L174.6,266.0 L173.7,261.6 L173.2,257.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M335.6,231.8 L332.4,233.2 L323.8,230.3 L326.8,229.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M338.6,250.5 L323.2,257.9 L313.8,249.9 L326.6,243.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M453.0,306.9 L456.4,302.3 L442.7,295.6 L439.5,300.1 Z"
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M338.6,250.5 L326.6,243.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M398.1,252.3 L392.6,253.5 L375.5,247.0 L380.3,246.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M351.2,240.4 L350.8,237.3 L341.4,234.1 L341.7,236.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M456.4,302.3 L458.4,297.1 L444.6,290.5 L442.7,295.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M448.1,311.6 L453.0,306.9 L439.5,300.1 L434.8,304.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M319.5,310.2 L323.2,310.4 L315.4,299.2 L312.2,298.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M332.4,233.2 L329.1,234.8 L320.8,231.8 L323.8,230.3 Z"
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M332.4,233.2 L323.8,230.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M368.5,249.4 L350.9,257.3 L338.6,250.5 L353.7,243.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M350.8,237.3 L350.3,235.7 L340.8,232.7 L341.4,234.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M323.9,242.0 L323.9,244.9 L316.1,240.6 L316.1,238.1 Z"
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M353.7,243.8 L338.6,250.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M423.6,260.1 L420.6,258.7 L402.1,252.5 L404.8,254.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M445.3,279.8 L444.7,269.6 L425.4,263.3 L426.0,273.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M329.1,234.8 L327.3,236.0 L319.2,232.8 L320.8,231.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M324.2,240.2 L323.9,242.0 L316.1,238.1 L316.4,236.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M441.4,316.6 L448.1,311.6 L434.8,304.6 L428.3,309.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M350.3,235.7 L349.4,234.7 L340.0,231.9 L340.8,232.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M327.3,236.0 L325.9,237.2 L317.9,234.0 L319.2,232.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M324.9,238.6 L324.2,240.2 L316.4,236.6 L317.0,235.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M325.9,237.2 L324.9,238.6 L317.0,235.2 L317.9,234.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M278.1,341.3 L262.3,329.4 L327.7,297.8 L343.6,309.0 Z"
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M325.9,237.2 L317.9,234.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M306.9,276.0 L307.2,285.4 L300.8,274.8 L300.4,265.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M316.8,308.8 L319.5,310.2 L312.2,298.9 L309.9,297.4 Z"
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M307.2,285.4 L300.8,274.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M458.4,297.1 L459.1,286.2 L445.3,279.8 L444.6,290.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1c1c",
      stroke: "#1d1c1c",
      strokeWidth: 0.8
    },
    d: "M349.4,234.7 L348.2,234.2 L338.9,231.4 L340.0,231.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M392.6,253.5 L384.8,256.4 L368.5,249.4 L375.5,247.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M323.2,257.9 L317.1,261.4 L308.7,252.9 L313.8,249.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M348.2,234.2 L346.6,234.1 L337.5,231.4 L338.9,231.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M420.6,258.7 L416.2,258.7 L398.1,252.3 L402.1,252.5 Z"
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M338.9,231.4 L337.5,231.4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M348.2,234.2 L338.9,231.4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M402.1,252.5 L398.1,252.3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M420.6,258.7 L402.1,252.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M338.5,320.8 L346.6,317.6 L335.4,306.6 L328.3,309.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M346.6,234.1 L344.6,234.6 L335.6,231.8 L337.5,231.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M315.0,305.7 L316.8,308.8 L309.9,297.4 L308.3,294.4 Z"
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M337.5,231.4 L335.6,231.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M317.1,261.4 L312.8,264.7 L305.2,255.8 L308.7,252.9 Z"
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M308.3,294.4 L309.9,297.4"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M316.8,308.8 L309.9,297.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M307.9,271.7 L306.9,276.0 L300.4,265.9 L301.2,262.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M431.6,322.6 L441.4,316.6 L428.3,309.4 L418.9,315.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M444.7,269.6 L442.8,266.3 L423.6,260.1 L425.4,263.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M493.2,312.5 L475.5,301.2 L416.0,332.6 L433.8,344.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M394.7,327.9 L418.9,315.1 L402.3,306.4 L380.5,317.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M466.7,313.9 L470.2,309.1 L456.4,302.3 L453.0,306.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M312.8,264.7 L309.8,268.1 L302.8,258.7 L305.2,255.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M309.8,268.1 L307.9,271.7 L301.2,262.0 L302.8,258.7 Z"
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M309.8,268.1 L302.8,258.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M360.8,243.9 L360.5,240.5 L350.8,237.3 L351.2,240.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M470.2,309.1 L472.3,303.8 L458.4,297.1 L456.4,302.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M344.6,234.6 L341.0,236.0 L332.4,233.2 L335.6,231.8 Z"
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M335.6,231.8 L332.4,233.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M461.7,318.7 L466.7,313.9 L453.0,306.9 L448.1,311.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M358.0,329.0 L380.5,317.8 L366.6,307.9 L346.6,317.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M416.2,258.7 L410.1,260.2 L392.6,253.5 L398.1,252.3 Z"
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M398.1,252.3 L392.6,253.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M360.5,240.5 L359.9,238.7 L350.3,235.7 L350.8,237.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M332.7,322.3 L338.5,320.8 L328.3,309.3 L323.2,310.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M341.0,236.0 L337.5,237.8 L329.1,234.8 L332.4,233.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M459.1,286.2 L458.6,275.8 L444.7,269.6 L445.3,279.8 Z"
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M332.4,233.2 L329.1,234.8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M341.0,236.0 L332.4,233.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M331.8,245.9 L331.8,249.2 L323.9,244.9 L323.9,242.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M442.8,266.3 L439.5,265.0 L420.6,258.7 L423.6,260.1 Z"
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M323.9,242.0 L323.9,244.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M350.9,257.3 L332.8,266.0 L323.2,257.9 L338.6,250.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M454.7,323.9 L461.7,318.7 L448.1,311.6 L441.4,316.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M313.8,296.3 L315.0,305.7 L308.3,294.4 L307.2,285.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M359.9,238.7 L358.9,237.6 L349.4,234.7 L350.3,235.7 Z"
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M338.6,250.5 L323.2,257.9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M350.9,257.3 L338.6,250.5"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M307.2,285.4 L308.3,294.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M337.5,237.8 L335.5,239.2 L327.3,236.0 L329.1,234.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M332.2,243.9 L331.8,245.9 L323.9,242.0 L324.2,240.2 Z"
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M329.1,234.8 L327.3,236.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M472.3,303.8 L473.2,292.7 L459.1,286.2 L458.4,297.1 Z"
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M324.2,240.2 L323.9,242.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M384.8,256.4 L364.7,265.6 L350.9,257.3 L368.5,249.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M335.5,239.2 L334.0,240.6 L325.9,237.2 L327.3,236.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M332.9,242.1 L332.2,243.9 L324.2,240.2 L324.9,238.6 Z"
  }), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M327.3,236.0 L325.9,237.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M334.0,240.6 L332.9,242.1 L324.9,238.6 L325.9,237.2 Z"
  }), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M324.9,238.6 L324.2,240.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M358.9,237.6 L357.6,237.0 L348.2,234.2 L349.4,234.7 Z"
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M325.9,237.2 L324.9,238.6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M334.0,240.6 L325.9,237.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M328.4,322.4 L332.7,322.3 L323.2,310.4 L319.5,310.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M357.6,237.0 L355.9,236.9 L346.6,234.1 L348.2,234.2 Z"
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M357.6,237.0 L348.2,234.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M410.1,260.2 L401.4,263.6 L384.8,256.4 L392.6,253.5 Z"
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M392.6,253.5 L384.8,256.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M439.5,265.0 L434.7,265.2 L416.2,258.7 L420.6,258.7 Z"
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M439.5,265.0 L420.6,258.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M355.9,236.9 L353.8,237.4 L344.6,234.6 L346.6,234.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M444.6,330.2 L454.7,323.9 L441.4,316.6 L431.6,322.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M458.6,275.8 L456.7,272.5 L442.8,266.3 L444.7,269.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M480.7,321.0 L484.3,316.1 L470.2,309.1 L466.7,313.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M484.3,316.1 L486.5,310.6 L472.3,303.8 L470.2,309.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M372.2,249.1 L371.8,245.3 L360.5,240.5 L360.8,243.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M294.3,353.5 L278.1,341.3 L343.6,309.0 L359.9,320.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M406.5,336.1 L431.6,322.6 L418.9,315.1 L394.7,327.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M475.5,326.0 L480.7,321.0 L466.7,313.9 L461.7,318.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M325.4,321.1 L328.4,322.4 L319.5,310.2 L316.8,308.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M313.5,286.2 L313.8,296.3 L307.2,285.4 L306.9,276.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M353.8,237.4 L349.9,239.0 L341.0,236.0 L344.6,234.6 Z"
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M306.9,276.0 L307.2,285.4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M313.8,296.3 L307.2,285.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M332.8,266.0 L325.7,270.2 L317.1,261.4 L323.2,257.9 Z"
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M323.2,257.9 L317.1,261.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M348.9,332.7 L358.0,329.0 L346.6,317.6 L338.5,320.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M371.8,245.3 L371.2,243.4 L359.9,238.7 L360.5,240.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M473.2,292.7 L472.8,282.1 L458.6,275.8 L459.1,286.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M434.7,265.2 L428.0,267.0 L410.1,260.2 L416.2,258.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M349.9,239.0 L346.0,240.9 L337.5,237.8 L341.0,236.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M456.7,272.5 L453.3,271.2 L439.5,265.0 L442.8,266.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M468.2,331.4 L475.5,326.0 L461.7,318.7 L454.7,323.9 Z"
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M349.9,239.0 L341.0,236.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M339.9,249.9 L339.9,253.6 L331.8,249.2 L331.8,245.9 Z"
  }), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M442.8,266.3 L439.5,265.0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M456.7,272.5 L442.8,266.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M325.7,270.2 L320.6,273.9 L312.8,264.7 L317.1,261.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M371.2,243.4 L370.2,242.2 L358.9,237.6 L359.9,238.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M323.4,318.0 L325.4,321.1 L316.8,308.8 L315.0,305.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M486.5,310.6 L487.6,299.3 L473.2,292.7 L472.3,303.8 Z"
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M317.1,261.4 L312.8,264.7"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M325.4,321.1 L316.8,308.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M314.7,281.6 L313.5,286.2 L306.9,276.0 L307.9,271.7 Z"
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M307.9,271.7 L306.9,276.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M346.0,240.9 L343.9,242.4 L335.5,239.2 L337.5,237.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M510.3,324.7 L493.2,312.5 L433.8,344.7 L451.9,357.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M369.7,340.6 L394.7,327.9 L380.5,317.8 L358.0,329.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M340.3,247.7 L339.9,249.9 L331.8,245.9 L332.2,243.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M320.6,273.9 L317.1,277.7 L309.8,268.1 L312.8,264.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M343.9,242.4 L342.3,244.0 L334.0,240.6 L335.5,239.2 Z"
  }), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M312.8,264.7 L309.8,268.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M317.1,277.7 L314.7,281.6 L307.9,271.7 L309.8,268.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M341.1,245.7 L340.3,247.7 L332.2,243.9 L332.9,242.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M370.2,242.2 L368.8,241.6 L357.6,237.0 L358.9,237.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M342.3,244.0 L341.1,245.7 L332.9,242.1 L334.0,240.6 Z"
  }), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M309.8,268.1 L307.9,271.7"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M317.1,277.7 L309.8,268.1"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M342.3,244.0 L334.0,240.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M368.8,241.6 L367.0,241.5 L355.9,236.9 L357.6,237.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M342.4,334.6 L348.9,332.7 L338.5,320.8 L332.7,322.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M364.7,265.6 L344.2,275.7 L332.8,266.0 L350.9,257.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M401.4,263.6 L378.9,274.2 L364.7,265.6 L384.8,256.4 Z"
  }), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M357.6,237.0 L355.9,236.9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M368.8,241.6 L357.6,237.0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M364.7,265.6 L350.9,257.3"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M384.8,256.4 L364.7,265.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M453.3,271.2 L448.3,271.5 L434.7,265.2 L439.5,265.0 Z"
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M439.5,265.0 L434.7,265.2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M453.3,271.2 L439.5,265.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M472.8,282.1 L470.8,278.8 L456.7,272.5 L458.6,275.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M494.9,328.2 L498.7,323.1 L484.3,316.1 L480.7,321.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M457.7,338.0 L468.2,331.4 L454.7,323.9 L444.6,330.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M428.0,267.0 L418.3,270.9 L401.4,263.6 L410.1,260.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M498.7,323.1 L501.0,317.5 L486.5,310.6 L484.3,316.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M367.0,241.5 L364.6,242.1 L353.8,237.4 L355.9,236.9 Z"
  }), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M355.9,236.9 L353.8,237.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M322.1,308.2 L323.4,318.0 L315.0,305.7 L313.8,296.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M489.5,333.3 L494.9,328.2 L480.7,321.0 L475.5,326.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M383.7,254.4 L383.4,250.3 L371.8,245.3 L372.2,249.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M418.5,344.4 L444.6,330.2 L431.6,322.6 L406.5,336.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M364.6,242.1 L360.5,243.8 L349.9,239.0 L353.8,237.4 Z"
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M353.8,237.4 L349.9,239.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M487.6,299.3 L487.2,288.5 L472.8,282.1 L473.2,292.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M337.6,334.9 L342.4,334.6 L332.7,322.3 L328.4,322.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M383.4,250.3 L382.7,248.3 L371.2,243.4 L371.8,245.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M481.9,339.0 L489.5,333.3 L475.5,326.0 L468.2,331.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1d1d",
      stroke: "#1e1d1d",
      strokeWidth: 0.8
    },
    d: "M470.8,278.8 L467.4,277.5 L453.3,271.2 L456.7,272.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M448.3,271.5 L441.4,273.4 L428.0,267.0 L434.7,265.2 Z"
  }), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M470.8,278.8 L456.7,272.5"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M434.7,265.2 L428.0,267.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M501.0,317.5 L502.1,306.0 L487.6,299.3 L486.5,310.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M360.5,243.8 L356.3,245.9 L346.0,240.9 L349.9,239.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M349.6,255.7 L349.6,259.6 L339.9,253.6 L339.9,249.9 Z"
  }), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M349.9,239.0 L346.0,240.9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M360.5,243.8 L349.9,239.0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M339.9,249.9 L339.9,253.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M382.7,248.3 L381.6,247.0 L370.2,242.2 L371.2,243.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M311.0,366.1 L294.3,353.5 L359.9,320.5 L376.6,332.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M356.3,245.9 L354.0,247.5 L343.9,242.4 L346.0,240.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M344.2,275.7 L336.0,280.4 L325.7,270.2 L332.8,266.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M350.1,253.2 L349.6,255.7 L339.9,249.9 L340.3,247.7 Z"
  }), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M346.0,240.9 L343.9,242.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M334.2,333.7 L337.6,334.9 L328.4,322.4 L325.4,321.1 Z"
  }), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M340.3,247.7 L339.9,249.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M359.6,344.9 L369.7,340.6 L358.0,329.0 L348.9,332.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M381.6,247.0 L380.2,246.3 L368.8,241.6 L370.2,242.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M322.0,297.8 L322.1,308.2 L313.8,296.3 L313.5,286.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M354.0,247.5 L352.3,249.2 L342.3,244.0 L343.9,242.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M351.0,251.1 L350.1,253.2 L340.3,247.7 L341.1,245.7 Z"
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M322.1,308.2 L313.8,296.3"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M343.9,242.4 L342.3,244.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M352.3,249.2 L351.0,251.1 L341.1,245.7 L342.3,244.0 Z"
  }), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M341.1,245.7 L340.3,247.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M380.6,349.5 L406.5,336.1 L394.7,327.9 L369.7,340.6 Z"
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M342.3,244.0 L341.1,245.7"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M352.3,249.2 L342.3,244.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M467.4,277.5 L462.2,277.9 L448.3,271.5 L453.3,271.2 Z"
  }), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M467.4,277.5 L453.3,271.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M487.2,288.5 L485.2,285.2 L470.8,278.8 L472.8,282.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M380.2,246.3 L378.3,246.2 L367.0,241.5 L368.8,241.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M471.1,345.8 L481.9,339.0 L468.2,331.4 L457.7,338.0 Z"
  }), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M380.2,246.3 L368.8,241.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M336.0,280.4 L330.2,284.6 L320.6,273.9 L325.7,270.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M441.4,273.4 L431.4,277.6 L418.3,270.9 L428.0,267.0 Z"
  }), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M428.0,267.0 L418.3,270.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1b1b",
      stroke: "#1c1b1b",
      strokeWidth: 0.8
    },
    d: "M332.1,330.6 L334.2,333.7 L325.4,321.1 L323.4,318.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M378.3,246.2 L375.7,246.8 L364.6,242.1 L367.0,241.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M509.6,338.8 L513.4,333.6 L498.7,323.1 L494.9,328.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M418.3,270.9 L393.4,282.9 L378.9,274.2 L401.4,263.6 Z"
  }), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M323.4,318.0 L325.4,321.1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M334.2,333.7 L325.4,321.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M430.8,352.9 L457.7,338.0 L444.6,330.2 L418.5,344.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M395.5,259.7 L395.2,255.4 L383.4,250.3 L383.7,254.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M527.9,337.3 L510.3,324.7 L451.9,357.1 L470.6,369.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M323.4,292.9 L322.0,297.8 L313.5,286.2 L314.7,281.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M513.4,333.6 L515.7,327.9 L501.0,317.5 L498.7,323.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M330.2,284.6 L326.1,288.7 L317.1,277.7 L320.6,273.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M504.2,344.0 L509.6,338.8 L494.9,328.2 L489.5,333.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M502.1,306.0 L501.8,295.0 L487.2,288.5 L487.6,299.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M326.1,288.7 L323.4,292.9 L314.7,281.6 L317.1,277.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M378.9,274.2 L355.8,285.6 L344.2,275.7 L364.7,265.6 Z"
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M326.1,288.7 L317.1,277.7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M364.7,265.6 L344.2,275.7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M378.9,274.2 L364.7,265.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M352.4,347.2 L359.6,344.9 L348.9,332.7 L342.4,334.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M375.7,246.8 L371.3,248.7 L360.5,243.8 L364.6,242.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1d",
      stroke: "#1e1e1d",
      strokeWidth: 0.8
    },
    d: "M485.2,285.2 L481.7,283.9 L467.4,277.5 L470.8,278.8 Z"
  }), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M470.8,278.8 L467.4,277.5"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M485.2,285.2 L470.8,278.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M462.2,277.9 L455.1,280.0 L441.4,273.4 L448.3,271.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M395.2,255.4 L394.5,253.2 L382.7,248.3 L383.4,250.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M496.9,349.7 L504.2,344.0 L489.5,333.3 L481.9,339.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M394.5,253.2 L393.3,251.8 L381.6,247.0 L382.7,248.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M515.7,327.9 L516.9,316.1 L502.1,306.0 L501.0,317.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M371.3,248.7 L366.8,251.0 L356.3,245.9 L360.5,243.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M359.6,261.5 L359.6,265.8 L349.6,259.6 L349.6,255.7 Z"
  }), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M371.3,248.7 L360.5,243.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M330.7,320.6 L332.1,330.6 L323.4,318.0 L322.1,308.2 Z"
  }), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M322.1,308.2 L323.4,318.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M393.3,251.8 L391.8,251.1 L380.2,246.3 L381.6,247.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M366.8,251.0 L364.3,252.7 L354.0,247.5 L356.3,245.9 Z"
  }), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M557.3,478.2 L502.1,469.5 L447.8,461.0 L426.2,446.5 L405.2,432.4 L384.8,418.6 L365.0,405.3 L345.6,392.3 L328.1,379.0 L311.0,366.1 L294.3,353.5 L278.1,341.3 L262.3,329.4 L246.7,311.2 L231.7,293.7 L234.9,284.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M360.1,258.9 L359.6,261.5 L349.6,255.7 L350.1,253.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M347.1,347.8 L352.4,347.2 L342.4,334.6 L337.6,334.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M481.7,283.9 L476.4,284.4 L462.2,277.9 L467.4,277.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M501.8,295.0 L499.8,291.7 L485.2,285.2 L487.2,288.5 Z"
  }), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M467.4,277.5 L462.2,277.9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M481.7,283.9 L467.4,277.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M391.7,358.5 L418.5,344.4 L406.5,336.1 L380.6,349.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M364.3,252.7 L362.5,254.6 L352.3,249.2 L354.0,247.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M361.1,256.6 L360.1,258.9 L350.1,253.2 L351.0,251.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M362.5,254.6 L361.1,256.6 L351.0,251.1 L352.3,249.2 Z"
  }), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M362.5,254.6 L352.3,249.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M391.8,251.1 L389.7,251.0 L378.3,246.2 L380.2,246.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M370.1,354.1 L380.6,349.5 L369.7,340.6 L359.6,344.9 Z"
  }), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M380.2,246.3 L378.3,246.2"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M391.8,251.1 L380.2,246.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M455.1,280.0 L444.7,284.4 L431.4,277.6 L441.4,273.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M486.2,356.6 L496.9,349.7 L481.9,339.0 L471.1,345.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M328.1,379.0 L311.0,366.1 L376.6,332.3 L393.7,344.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M443.3,361.6 L471.1,345.8 L457.7,338.0 L430.8,352.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M407.5,265.2 L407.2,260.6 L395.2,255.4 L395.5,259.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M389.7,251.0 L387.1,251.7 L375.7,246.8 L378.3,246.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M355.8,285.6 L346.6,291.0 L336.0,280.4 L344.2,275.7 Z"
  }), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M378.3,246.2 L375.7,246.8"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M344.2,275.7 L336.0,280.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M431.4,277.6 L405.6,290.2 L393.4,282.9 L418.3,270.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M343.3,346.7 L347.1,347.8 L337.6,334.9 L334.2,333.7 Z"
  }), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M418.3,270.9 L393.4,282.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1d",
      stroke: "#1e1e1d",
      strokeWidth: 0.8
    },
    d: "M499.8,291.7 L496.2,290.5 L481.7,283.9 L485.2,285.2 Z"
  }), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M499.8,291.7 L485.2,285.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M330.7,309.7 L330.7,320.6 L322.1,308.2 L322.0,297.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M516.9,316.1 L516.8,304.8 L501.8,295.0 L502.1,306.0 Z"
  }), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M322.0,297.8 L322.1,308.2"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M330.7,320.6 L322.1,308.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M476.4,284.4 L469.0,286.7 L455.1,280.0 L462.2,277.9 Z"
  }), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M462.2,277.9 L455.1,280.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M387.1,251.7 L382.3,253.7 L371.3,248.7 L375.7,246.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M407.2,260.6 L406.4,258.2 L394.5,253.2 L395.2,255.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M524.7,349.6 L528.4,344.4 L513.4,333.6 L509.6,338.8 Z"
  }), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M375.7,246.8 L371.3,248.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M528.4,344.4 L530.7,338.6 L515.7,327.9 L513.4,333.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M519.4,354.9 L524.7,349.6 L509.6,338.8 L504.2,344.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M346.6,291.0 L340.1,295.6 L330.2,284.6 L336.0,280.4 Z"
  }), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M336.0,280.4 L330.2,284.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M362.6,356.6 L370.1,354.1 L359.6,344.9 L352.4,347.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M406.4,258.2 L405.2,256.8 L393.3,251.8 L394.5,253.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M393.4,282.9 L367.8,295.8 L355.8,285.6 L378.9,274.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M340.9,343.6 L343.3,346.7 L334.2,333.7 L332.1,330.6 Z"
  }), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M393.4,282.9 L378.9,274.2"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M332.1,330.6 L334.2,333.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M546.0,350.2 L527.9,337.3 L470.6,369.9 L489.8,383.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M382.3,253.7 L377.5,256.2 L366.8,251.0 L371.3,248.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M369.8,267.5 L369.8,272.1 L359.6,265.8 L359.6,261.5 Z"
  }), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M371.3,248.7 L366.8,251.0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M382.3,253.7 L371.3,248.7"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M359.6,261.5 L359.6,265.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M332.3,304.6 L330.7,309.7 L322.0,297.8 L323.4,292.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M340.1,295.6 L335.4,300.1 L326.1,288.7 L330.2,284.6 Z"
  }), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M323.4,292.9 L322.0,297.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M496.2,290.5 L490.8,291.0 L476.4,284.4 L481.7,283.9 Z"
  }), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M330.2,284.6 L326.1,288.7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M496.2,290.5 L481.7,283.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M405.2,256.8 L403.6,256.0 L391.8,251.1 L393.3,251.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M512.1,360.7 L519.4,354.9 L504.2,344.0 L496.9,349.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M335.4,300.1 L332.3,304.6 L323.4,292.9 L326.1,288.7 Z"
  }), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M326.1,288.7 L323.4,292.9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M335.4,300.1 L326.1,288.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M377.5,256.2 L374.9,258.1 L364.3,252.7 L366.8,251.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M403.0,367.8 L430.8,352.9 L418.5,344.4 L391.7,358.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M370.3,264.7 L369.8,267.5 L359.6,261.5 L360.1,258.9 Z"
  }), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M366.8,251.0 L364.3,252.7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M360.1,258.9 L359.6,261.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M530.7,338.6 L532.1,326.4 L516.9,316.1 L515.7,327.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M374.9,258.1 L372.9,260.1 L362.5,254.6 L364.3,252.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M371.4,262.2 L370.3,264.7 L360.1,258.9 L361.1,256.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M516.8,304.8 L514.8,301.3 L499.8,291.7 L501.8,295.0 Z"
  }), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M364.3,252.7 L362.5,254.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M403.6,256.0 L401.4,255.9 L389.7,251.0 L391.8,251.1 Z"
  }), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M361.1,256.6 L360.1,258.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M372.9,260.1 L371.4,262.2 L361.1,256.6 L362.5,254.6 Z"
  }), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M403.6,256.0 L391.8,251.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M469.0,286.7 L458.3,291.3 L444.7,284.4 L455.1,280.0 Z"
  }), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M362.5,254.6 L361.1,256.6"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M372.9,260.1 L362.5,254.6"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M455.1,280.0 L444.7,284.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M380.8,363.5 L391.7,358.5 L380.6,349.5 L370.1,354.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M357.1,357.2 L362.6,356.6 L352.4,347.2 L347.1,347.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M419.7,270.7 L419.4,265.8 L407.2,260.6 L407.5,265.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M401.4,255.9 L398.6,256.6 L387.1,251.7 L389.7,251.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M339.6,333.2 L340.9,343.6 L332.1,330.6 L330.7,320.6 Z"
  }), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M340.9,343.6 L332.1,330.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M444.7,284.4 L417.9,297.7 L405.6,290.2 L431.4,277.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M458.9,372.3 L486.2,356.6 L471.1,345.8 L443.3,361.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M490.8,291.0 L483.2,293.5 L469.0,286.7 L476.4,284.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M501.7,367.6 L512.1,360.7 L496.9,349.7 L486.2,356.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M419.4,265.8 L418.6,263.4 L406.4,258.2 L407.2,260.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M514.8,301.3 L511.3,300.0 L496.2,290.5 L499.8,291.7 Z"
  }), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M499.8,291.7 L496.2,290.5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M514.8,301.3 L499.8,291.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M398.6,256.6 L393.5,258.8 L382.3,253.7 L387.1,251.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M353.2,356.2 L357.1,357.2 L347.1,347.8 L343.3,346.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M345.6,392.3 L328.1,379.0 L393.7,344.3 L411.4,356.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M418.6,263.4 L417.4,261.8 L405.2,256.8 L406.4,258.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M367.8,295.8 L357.5,301.8 L346.6,291.0 L355.8,285.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M373.0,366.1 L380.8,363.5 L370.1,354.1 L362.6,356.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M532.1,326.4 L532.1,314.8 L516.8,304.8 L516.9,316.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M540.1,360.7 L543.8,355.4 L528.4,344.4 L524.7,349.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M393.5,258.8 L388.5,261.5 L377.5,256.2 L382.3,253.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M380.2,273.6 L380.1,278.5 L369.8,272.1 L369.8,267.5 Z"
  }), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M393.5,258.8 L382.3,253.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M543.8,355.4 L546.2,349.5 L530.7,338.6 L528.4,344.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M417.4,261.8 L415.6,261.0 L403.6,256.0 L405.2,256.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M534.9,366.1 L540.1,360.7 L524.7,349.6 L519.4,354.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M405.6,290.2 L378.9,303.8 L367.8,295.8 L393.4,282.9 Z"
  }), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M393.4,282.9 L367.8,295.8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M405.6,290.2 L393.4,282.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M339.6,322.0 L339.6,333.2 L330.7,320.6 L330.7,309.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M414.5,377.2 L443.3,361.6 L430.8,352.9 L403.0,367.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M511.3,300.0 L506.0,300.5 L490.8,291.0 L496.2,290.5 Z"
  }), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M339.6,333.2 L330.7,320.6"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M496.2,290.5 L490.8,291.0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M511.3,300.0 L496.2,290.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M350.7,353.1 L353.2,356.2 L343.3,346.7 L340.9,343.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M388.5,261.5 L385.6,263.5 L374.9,258.1 L377.5,256.2 Z"
  }), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M340.9,343.6 L343.3,346.7"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M353.2,356.2 L343.3,346.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M380.8,270.6 L380.2,273.6 L369.8,267.5 L370.3,264.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M483.2,293.5 L472.1,298.3 L458.3,291.3 L469.0,286.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M415.6,261.0 L413.4,260.9 L401.4,255.9 L403.6,256.0 Z"
  }), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M403.6,256.0 L401.4,255.9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M415.6,261.0 L403.6,256.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M357.5,301.8 L350.2,306.9 L340.1,295.6 L346.6,291.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M385.6,263.5 L383.5,265.6 L372.9,260.1 L374.9,258.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M381.9,268.0 L380.8,270.6 L370.3,264.7 L371.4,262.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M527.8,371.9 L534.9,366.1 L519.4,354.9 L512.1,360.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M383.5,265.6 L381.9,268.0 L371.4,262.2 L372.9,260.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M430.7,276.0 L430.4,270.8 L419.4,265.8 L419.7,270.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M391.7,373.0 L403.0,367.8 L391.7,358.5 L380.8,363.5 Z"
  }), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M383.5,265.6 L372.9,260.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M564.7,363.5 L546.0,350.2 L489.8,383.0 L509.6,396.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M367.3,366.9 L373.0,366.1 L362.6,356.6 L357.1,357.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M413.4,260.9 L410.4,261.7 L398.6,256.6 L401.4,255.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M458.3,291.3 L430.6,305.3 L417.9,297.7 L444.7,284.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M546.2,349.5 L547.7,337.0 L532.1,326.4 L530.7,338.6 Z"
  }), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M401.4,255.9 L398.6,256.6"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M444.7,284.4 L417.9,297.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M350.2,306.9 L345.0,311.7 L335.4,300.1 L340.1,295.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M341.5,316.6 L339.6,322.0 L330.7,309.7 L332.3,304.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M532.1,314.8 L530.3,311.2 L514.8,301.3 L516.8,304.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M345.0,311.7 L341.5,316.6 L332.3,304.6 L335.4,300.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M430.4,270.8 L429.7,268.1 L418.6,263.4 L419.4,265.8 Z"
  }), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M345.0,311.7 L335.4,300.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M506.0,300.5 L498.6,302.9 L483.2,293.5 L490.8,291.0 Z"
  }), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M490.8,291.0 L483.2,293.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M474.9,383.4 L501.7,367.6 L486.2,356.6 L458.9,372.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M410.4,261.7 L405.0,264.0 L393.5,258.8 L398.6,256.6 Z"
  }), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M398.6,256.6 L393.5,258.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M349.4,342.6 L350.7,353.1 L340.9,343.6 L339.6,333.2 Z"
  }), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M339.6,333.2 L340.9,343.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M517.5,378.9 L527.8,371.9 L512.1,360.7 L501.7,367.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M429.7,268.1 L428.4,266.4 L417.4,261.8 L418.6,263.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M363.3,365.9 L367.3,366.9 L357.1,357.2 L353.2,356.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M383.6,375.9 L391.7,373.0 L380.8,363.5 L373.0,366.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M530.3,311.2 L526.8,309.8 L511.3,300.0 L514.8,301.3 Z"
  }), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M530.3,311.2 L514.8,301.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M428.4,266.4 L426.7,265.6 L415.6,261.0 L417.4,261.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M405.0,264.0 L399.6,266.9 L388.5,261.5 L393.5,258.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M390.8,279.8 L390.7,285.0 L380.1,278.5 L380.2,273.6 Z"
  }), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M393.5,258.8 L388.5,261.5"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M405.0,264.0 L393.5,258.8"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M380.2,273.6 L380.1,278.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M417.9,297.7 L390.3,312.0 L378.9,303.8 L405.6,290.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M378.9,303.8 L368.2,310.1 L357.5,301.8 L367.8,295.8 Z"
  }), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M417.9,297.7 L405.6,290.2"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M367.8,295.8 L357.5,301.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M430.7,388.0 L458.9,372.3 L443.3,361.6 L414.5,377.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M365.0,405.3 L345.6,392.3 L411.4,356.8 L429.5,369.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M426.7,265.6 L424.4,265.4 L413.4,260.9 L415.6,261.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M547.7,337.0 L547.8,325.1 L532.1,314.8 L532.1,326.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M399.6,266.9 L396.6,269.0 L385.6,263.5 L388.5,261.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M441.9,281.4 L441.7,275.9 L430.4,270.8 L430.7,276.0 Z"
  }), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M426.7,265.6 L415.6,261.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M391.4,276.6 L390.8,279.8 L380.2,273.6 L380.8,270.6 Z"
  }), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M388.5,261.5 L385.6,263.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M360.8,362.8 L363.3,365.9 L353.2,356.2 L350.7,353.1 Z"
  }), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M380.8,270.6 L380.2,273.6"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M363.3,365.9 L353.2,356.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M498.6,302.9 L487.7,307.8 L472.1,298.3 L483.2,293.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M396.6,269.0 L394.3,271.3 L383.5,265.6 L385.6,263.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M392.6,273.8 L391.4,276.6 L380.8,270.6 L381.9,268.0 Z"
  }), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M483.2,293.5 L472.1,298.3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M385.6,263.5 L383.5,265.6"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M381.9,268.0 L380.8,270.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M402.8,382.8 L414.5,377.2 L403.0,367.8 L391.7,373.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M394.3,271.3 L392.6,273.8 L381.9,268.0 L383.5,265.6 Z"
  }), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M383.5,265.6 L381.9,268.0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M394.3,271.3 L383.5,265.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#201f1f",
      stroke: "#201f1f",
      strokeWidth: 0.8
    },
    d: "M515.8,375.2 L517.7,370.6 L543.8,355.4 L540.1,360.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M349.5,331.1 L349.4,342.6 L339.6,333.2 L339.6,322.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M526.8,309.8 L521.7,310.3 L506.0,300.5 L511.3,300.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M424.4,265.4 L421.3,266.2 L410.4,261.7 L413.4,260.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M472.1,298.3 L443.4,313.1 L430.6,305.3 L458.3,291.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M513.2,379.2 L515.8,375.2 L540.1,360.7 L534.9,366.1 Z"
  }), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M540.1,360.7 L543.8,355.4"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M339.6,322.0 L339.6,333.2"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M349.4,342.6 L339.6,333.2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M526.8,309.8 L511.3,300.0"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M534.9,366.1 L540.1,360.7"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M515.8,375.2 L540.1,360.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M377.7,376.8 L383.6,375.9 L373.0,366.1 L367.3,366.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M441.7,275.9 L440.9,273.0 L429.7,268.1 L430.4,270.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M368.2,310.1 L360.6,315.5 L350.2,306.9 L357.5,301.8 Z"
  }), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M357.5,301.8 L350.2,306.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M517.7,370.6 L519.0,364.8 L546.2,349.5 L543.8,355.4 Z"
  }), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M543.8,355.4 L546.2,349.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1e",
      stroke: "#1f1f1e",
      strokeWidth: 0.8
    },
    d: "M509.6,383.1 L513.2,379.2 L534.9,366.1 L527.8,371.9 Z"
  }), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M527.8,371.9 L534.9,366.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M421.3,266.2 L415.9,268.6 L405.0,264.0 L410.4,261.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M440.9,273.0 L439.7,271.2 L428.4,266.4 L429.7,268.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M360.6,315.5 L355.2,320.5 L345.0,311.7 L350.2,306.9 Z"
  }), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M350.2,306.9 L345.0,311.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M351.5,325.6 L349.5,331.1 L339.6,322.0 L341.5,316.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M359.4,352.1 L360.8,362.8 L350.7,353.1 L349.4,342.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M547.8,325.1 L546.1,321.3 L530.3,311.2 L532.1,314.8 Z"
  }), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M341.5,316.6 L339.6,322.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M583.8,377.2 L564.7,363.5 L509.6,396.5 L529.9,410.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M491.3,394.7 L517.5,378.9 L501.7,367.6 L474.9,383.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M355.2,320.5 L351.5,325.6 L341.5,316.6 L345.0,311.7 Z"
  }), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M345.0,311.7 L341.5,316.6"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M355.2,320.5 L345.0,311.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M504.5,387.1 L509.6,383.1 L527.8,371.9 L517.5,378.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M373.6,375.9 L377.7,376.8 L367.3,366.9 L363.3,365.9 Z"
  }), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M517.5,378.9 L527.8,371.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M521.7,310.3 L514.3,312.6 L498.6,302.9 L506.0,300.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M439.7,271.2 L437.9,270.2 L426.7,265.6 L428.4,266.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M394.5,385.8 L402.8,382.8 L391.7,373.0 L383.6,375.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M415.9,268.6 L410.4,271.5 L399.6,266.9 L405.0,264.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M401.4,285.2 L401.2,290.7 L390.7,285.0 L390.8,279.8 Z"
  }), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M415.9,268.6 L405.0,264.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M519.0,364.8 L520.0,351.4 L547.7,337.0 L546.2,349.5 Z"
  }), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M546.2,349.5 L547.7,337.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M430.6,305.3 L401.9,320.4 L390.3,312.0 L417.9,297.7 Z"
  }), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M417.9,297.7 L390.3,312.0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M430.6,305.3 L417.9,297.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M390.3,312.0 L379.1,318.7 L368.2,310.1 L378.9,303.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M453.3,286.9 L453.1,281.0 L441.7,275.9 L441.9,281.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M437.9,270.2 L435.6,270.0 L424.4,265.4 L426.7,265.6 Z"
  }), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M426.7,265.6 L424.4,265.4"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M437.9,270.2 L426.7,265.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M410.4,271.5 L407.3,273.8 L396.6,269.0 L399.6,266.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M402.0,281.8 L401.4,285.2 L390.8,279.8 L391.4,276.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1d",
      stroke: "#1e1e1d",
      strokeWidth: 0.8
    },
    d: "M546.1,321.3 L542.8,319.9 L526.8,309.8 L530.3,311.2 Z"
  }), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M530.3,311.2 L526.8,309.8"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M546.1,321.3 L530.3,311.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M371.0,372.7 L373.6,375.9 L363.3,365.9 L360.8,362.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M407.3,273.8 L405.0,276.2 L394.3,271.3 L396.6,269.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M403.3,278.8 L402.0,281.8 L391.4,276.6 L392.6,273.8 Z"
  }), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M360.8,362.8 L363.3,365.9"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M373.6,375.9 L363.3,365.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M447.2,399.1 L474.9,383.4 L458.9,372.3 L430.7,388.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M405.0,276.2 L403.3,278.8 L392.6,273.8 L394.3,271.3 Z"
  }), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M405.0,276.2 L394.3,271.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M435.6,270.0 L432.5,270.8 L421.3,266.2 L424.4,265.4 Z"
  }), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M424.4,265.4 L421.3,266.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M419.2,393.6 L430.7,388.0 L414.5,377.2 L402.8,382.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M453.1,281.0 L452.4,278.0 L440.9,273.0 L441.7,275.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M359.6,340.4 L359.4,352.1 L349.4,342.6 L349.5,331.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M388.4,386.9 L394.5,385.8 L383.6,375.9 L377.7,376.8 Z"
  }), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M359.4,352.1 L349.4,342.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M487.7,307.8 L459.6,322.6 L443.4,313.1 L472.1,298.3 Z"
  }), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M472.1,298.3 L443.4,313.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M384.8,418.6 L365.0,405.3 L429.5,369.5 L448.1,382.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M514.3,312.6 L503.7,317.5 L487.7,307.8 L498.6,302.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M379.1,318.7 L371.2,324.3 L360.6,315.5 L368.2,310.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M526.5,388.1 L529.1,384.0 L515.8,375.2 L513.2,379.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M432.5,270.8 L426.9,273.3 L415.9,268.6 L421.3,266.2 Z"
  }), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M513.2,379.2 L515.8,375.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M452.4,278.0 L451.1,276.0 L439.7,271.2 L440.9,273.0 Z"
  }), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M421.3,266.2 L415.9,268.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M491.7,395.0 L504.5,387.1 L517.5,378.9 L491.3,394.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M522.9,392.0 L526.5,388.1 L513.2,379.2 L509.6,383.1 Z"
  }), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M504.5,387.1 L517.5,378.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M542.8,319.9 L537.7,320.3 L521.7,310.3 L526.8,309.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M529.1,384.0 L531.1,379.3 L517.7,370.6 L515.8,375.2 Z"
  }), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M509.6,383.1 L513.2,379.2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M526.8,309.8 L521.7,310.3"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M542.8,319.9 L526.8,309.8"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M515.8,375.2 L517.7,370.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M520.0,351.4 L520.4,338.2 L547.8,325.1 L547.7,337.0 Z"
  }), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M547.7,337.0 L547.8,325.1"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M520.0,351.4 L547.7,337.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M371.2,324.3 L365.6,329.5 L355.2,320.5 L360.6,315.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M517.8,396.1 L522.9,392.0 L509.6,383.1 L504.5,387.1 Z"
  }), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M504.5,387.1 L509.6,383.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M369.7,361.8 L371.0,372.7 L360.8,362.8 L359.4,352.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M451.1,276.0 L449.4,275.0 L437.9,270.2 L439.7,271.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M361.8,334.7 L359.6,340.4 L349.5,331.1 L351.5,325.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M531.1,379.3 L532.4,373.5 L519.0,364.8 L517.7,370.6 Z"
  }), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M359.4,352.1 L360.8,362.8"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M517.7,370.6 L519.0,364.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M412.1,290.7 L412.0,296.6 L401.2,290.7 L401.4,285.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M365.6,329.5 L361.8,334.7 L351.5,325.6 L355.2,320.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M384.1,386.0 L388.4,386.9 L377.7,376.8 L373.6,375.9 Z"
  }), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M401.4,285.2 L401.2,290.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M426.9,273.3 L421.4,276.3 L410.4,271.5 L415.9,268.6 Z"
  }), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M365.6,329.5 L355.2,320.5"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M415.9,268.6 L410.4,271.5"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M426.9,273.3 L415.9,268.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M464.9,292.5 L464.8,286.3 L453.1,281.0 L453.3,286.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M411.0,396.6 L419.2,393.6 L402.8,382.8 L394.5,385.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M443.4,313.1 L413.8,329.0 L401.9,320.4 L430.6,305.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M449.4,275.0 L447.0,274.7 L435.6,270.0 L437.9,270.2 Z"
  }), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M443.4,313.1 L430.6,305.3"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M449.4,275.0 L437.9,270.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M412.8,287.1 L412.1,290.7 L401.4,285.2 L402.0,281.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M401.9,320.4 L390.3,327.4 L379.1,318.7 L390.3,312.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M421.4,276.3 L418.3,278.6 L407.3,273.8 L410.4,271.5 Z"
  }), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M402.0,281.8 L401.4,285.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#101010"
    },
    d: "M522.9,358.1 L545.1,345.2 L546.5,336.5 L547.6,320.0 L543.8,318.1 L524.4,329.0 L523.2,335.8 Z"
  }), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M390.3,312.0 L379.1,318.7"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M410.4,271.5 L407.3,273.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M537.7,320.3 L530.6,322.6 L514.3,312.6 L521.7,310.3 Z"
  }), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M522.9,358.1 C526.5,359.6 541.1,348.8 545.1,345.2 C549.0,341.6 546.1,340.7 546.5,336.5 C546.9,332.3 548.1,323.0 547.6,320.0 C547.2,316.9 547.7,316.6 543.8,318.1 C539.9,319.6 527.9,326.0 524.4,329.0 C521.0,331.9 523.4,331.0 523.2,335.8 C522.9,340.7 519.2,356.5 522.9,358.1 Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M521.7,310.3 L514.3,312.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M414.1,284.0 L412.8,287.1 L402.0,281.8 L403.3,278.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M418.3,278.6 L415.9,281.2 L405.0,276.2 L407.3,273.8 Z"
  }), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M403.3,278.8 L402.0,281.8"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M407.3,273.8 L405.0,276.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M415.9,281.2 L414.1,284.0 L403.3,278.8 L405.0,276.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M447.0,274.7 L443.9,275.5 L432.5,270.8 L435.6,270.0 Z"
  }), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M405.0,276.2 L403.3,278.8"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M415.9,281.2 L405.0,276.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M504.9,404.1 L517.8,396.1 L504.5,387.1 L491.7,395.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M464.8,286.3 L464.1,283.1 L452.4,278.0 L453.1,281.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M381.4,382.9 L384.1,386.0 L373.6,375.9 L371.0,372.7 Z"
  }), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M384.1,386.0 L373.6,375.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M520.4,338.2 L519.6,333.5 L546.1,321.3 L547.8,325.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M532.4,373.5 L533.5,359.9 L520.0,351.4 L519.0,364.8 Z"
  }), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M547.8,325.1 L546.1,321.3"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M519.0,364.8 L520.0,351.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M464.1,410.4 L491.3,394.7 L474.9,383.4 L447.2,399.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M436.0,404.6 L447.2,399.1 L430.7,388.0 L419.2,393.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M370.0,349.9 L369.7,361.8 L359.4,352.1 L359.6,340.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M405.1,397.6 L411.0,396.6 L394.5,385.8 L388.4,386.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M464.1,283.1 L462.8,281.0 L451.1,276.0 L452.4,278.0 Z"
  }), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M359.6,340.4 L359.4,352.1"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M369.7,361.8 L359.4,352.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M443.9,275.5 L438.2,278.0 L426.9,273.3 L432.5,270.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M390.3,327.4 L382.1,333.2 L371.2,324.3 L379.1,318.7 Z"
  }), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M379.1,318.7 L371.2,324.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M540.7,400.0 L543.1,396.0 L529.1,384.0 L526.5,388.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M503.7,317.5 L476.1,332.3 L459.6,322.6 L487.7,307.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M537.4,403.7 L540.7,400.0 L526.5,388.1 L522.9,392.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M543.1,396.0 L544.9,391.5 L531.1,379.3 L529.1,384.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M519.6,333.5 L518.0,330.7 L542.8,319.9 L546.1,321.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1b1b",
      stroke: "#1c1b1b",
      strokeWidth: 0.8
    },
    d: "M462.8,281.0 L461.0,279.8 L449.4,275.0 L451.1,276.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M530.6,322.6 L520.1,327.5 L503.7,317.5 L514.3,312.6 Z"
  }), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M514.3,312.6 L503.7,317.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M478.7,402.3 L491.7,395.0 L491.3,394.7 L464.1,410.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M423.1,296.3 L422.9,302.5 L412.0,296.6 L412.1,290.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M594.8,410.1 L583.8,377.2 L529.9,410.4 L561.1,431.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M405.2,432.4 L384.8,418.6 L448.1,382.7 L467.3,396.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M382.1,333.2 L376.2,338.7 L365.6,329.5 L371.2,324.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M438.2,278.0 L432.6,281.1 L421.4,276.3 L426.9,273.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M532.8,407.5 L537.4,403.7 L522.9,392.0 L517.8,396.1 Z"
  }), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M371.2,324.3 L365.6,329.5"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M438.2,278.0 L426.9,273.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M476.8,298.2 L476.7,291.6 L464.8,286.3 L464.9,292.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M380.2,371.8 L381.4,382.9 L371.0,372.7 L369.7,361.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M372.2,344.1 L370.0,349.9 L359.6,340.4 L361.8,334.7 Z"
  }), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M361.8,334.7 L359.6,340.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M544.9,391.5 L546.2,385.8 L532.4,373.5 L531.1,379.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M376.2,338.7 L372.2,344.1 L361.8,334.7 L365.6,329.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M400.9,396.7 L405.1,397.6 L388.4,386.9 L384.1,386.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M461.0,279.8 L458.6,279.5 L447.0,274.7 L449.4,275.0 Z"
  }), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M365.6,329.5 L361.8,334.7"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M376.2,338.7 L365.6,329.5"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M449.4,275.0 L447.0,274.7"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M461.0,279.8 L449.4,275.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M423.9,292.4 L423.1,296.3 L412.1,290.7 L412.8,287.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M491.9,411.6 L504.9,404.1 L491.7,395.0 L478.7,402.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M432.6,281.1 L429.4,283.6 L418.3,278.6 L421.4,276.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M428.0,407.6 L436.0,404.6 L419.2,393.6 L411.0,396.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M518.0,330.7 L515.5,329.4 L537.7,320.3 L542.8,319.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M459.6,322.6 L430.4,338.5 L413.8,329.0 L443.4,313.1 Z"
  }), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M518.0,330.7 L542.8,319.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M425.2,289.2 L423.9,292.4 L412.8,287.1 L414.1,284.0 Z"
  }), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M443.4,313.1 L413.8,329.0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M459.6,322.6 L443.4,313.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M413.8,329.0 L401.7,336.3 L390.3,327.4 L401.9,320.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M533.5,359.9 L534.0,346.5 L520.4,338.2 L520.0,351.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M429.4,283.6 L427.0,286.2 L415.9,281.2 L418.3,278.6 Z"
  }), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M520.0,351.4 L520.4,338.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M427.0,286.2 L425.2,289.2 L414.1,284.0 L415.9,281.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M458.6,279.5 L455.5,280.3 L443.9,275.5 L447.0,274.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M476.7,291.6 L476.0,288.2 L464.1,283.1 L464.8,286.3 Z"
  }), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M427.0,286.2 L415.9,281.2"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M447.0,274.7 L443.9,275.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M521.3,414.9 L532.8,407.5 L517.8,396.1 L504.9,404.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M398.3,393.4 L400.9,396.7 L384.1,386.0 L381.4,382.9 Z"
  }), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M381.4,382.9 L384.1,386.0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M400.9,396.7 L384.1,386.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M546.2,385.8 L547.4,372.5 L533.5,359.9 L532.4,373.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M476.0,288.2 L474.8,286.0 L462.8,281.0 L464.1,283.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M455.5,280.3 L449.8,282.9 L438.2,278.0 L443.9,275.5 Z"
  }), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M443.9,275.5 L438.2,278.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M515.5,329.4 L512.0,329.5 L530.6,322.6 L537.7,320.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M453.1,415.9 L464.1,410.4 L447.2,399.1 L436.0,404.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M380.6,359.7 L380.2,371.8 L369.7,361.8 L370.0,349.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M422.2,408.6 L428.0,407.6 L411.0,396.6 L405.1,397.6 Z"
  }), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M380.2,371.8 L369.7,361.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M486.7,413.7 L491.9,411.6 L478.7,402.3 L473.5,404.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M401.7,336.3 L393.2,342.4 L382.1,333.2 L390.3,327.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M473.5,404.4 L478.7,402.3 L464.1,410.4 L453.1,415.9 Z"
  }), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M473.5,404.4 L478.7,402.3"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M453.1,415.9 L464.1,410.4"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M478.7,402.3 L464.1,410.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M474.8,286.0 L473.0,284.7 L461.0,279.8 L462.8,281.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M434.3,302.0 L434.1,308.6 L422.9,302.5 L423.1,296.3 Z"
  }), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M423.1,296.3 L422.9,302.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M534.0,346.5 L533.3,341.7 L519.6,333.5 L520.4,338.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M488.5,303.1 L488.4,296.2 L476.7,291.6 L476.8,298.2 Z"
  }), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M520.4,338.2 L519.6,333.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M449.8,282.9 L444.0,286.1 L432.6,281.1 L438.2,278.0 Z"
  }), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M438.2,278.0 L432.6,281.1"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M449.8,282.9 L438.2,278.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#201f1f",
      stroke: "#201f1f",
      strokeWidth: 0.8
    },
    d: "M473.0,284.7 L470.5,284.4 L458.6,279.5 L461.0,279.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M520.1,327.5 L493.0,342.3 L476.1,332.3 L503.7,317.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M393.2,342.4 L387.1,348.1 L376.2,338.7 L382.1,333.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M555.3,412.2 L557.5,408.4 L543.1,396.0 L540.7,400.0 Z"
  }), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M473.0,284.7 L461.0,279.8"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M503.7,317.5 L476.1,332.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M552.3,415.6 L555.3,412.2 L540.7,400.0 L537.4,403.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M397.2,382.0 L398.3,393.4 L381.4,382.9 L380.2,371.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M435.1,297.9 L434.3,302.0 L423.1,296.3 L423.9,292.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M483.1,414.1 L486.7,413.7 L473.5,404.4 L469.9,404.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M382.9,353.6 L380.6,359.7 L370.0,349.9 L372.2,344.1 Z"
  }), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M380.2,371.8 L381.4,382.9"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M423.9,292.4 L423.1,296.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M557.5,408.4 L559.1,404.0 L544.9,391.5 L543.1,396.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M512.0,329.5 L506.9,331.3 L520.1,327.5 L530.6,322.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M444.0,286.1 L440.8,288.6 L429.4,283.6 L432.6,281.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M387.1,348.1 L382.9,353.6 L372.2,344.1 L376.2,338.7 Z"
  }), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M530.6,322.6 L520.1,327.5"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M512.0,329.5 L530.6,322.6"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M432.6,281.1 L429.4,283.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M509.6,421.7 L521.3,414.9 L504.9,404.1 L491.9,411.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M418.1,407.6 L422.2,408.6 L405.1,397.6 L400.9,396.7 Z"
  }), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M387.1,348.1 L376.2,338.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M548.2,419.2 L552.3,415.6 L537.4,403.7 L532.8,407.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M436.4,294.5 L435.1,297.9 L423.9,292.4 L425.2,289.2 Z"
  }), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M425.2,289.2 L423.9,292.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M488.4,296.2 L487.7,292.7 L476.0,288.2 L476.7,291.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M440.8,288.6 L438.3,291.4 L427.0,286.2 L429.4,283.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M469.9,404.8 L473.5,404.4 L453.1,415.9 L445.3,418.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M533.3,341.7 L531.7,338.9 L518.0,330.7 L519.6,333.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M438.3,291.4 L436.4,294.5 L425.2,289.2 L427.0,286.2 Z"
  }), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M429.4,283.6 L427.0,286.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M470.5,284.4 L467.3,285.1 L455.5,280.3 L458.6,279.5 Z"
  }), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M469.9,404.8 L473.5,404.4"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M519.6,333.5 L518.0,330.7"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M427.0,286.2 L425.2,289.2"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M438.3,291.4 L427.0,286.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M426.2,446.5 L405.2,432.4 L467.3,396.1 L487.0,410.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M445.3,418.9 L453.1,415.9 L436.0,404.6 L428.0,407.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M559.1,404.0 L560.3,398.4 L546.2,385.8 L544.9,391.5 Z"
  }), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M445.3,418.9 L453.1,415.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M547.4,372.5 L548.0,359.3 L534.0,346.5 L533.5,359.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M430.4,338.5 L418.6,345.9 L401.7,336.3 L413.8,329.0 Z"
  }), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M413.8,329.0 L401.7,336.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M480.5,413.1 L483.1,414.1 L469.9,404.8 L467.3,403.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M476.1,332.3 L447.5,348.3 L430.4,338.5 L459.6,322.6 Z"
  }), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M476.1,332.3 L459.6,322.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M487.7,292.7 L486.5,290.4 L474.8,286.0 L476.0,288.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M467.3,285.1 L461.5,287.8 L449.8,282.9 L455.5,280.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M531.7,338.9 L529.3,337.6 L515.5,329.4 L518.0,330.7 Z"
  }), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M518.0,330.7 L515.5,329.4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M531.7,338.9 L518.0,330.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M415.6,404.2 L418.1,407.6 L400.9,396.7 L398.3,393.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M538.0,425.9 L548.2,419.2 L532.8,407.5 L521.3,414.9 Z"
  }), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M418.1,407.6 L400.9,396.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#201f1f",
      stroke: "#201f1f",
      strokeWidth: 0.8
    },
    d: "M467.3,403.7 L469.9,404.8 L445.3,418.9 L439.6,419.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M514.2,333.4 L514.0,332.6 L500.6,320.9 L500.8,322.7 Z"
  }), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M467.3,403.7 L469.9,404.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M505.0,423.6 L509.6,421.7 L491.9,411.6 L486.7,413.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M486.5,290.4 L484.7,289.1 L473.0,284.7 L474.8,286.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M478.8,410.5 L480.5,413.1 L467.3,403.7 L465.5,401.2 Z"
  }), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M480.5,413.1 L467.3,403.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M445.8,307.8 L445.5,314.7 L434.1,308.6 L434.3,302.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M514.0,332.6 L513.2,332.5 L499.8,320.2 L500.6,320.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M500.8,322.7 L500.6,320.9 L500.4,300.9 L500.4,308.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M500.4,308.0 L500.4,300.9 L488.4,296.2 L488.5,303.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M397.7,369.6 L397.2,382.0 L380.2,371.8 L380.6,359.7 Z"
  }), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M514.0,332.6 L513.2,332.5"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M514.0,332.6 L500.6,320.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M439.6,419.8 L445.3,418.9 L428.0,407.6 L422.2,408.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M559.1,321.7 L572.1,313.3 L570.8,304.6 L557.8,312.9 Z"
  }), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M500.8,322.7 L500.6,320.9"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M500.4,308.0 L500.4,300.9"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M380.6,359.7 L380.2,371.8"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M397.2,382.0 L380.2,371.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M560.3,398.4 L561.6,385.4 L547.4,372.5 L546.2,385.8 Z"
  }), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M439.6,419.8 L445.3,418.9"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M559.1,321.7 L572.1,313.3 L570.8,304.6 L557.8,312.9 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M418.6,345.9 L410.2,352.0 L393.2,342.4 L401.7,336.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M461.5,287.8 L455.7,291.1 L444.0,286.1 L449.8,282.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M513.2,332.5 L511.9,332.9 L498.5,320.1 L499.8,320.2 Z"
  }), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M401.7,336.3 L393.2,342.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M529.3,337.6 L525.8,337.7 L512.0,329.5 L515.5,329.4 Z"
  }), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M461.5,287.8 L449.8,282.9"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M513.2,332.5 L511.9,332.9"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M515.5,329.4 L512.0,329.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M484.7,289.1 L482.2,288.7 L470.5,284.4 L473.0,284.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M548.0,359.3 L547.4,354.5 L533.3,341.7 L534.0,346.5 Z"
  }), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M473.0,284.7 L470.5,284.4"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M484.7,289.1 L473.0,284.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M506.9,331.3 L493.7,338.3 L493.0,342.3 L520.1,327.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M511.9,332.9 L509.9,333.6 L496.7,320.5 L498.5,320.1 Z"
  }), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M520.1,327.5 L493.0,342.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M446.6,303.5 L445.8,307.8 L434.3,302.0 L435.1,297.9 Z"
  }), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M511.9,332.9 L509.9,333.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M500.6,320.9 L499.8,320.2 L499.7,297.3 L500.4,300.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M465.5,401.2 L467.3,403.7 L439.6,419.8 L435.7,418.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M501.7,423.8 L505.0,423.6 L486.7,413.7 L483.1,414.1 Z"
  }), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M465.5,401.2 L467.3,403.7"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M467.3,403.7 L439.6,419.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M477.8,405.8 L478.8,410.5 L465.5,401.2 L464.5,396.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M455.7,291.1 L452.4,293.8 L440.8,288.6 L444.0,286.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M410.2,352.0 L404.2,357.8 L387.1,348.1 L393.2,342.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M500.4,300.9 L499.7,297.3 L487.7,292.7 L488.4,296.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M447.9,299.9 L446.6,303.5 L435.1,297.9 L436.4,294.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M509.9,333.6 L507.4,334.8 L494.2,321.4 L496.7,320.5 Z"
  }), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M393.2,342.4 L387.1,348.1"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M500.4,300.9 L499.7,297.3"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M509.9,333.6 L507.4,334.8"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M509.9,333.6 L496.7,320.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M414.7,392.5 L415.6,404.2 L398.3,393.4 L397.2,382.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M452.4,293.8 L449.9,296.7 L438.3,291.4 L440.8,288.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M400.1,363.4 L397.7,369.6 L380.6,359.7 L382.9,353.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232222",
      stroke: "#232222",
      strokeWidth: 0.8
    },
    d: "M482.2,288.7 L479.0,289.5 L467.3,285.1 L470.5,284.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M449.9,296.7 L447.9,299.9 L436.4,294.5 L438.3,291.4 Z"
  }), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M382.9,353.6 L380.6,359.7"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M470.5,284.4 L467.3,285.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M499.8,320.2 L498.5,320.1 L498.5,294.9 L499.7,297.3 Z"
  }), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M449.9,296.7 L438.3,291.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M525.8,337.7 L520.7,339.5 L506.9,331.3 L512.0,329.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M527.7,432.1 L538.0,425.9 L521.3,414.9 L509.6,421.7 Z"
  }), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M512.0,329.5 L506.9,331.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M404.2,357.8 L400.1,363.4 L382.9,353.6 L387.1,348.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M435.7,418.7 L439.6,419.8 L422.2,408.6 L418.1,407.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M570.2,422.9 L572.3,419.4 L557.5,408.4 L555.3,412.2 Z"
  }), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M387.1,348.1 L382.9,353.6"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M404.2,357.8 L387.1,348.1"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M435.7,418.7 L439.6,419.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M567.5,426.2 L570.2,422.9 L555.3,412.2 L552.3,415.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M547.4,354.5 L546.1,351.7 L531.7,338.9 L533.3,341.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M507.4,334.8 L504.0,336.6 L490.9,322.9 L494.2,321.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M572.3,419.4 L573.8,415.3 L559.1,404.0 L557.5,408.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M499.5,422.7 L501.7,423.8 L483.1,414.1 L480.5,413.1 Z"
  }), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M507.4,334.8 L504.0,336.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M563.7,429.5 L567.5,426.2 L552.3,415.6 L548.2,419.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M499.7,297.3 L498.5,294.9 L486.5,290.4 L487.7,292.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M498.5,320.1 L496.7,320.5 L496.7,293.5 L498.5,294.9 Z"
  }), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M499.7,297.3 L498.5,294.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M464.5,396.6 L465.5,401.2 L435.7,418.7 L433.4,415.2 Z"
  }), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M464.5,396.6 L465.5,401.2"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M544.9,336.3 L559.3,319.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M479.0,289.5 L473.1,292.2 L461.5,287.8 L467.3,285.1 Z"
  }), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M467.3,285.1 L461.5,287.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M573.8,415.3 L575.0,410.1 L560.3,398.4 L559.1,404.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M447.5,348.3 L435.9,355.7 L418.6,345.9 L430.4,338.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M561.6,385.4 L562.4,372.5 L548.0,359.3 L547.4,372.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M496.7,320.5 L494.2,321.4 L494.2,293.2 L496.7,293.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M606.6,445.3 L594.8,410.1 L561.1,431.7 L593.6,453.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M504.0,336.6 L497.9,340.0 L485.0,326.0 L490.9,322.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M447.8,461.0 L426.2,446.5 L487.0,410.0 L507.3,424.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M546.1,351.7 L543.9,350.3 L529.3,337.6 L531.7,338.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M493.0,342.3 L465.0,358.3 L447.5,348.3 L476.1,332.3 Z"
  }), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M496.7,320.5 L496.7,293.5"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M504.0,336.6 L497.9,340.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1b1b1b",
      stroke: "#1b1b1b",
      strokeWidth: 0.8
    },
    d: "M498.5,294.9 L496.7,293.5 L484.7,289.1 L486.5,290.4 Z"
  }), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M546.1,351.7 L531.7,338.9"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M476.1,332.3 L447.5,348.3"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M493.0,342.3 L476.1,332.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M497.9,420.1 L499.5,422.7 L480.5,413.1 L478.8,410.5 Z"
  }), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M498.5,294.9 L496.7,293.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M433.4,415.2 L435.7,418.7 L418.1,407.6 L415.6,404.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M456.9,312.9 L456.6,320.1 L445.5,314.7 L445.8,307.8 Z"
  }), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M499.5,422.7 L480.5,413.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M477.8,392.5 L477.8,405.8 L464.5,396.6 L464.4,383.4 Z"
  }), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M415.6,404.2 L418.1,407.6"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M435.7,418.7 L418.1,407.6"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M445.8,307.8 L445.5,314.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M523.6,433.7 L527.7,432.1 L509.6,421.7 L505.0,423.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M554.4,435.8 L563.7,429.5 L548.2,419.2 L538.0,425.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M520.7,339.5 L507.4,346.7 L493.7,338.3 L506.9,331.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M473.1,292.2 L467.1,295.7 L455.7,291.1 L461.5,287.8 Z"
  }), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M506.9,331.3 L493.7,338.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M494.2,321.4 L490.9,322.9 L490.9,293.9 L494.2,293.2 Z"
  }), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M461.5,287.8 L455.7,291.1"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M473.1,292.2 L461.5,287.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M496.7,293.5 L494.2,293.2 L482.2,288.7 L484.7,289.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252424",
      stroke: "#252424",
      strokeWidth: 0.8
    },
    d: "M415.3,379.7 L414.7,392.5 L397.2,382.0 L397.7,369.6 Z"
  }), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M496.7,293.5 L494.2,293.2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M496.7,293.5 L484.7,289.1"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M414.7,392.5 L397.2,382.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M543.9,350.3 L540.8,350.3 L525.8,337.7 L529.3,337.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M457.8,308.5 L456.9,312.9 L445.8,307.8 L446.6,303.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M497.9,340.0 L491.8,343.4 L479.0,329.4 L485.0,326.0 Z"
  }), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M446.6,303.5 L445.8,307.8"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M497.9,340.0 L491.8,343.4"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M497.9,340.0 L485.0,326.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M435.9,355.7 L427.7,361.9 L410.2,352.0 L418.6,345.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M497.2,415.5 L497.9,420.1 L478.8,410.5 L477.8,405.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M464.4,383.4 L464.5,396.6 L433.4,415.2 L432.5,403.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M575.0,410.1 L576.3,398.0 L561.6,385.4 L560.3,398.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M467.1,295.7 L463.7,298.4 L452.4,293.8 L455.7,291.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M520.8,433.8 L523.6,433.7 L505.0,423.6 L501.7,423.8 Z"
  }), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M464.4,383.4 L464.5,396.6"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M455.7,291.1 L452.4,293.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M459.2,304.7 L457.8,308.5 L446.6,303.5 L447.9,299.9 Z"
  }), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M447.9,299.9 L446.6,303.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M490.9,322.9 L485.0,326.0 L484.9,296.8 L490.9,293.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232222",
      stroke: "#232222",
      strokeWidth: 0.8
    },
    d: "M494.2,293.2 L490.9,293.9 L479.0,289.5 L482.2,288.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M463.7,298.4 L461.2,301.4 L449.9,296.7 L452.4,293.8 Z"
  }), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M494.2,293.2 L490.9,293.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M461.2,301.4 L459.2,304.7 L447.9,299.9 L449.9,296.7 Z"
  }), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M452.4,293.8 L449.9,296.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M493.7,338.3 L480.2,346.2 L465.0,358.3 L493.0,342.3 Z"
  }), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M449.9,296.7 L447.9,299.9"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M461.2,301.4 L449.9,296.7"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M493.0,342.3 L465.0,358.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M562.4,372.5 L562.0,367.7 L547.4,354.5 L548.0,359.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M491.8,343.4 L488.3,345.5 L475.7,331.5 L479.0,329.4 Z"
  }), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M491.8,343.4 L488.3,345.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M540.8,350.3 L536.2,351.9 L520.7,339.5 L525.8,337.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M432.5,403.2 L433.4,415.2 L415.6,404.2 L414.7,392.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M427.7,361.9 L421.7,367.7 L404.2,357.8 L410.2,352.0 Z"
  }), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M414.7,392.5 L415.6,404.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M623.7,382.7 L623.9,377.6 L624.8,372.9 L626.4,368.6 L628.5,364.8 L631.2,361.6 L634.4,359.0 L662.7,341.4 L666.5,339.5 L670.7,338.3 L675.3,337.8 L680.2,338.2 L685.2,339.3 L690.4,341.1 L695.6,343.7 L700.7,347.0 L705.7,350.9 L710.4,355.4 L714.7,360.4 L718.6,365.8 L722.0,371.5 L724.8,377.4 L726.9,383.4 L728.4,389.3 L729.2,395.1 L729.3,400.6 L728.8,405.8 L727.5,410.5 L725.5,414.7 L723.0,418.3 L719.9,421.3 L692.3,440.8 L688.8,443.0 L684.8,444.5 L680.5,445.2 L675.8,445.2 L671.0,444.4 L666.1,442.9 L661.1,440.7 L656.1,437.9 L651.3,434.4 L646.7,430.4 L642.3,426.0 L638.3,421.1 L634.6,415.9 L631.4,410.5 L628.8,404.9 L626.6,399.2 L625.0,393.6 L624.0,388.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M728.8,405.8 L729.3,400.6 L701.4,420.0 L700.9,425.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M729.3,400.6 L729.2,395.1 L701.3,414.5 L701.4,420.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M729.2,395.1 L728.4,389.3 L700.4,408.6 L701.3,414.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M728.4,389.3 L726.9,383.4 L698.8,402.6 L700.4,408.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M726.9,383.4 L724.8,377.4 L696.6,396.5 L698.8,402.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232222",
      stroke: "#232222",
      strokeWidth: 0.8
    },
    d: "M724.8,377.4 L722.0,371.5 L693.7,390.5 L696.6,396.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M722.0,371.5 L718.6,365.8 L690.3,384.7 L693.7,390.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M718.6,365.8 L714.7,360.4 L686.3,379.2 L690.3,384.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M714.7,360.4 L710.4,355.4 L681.9,374.1 L686.3,379.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M710.4,355.4 L705.7,350.9 L677.2,369.4 L681.9,374.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M705.7,350.9 L700.7,347.0 L672.3,365.4 L677.2,369.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M700.7,347.0 L695.6,343.7 L667.1,362.0 L672.3,365.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M695.6,343.7 L690.4,341.1 L661.9,359.2 L667.1,362.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M690.4,341.1 L685.2,339.3 L656.8,357.3 L661.9,359.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M685.2,339.3 L680.2,338.2 L651.7,356.1 L656.8,357.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#201f1f",
      stroke: "#201f1f",
      strokeWidth: 0.8
    },
    d: "M680.2,338.2 L675.3,337.8 L646.9,355.7 L651.7,356.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M675.3,337.8 L670.7,338.3 L642.3,356.0 L646.9,355.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M670.7,338.3 L666.5,339.5 L638.2,357.2 L642.3,356.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M666.5,339.5 L662.7,341.4 L634.4,359.0 L638.2,357.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M719.9,421.3 L723.0,418.3 L695.4,437.9 L692.3,440.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M723.0,418.3 L725.5,414.7 L697.9,434.3 L695.4,437.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M725.5,414.7 L727.5,410.5 L699.7,430.0 L697.9,434.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M727.5,410.5 L728.8,405.8 L700.9,425.3 L699.7,430.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M417.6,373.5 L415.3,379.7 L397.7,369.6 L400.1,363.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M518.8,432.5 L520.8,433.8 L501.7,423.8 L499.5,422.7 Z"
  }), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M728.8,405.8 L700.9,425.3"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M728.4,389.3 L700.4,408.6"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M722.0,371.5 L693.7,390.5"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M710.4,355.4 L681.9,374.1"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M695.6,343.7 L667.1,362.0"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M680.2,338.2 L651.7,356.1"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M666.5,339.5 L638.2,357.2"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M723.0,418.3 L695.4,437.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M544.9,441.6 L554.4,435.8 L538.0,425.9 L527.7,432.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M694.7,424.3 L695.1,419.6 L694.9,414.6 L694.1,409.3 L692.7,403.9 L690.7,398.5 L688.1,393.1 L685.0,387.9 L681.5,382.9 L677.6,378.3 L673.3,374.1 L668.9,370.5 L664.3,367.4 L659.6,364.9 L655.0,363.1 L650.4,362.0 L646.1,361.7 L642.0,362.0 L638.2,363.0 L634.9,364.6 L631.9,366.9 L629.5,369.8 L627.6,373.2 L626.2,377.0 L625.4,381.3 L625.1,385.9 L625.5,390.7 L626.4,395.7 L627.8,400.8 L629.7,405.9 L632.2,411.0 L635.0,415.9 L638.3,420.6 L642.0,425.0 L645.9,429.0 L650.1,432.6 L654.5,435.7 L658.9,438.3 L663.4,440.3 L667.9,441.6 L672.2,442.3 L676.4,442.3 L680.3,441.7 L683.8,440.3 L687.0,438.3 L689.7,435.7 L691.9,432.4 L693.6,428.6 Z"
  }), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M499.5,422.7 L501.7,423.8"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M520.8,433.8 L501.7,423.8"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M694.7,424.3 C694.9,422.8 695.1,421.2 695.1,419.6 C695.2,418.0 695.1,416.3 694.9,414.6 C694.8,412.9 694.5,411.1 694.1,409.3 C693.8,407.6 693.3,405.7 692.7,403.9 C692.1,402.1 691.5,400.3 690.7,398.5 C689.9,396.7 689.1,394.9 688.1,393.1 C687.2,391.3 686.1,389.6 685.0,387.9 C683.9,386.2 682.7,384.5 681.5,382.9 C680.2,381.3 678.9,379.8 677.6,378.3 C676.2,376.8 674.8,375.4 673.3,374.1 C671.9,372.8 670.4,371.6 668.9,370.5 C667.4,369.3 665.8,368.3 664.3,367.4 C662.7,366.5 661.2,365.6 659.6,364.9 C658.1,364.2 656.5,363.6 655.0,363.1 C653.4,362.7 651.9,362.3 650.4,362.0 C649.0,361.8 647.5,361.7 646.1,361.7 C644.7,361.6 643.3,361.7 642.0,362.0 C640.7,362.2 639.4,362.5 638.2,363.0 C637.1,363.4 635.9,364.0 634.9,364.6 C633.8,365.3 632.8,366.0 631.9,366.9 C631.1,367.8 630.2,368.7 629.5,369.8 C628.8,370.8 628.1,372.0 627.6,373.2 C627.0,374.4 626.6,375.7 626.2,377.0 C625.8,378.4 625.6,379.8 625.4,381.3 C625.2,382.7 625.1,384.3 625.1,385.9 C625.2,387.4 625.3,389.1 625.5,390.7 C625.7,392.3 626.0,394.0 626.4,395.7 C626.7,397.4 627.2,399.1 627.8,400.8 C628.3,402.5 629.0,404.2 629.7,405.9 C630.5,407.6 631.3,409.3 632.2,411.0 C633.0,412.6 634.0,414.3 635.0,415.9 C636.1,417.5 637.2,419.1 638.3,420.6 C639.5,422.1 640.7,423.6 642.0,425.0 C643.2,426.4 644.6,427.7 645.9,429.0 C647.3,430.3 648.7,431.5 650.1,432.6 C651.5,433.7 653.0,434.8 654.5,435.7 C655.9,436.7 657.4,437.5 658.9,438.3 C660.4,439.1 661.9,439.7 663.4,440.3 C664.9,440.8 666.4,441.3 667.9,441.6 C669.3,442.0 670.8,442.2 672.2,442.3 C673.6,442.4 675.0,442.5 676.4,442.3 C677.7,442.2 679.0,442.0 680.3,441.7 C681.5,441.3 682.7,440.9 683.8,440.3 C685.0,439.8 686.0,439.1 687.0,438.3 C688.0,437.5 688.9,436.7 689.7,435.7 C690.6,434.7 691.3,433.6 691.9,432.4 C692.6,431.2 693.1,430.0 693.6,428.6 C694.1,427.3 694.4,425.8 694.7,424.3 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M683.5,417.4 L683.8,414.1 L683.6,410.7 L683.1,407.1 L682.1,403.4 L680.7,399.7 L678.9,396.0 L676.8,392.5 L674.4,389.1 L671.8,385.9 L668.9,383.1 L665.8,380.6 L662.7,378.4 L659.5,376.7 L656.3,375.5 L653.2,374.7 L650.2,374.4 L647.4,374.6 L644.8,375.2 L642.4,376.3 L640.4,377.9 L638.7,379.8 L637.3,382.1 L636.4,384.8 L635.8,387.7 L635.6,390.9 L635.8,394.2 L636.4,397.7 L637.4,401.3 L638.7,404.8 L640.4,408.3 L642.4,411.8 L644.7,415.0 L647.2,418.1 L650.0,420.9 L652.9,423.4 L655.9,425.5 L659.0,427.3 L662.1,428.6 L665.2,429.5 L668.2,430.0 L671.1,429.9 L673.7,429.4 L676.2,428.5 L678.3,427.1 L680.2,425.2 L681.7,422.9 L682.8,420.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M488.3,345.5 L485.7,347.2 L473.1,333.4 L475.7,331.5 Z"
  }), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M683.5,417.4 C683.6,416.3 683.7,415.3 683.8,414.1 C683.8,413.0 683.7,411.9 683.6,410.7 C683.5,409.5 683.3,408.3 683.1,407.1 C682.8,405.9 682.5,404.6 682.1,403.4 C681.7,402.2 681.2,400.9 680.7,399.7 C680.2,398.5 679.6,397.2 678.9,396.0 C678.3,394.8 677.6,393.6 676.8,392.5 C676.1,391.3 675.3,390.2 674.4,389.1 C673.6,388.0 672.7,386.9 671.8,385.9 C670.8,384.9 669.9,384.0 668.9,383.1 C667.9,382.2 666.9,381.3 665.8,380.6 C664.8,379.8 663.7,379.1 662.7,378.4 C661.6,377.8 660.6,377.2 659.5,376.7 C658.4,376.2 657.4,375.8 656.3,375.5 C655.3,375.1 654.2,374.9 653.2,374.7 C652.2,374.5 651.2,374.4 650.2,374.4 C649.2,374.4 648.3,374.4 647.4,374.6 C646.5,374.7 645.6,374.9 644.8,375.2 C644.0,375.5 643.2,375.9 642.4,376.3 C641.7,376.8 641.0,377.3 640.4,377.9 C639.8,378.4 639.2,379.1 638.7,379.8 C638.2,380.5 637.7,381.3 637.3,382.1 C636.9,383.0 636.6,383.9 636.4,384.8 C636.1,385.7 635.9,386.7 635.8,387.7 C635.6,388.7 635.6,389.8 635.6,390.9 C635.6,392.0 635.7,393.1 635.8,394.2 C635.9,395.4 636.1,396.6 636.4,397.7 C636.7,398.9 637.0,400.1 637.4,401.3 C637.8,402.5 638.2,403.7 638.7,404.8 C639.2,406.0 639.8,407.2 640.4,408.3 C641.0,409.5 641.7,410.6 642.4,411.8 C643.1,412.9 643.9,414.0 644.7,415.0 C645.5,416.1 646.4,417.1 647.2,418.1 C648.1,419.0 649.1,420.0 650.0,420.9 C650.9,421.7 651.9,422.6 652.9,423.4 C653.9,424.1 654.9,424.8 655.9,425.5 C656.9,426.1 658.0,426.7 659.0,427.3 C660.1,427.8 661.1,428.2 662.1,428.6 C663.2,429.0 664.2,429.3 665.2,429.5 C666.2,429.7 667.2,429.9 668.2,430.0 C669.2,430.0 670.1,430.0 671.1,429.9 C672.0,429.8 672.9,429.7 673.7,429.4 C674.6,429.2 675.4,428.9 676.2,428.5 C676.9,428.1 677.7,427.6 678.3,427.1 C679.0,426.5 679.6,425.9 680.2,425.2 C680.7,424.5 681.2,423.8 681.7,422.9 C682.1,422.1 682.5,421.3 682.8,420.3 C683.1,419.4 683.3,418.4 683.5,417.4 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M421.7,367.7 L417.6,373.5 L400.1,363.4 L404.2,357.8 Z"
  }), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M678.7,414.4 C678.9,413.6 678.9,412.7 679.0,411.8 C679.0,410.9 678.9,410.0 678.8,409.1 C678.7,408.1 678.6,407.1 678.4,406.2 C678.2,405.2 677.9,404.2 677.6,403.2 C677.3,402.2 676.9,401.2 676.5,400.2 C676.1,399.2 675.6,398.2 675.1,397.3 C674.5,396.3 674.0,395.3 673.4,394.4 C672.8,393.5 672.1,392.6 671.4,391.7 C670.8,390.8 670.0,390.0 669.3,389.2 C668.6,388.3 667.8,387.6 667.0,386.9 C666.2,386.1 665.4,385.4 664.5,384.8 C663.7,384.2 662.9,383.6 662.0,383.1 C661.2,382.6 660.3,382.1 659.4,381.7 C658.6,381.3 657.7,381.0 656.9,380.7 C656.0,380.4 655.2,380.2 654.4,380.1 C653.6,379.9 652.7,379.8 652.0,379.8 C651.2,379.8 650.4,379.8 649.7,379.9 C649.0,380.0 648.2,380.2 647.6,380.5 C646.9,380.7 646.3,381.0 645.7,381.3 C645.1,381.7 644.5,382.1 644.0,382.6 C643.5,383.0 643.1,383.6 642.6,384.1 C642.2,384.7 641.9,385.3 641.5,386.0 C641.2,386.7 641.0,387.4 640.7,388.1 C640.5,388.9 640.4,389.7 640.3,390.5 C640.2,391.3 640.1,392.2 640.1,393.1 C640.1,394.0 640.2,394.9 640.3,395.8 C640.4,396.7 640.5,397.7 640.7,398.6 C641.0,399.5 641.2,400.5 641.5,401.5 C641.9,402.4 642.2,403.4 642.6,404.4 C643.0,405.3 643.5,406.3 644.0,407.2 C644.5,408.1 645.0,409.1 645.6,410.0 C646.2,410.9 646.8,411.8 647.5,412.6 C648.1,413.5 648.8,414.3 649.5,415.1 C650.2,415.9 651.0,416.6 651.8,417.3 C652.5,418.0 653.3,418.7 654.1,419.3 C654.9,420.0 655.7,420.5 656.6,421.1 C657.4,421.6 658.2,422.1 659.1,422.5 C659.9,422.9 660.7,423.3 661.6,423.6 C662.4,423.9 663.3,424.1 664.1,424.3 C664.9,424.5 665.7,424.6 666.5,424.6 C667.3,424.7 668.0,424.7 668.8,424.6 C669.5,424.5 670.2,424.4 670.9,424.2 C671.6,424.0 672.3,423.7 672.9,423.4 C673.5,423.1 674.1,422.7 674.6,422.2 C675.2,421.8 675.7,421.3 676.1,420.7 C676.5,420.2 676.9,419.6 677.3,418.9 C677.6,418.3 677.9,417.6 678.2,416.8 C678.4,416.1 678.6,415.3 678.7,414.4 Z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M488.3,345.5 L485.7,347.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#0e0e0e"
    },
    d: "M663.9,405.2 L663.9,404.6 L663.9,403.9 L663.8,403.2 L663.6,402.5 L663.3,401.8 L663.0,401.1 L662.6,400.4 L662.1,399.8 L661.6,399.2 L661.1,398.7 L660.5,398.2 L659.9,397.8 L659.3,397.4 L658.7,397.2 L658.1,397.0 L657.5,396.9 L657.0,397.0 L656.5,397.1 L656.0,397.3 L655.6,397.6 L655.2,397.9 L655.0,398.4 L654.8,398.9 L654.7,399.5 L654.6,400.1 L654.6,400.7 L654.8,401.4 L654.9,402.1 L655.2,402.8 L655.5,403.5 L655.9,404.2 L656.4,404.8 L656.9,405.4 L657.4,406.0 L658.0,406.4 L658.6,406.9 L659.2,407.2 L659.8,407.5 L660.4,407.6 L661.0,407.7 L661.5,407.7 L662.1,407.6 L662.5,407.4 L662.9,407.1 L663.3,406.7 L663.6,406.3 L663.8,405.8 Z"
  }), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M421.7,367.7 L404.2,357.8"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M663.9,405.2 C663.9,405.0 663.9,404.8 663.9,404.6 C663.9,404.4 663.9,404.1 663.9,403.9 C663.9,403.7 663.8,403.5 663.8,403.2 C663.7,403.0 663.7,402.8 663.6,402.5 C663.5,402.3 663.4,402.1 663.3,401.8 C663.2,401.6 663.1,401.4 663.0,401.1 C662.9,400.9 662.7,400.7 662.6,400.4 C662.5,400.2 662.3,400.0 662.1,399.8 C662.0,399.6 661.8,399.4 661.6,399.2 C661.5,399.0 661.3,398.8 661.1,398.7 C660.9,398.5 660.7,398.3 660.5,398.2 C660.3,398.0 660.1,397.9 659.9,397.8 C659.7,397.6 659.5,397.5 659.3,397.4 C659.1,397.3 658.9,397.2 658.7,397.2 C658.5,397.1 658.3,397.0 658.1,397.0 C657.9,397.0 657.7,396.9 657.5,396.9 C657.3,396.9 657.1,396.9 657.0,397.0 C656.8,397.0 656.6,397.0 656.5,397.1 C656.3,397.1 656.1,397.2 656.0,397.3 C655.9,397.4 655.7,397.5 655.6,397.6 C655.5,397.7 655.4,397.8 655.2,397.9 C655.1,398.1 655.1,398.2 655.0,398.4 C654.9,398.5 654.8,398.7 654.8,398.9 C654.7,399.1 654.7,399.3 654.7,399.5 C654.6,399.7 654.6,399.9 654.6,400.1 C654.6,400.3 654.6,400.5 654.6,400.7 C654.7,401.0 654.7,401.2 654.8,401.4 C654.8,401.6 654.9,401.9 654.9,402.1 C655.0,402.3 655.1,402.6 655.2,402.8 C655.3,403.0 655.4,403.3 655.5,403.5 C655.7,403.7 655.8,404.0 655.9,404.2 C656.1,404.4 656.2,404.6 656.4,404.8 C656.6,405.0 656.7,405.2 656.9,405.4 C657.1,405.6 657.3,405.8 657.4,406.0 C657.6,406.1 657.8,406.3 658.0,406.4 C658.2,406.6 658.4,406.7 658.6,406.9 C658.8,407.0 659.0,407.1 659.2,407.2 C659.4,407.3 659.6,407.4 659.8,407.5 C660.0,407.5 660.2,407.6 660.4,407.6 C660.6,407.7 660.8,407.7 661.0,407.7 C661.2,407.7 661.4,407.7 661.5,407.7 C661.7,407.7 661.9,407.6 662.1,407.6 C662.2,407.5 662.4,407.5 662.5,407.4 C662.7,407.3 662.8,407.2 662.9,407.1 C663.1,407.0 663.2,406.9 663.3,406.7 C663.4,406.6 663.5,406.4 663.6,406.3 C663.6,406.1 663.7,405.9 663.8,405.8 C663.8,405.6 663.9,405.4 663.9,405.2 Z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M678.7,414.4 L664.7,405.7"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M675.1,397.3 L663.6,400.9"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M662.0,383.1 L660.0,397.0"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M647.6,380.5 L656.0,396.2"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M640.3,390.5 L653.9,399.0"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M644.0,407.2 L654.9,403.7"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M656.6,421.1 L658.5,407.6"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M670.9,424.2 L662.5,408.4"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M623.7,382.7 L623.9,377.6 L624.8,372.9 L626.4,368.6 L628.5,364.8 L631.2,361.6 L634.4,359.0 L662.7,341.4 L666.5,339.5 L670.7,338.3 L675.3,337.8 L680.2,338.2 L685.2,339.3 L690.4,341.1 L695.6,343.7 L700.7,347.0 L705.7,350.9 L710.4,355.4 L714.7,360.4 L718.6,365.8 L722.0,371.5 L724.8,377.4 L726.9,383.4 L728.4,389.3 L729.2,395.1 L729.3,400.6 L728.8,405.8 L727.5,410.5 L725.5,414.7 L723.0,418.3 L719.9,421.3 L692.3,440.8 L688.8,443.0 L684.8,444.5 L680.5,445.2 L675.8,445.2 L671.0,444.4 L666.1,442.9 L661.1,440.7 L656.1,437.9 L651.3,434.4 L646.7,430.4 L642.3,426.0 L638.3,421.1 L634.6,415.9 L631.4,410.5 L628.8,404.9 L626.6,399.2 L625.0,393.6 L624.0,388.0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M490.9,293.9 L484.9,296.8 L473.1,292.2 L479.0,289.5 Z"
  }), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M490.9,293.9 L484.9,296.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M485.0,326.0 L479.0,329.4 L478.8,300.3 L484.9,296.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M585.6,434.0 L587.4,430.7 L572.3,419.4 L570.2,422.9 Z"
  }), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M485.0,326.0 L484.9,296.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M485.7,347.2 L483.7,348.6 L471.1,335.1 L473.1,333.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M583.1,437.0 L585.6,434.0 L570.2,422.9 L567.5,426.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M478.5,378.5 L477.8,392.5 L464.4,383.4 L464.9,369.6 Z"
  }), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M485.7,347.2 L483.7,348.6"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M485.7,347.2 L473.1,333.4"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M477.8,392.5 L464.4,383.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M562.0,367.7 L560.8,364.9 L546.1,351.7 L547.4,354.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M481.4,350.9 L481.1,352.1 L468.6,340.4 L468.9,338.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M483.7,348.6 L482.2,349.9 L469.7,336.7 L471.1,335.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M587.4,430.7 L588.9,426.9 L573.8,415.3 L572.3,419.4 Z"
  }), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M481.4,350.9 L481.1,352.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a2a",
      stroke: "#2a2a2a",
      strokeWidth: 0.8
    },
    d: "M482.2,349.9 L481.4,350.9 L468.9,338.3 L469.7,336.7 Z"
  }), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M483.7,348.6 L482.2,349.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M507.4,346.7 L493.9,354.7 L480.2,346.2 L493.7,338.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M579.7,440.1 L583.1,437.0 L567.5,426.2 L563.7,429.5 Z"
  }), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M482.2,349.9 L481.4,350.9"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M493.7,338.3 L480.2,346.2"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M507.4,346.7 L493.7,338.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M468.3,318.1 L467.9,325.6 L456.6,320.1 L456.9,312.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M497.4,402.4 L497.2,415.5 L477.8,405.8 L477.8,392.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M468.9,338.3 L468.6,340.4 L467.9,325.6 L468.3,318.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M517.5,429.9 L518.8,432.5 L499.5,422.7 L497.9,420.1 Z"
  }), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M468.3,318.1 L467.9,325.6"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M658.7,414.5 L584.2,429.2"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M497.9,420.1 L499.5,422.7"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M518.8,432.5 L499.5,422.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M479.0,329.4 L475.7,331.5 L475.3,303.1 L478.8,300.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M465.0,358.3 L453.6,365.7 L435.9,355.7 L447.5,348.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M588.9,426.9 L590.0,422.1 L575.0,410.1 L573.8,415.3 Z"
  }), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M447.5,348.3 L435.9,355.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#101010"
    },
    d: "M495.4,304.4 L495.2,301.0 L494.4,299.0 L493.0,297.8 L491.1,297.4 L488.6,297.9 L484.9,299.6 L481.1,301.9 L478.5,304.1 L476.5,306.6 L475.0,309.3 L474.0,312.3 L473.6,316.1 L473.9,319.5 L474.7,321.4 L476.1,322.6 L478.1,322.9 L480.6,322.3 L484.3,320.6 L487.9,318.3 L490.5,316.1 L492.5,313.7 L494.0,311.0 L495.0,308.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M484.9,296.8 L478.8,300.3 L467.1,295.7 L473.1,292.2 Z"
  }), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M495.4,304.4 C495.4,303.2 495.4,301.9 495.2,301.0 C495.0,300.1 494.8,299.5 494.4,299.0 C494.0,298.4 493.6,298.1 493.0,297.8 C492.5,297.5 491.8,297.4 491.1,297.4 C490.3,297.5 489.6,297.6 488.6,297.9 C487.5,298.3 486.1,299.0 484.9,299.6 C483.6,300.3 482.2,301.1 481.1,301.9 C480.1,302.6 479.3,303.3 478.5,304.1 C477.8,304.9 477.1,305.7 476.5,306.6 C475.9,307.5 475.4,308.4 475.0,309.3 C474.5,310.3 474.2,311.2 474.0,312.3 C473.8,313.4 473.7,314.9 473.6,316.1 C473.6,317.2 473.7,318.6 473.9,319.5 C474.0,320.4 474.3,320.9 474.7,321.4 C475.1,322.0 475.5,322.3 476.1,322.6 C476.7,322.8 477.3,322.9 478.1,322.9 C478.8,322.8 479.6,322.7 480.6,322.3 C481.6,321.9 483.1,321.3 484.3,320.6 C485.5,320.0 486.9,319.1 487.9,318.3 C489.0,317.6 489.7,316.9 490.5,316.1 C491.3,315.4 491.9,314.5 492.5,313.7 C493.1,312.8 493.6,311.9 494.0,311.0 C494.4,310.1 494.7,309.2 495.0,308.1 C495.2,307.0 495.3,305.6 495.4,304.4 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M576.3,398.0 L577.1,386.0 L562.4,372.5 L561.6,385.4 Z"
  }), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M484.9,296.8 L478.8,300.3"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M484.9,296.8 L473.1,292.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M541.2,443.0 L544.9,441.6 L527.7,432.1 L523.6,433.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M469.7,336.7 L468.9,338.3 L468.3,318.1 L469.2,313.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M464.9,369.6 L464.4,383.4 L432.5,403.2 L433.3,390.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M475.7,331.5 L473.1,333.4 L472.7,306.2 L475.3,303.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M536.2,351.9 L524.3,358.5 L507.4,346.7 L520.7,339.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M560.8,364.9 L559.0,363.4 L543.9,350.3 L546.1,351.7 Z"
  }), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M464.9,369.6 L464.4,383.4"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M464.4,383.4 L432.5,403.2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M546.1,351.7 L543.9,350.3"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M560.8,364.9 L546.1,351.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M471.1,335.1 L469.7,336.7 L469.2,313.6 L470.7,309.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M473.1,333.4 L471.1,335.1 L470.7,309.7 L472.7,306.2 Z"
  }), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M473.1,333.4 L472.7,306.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M469.2,313.6 L468.3,318.1 L456.9,312.9 L457.8,308.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M571.2,445.9 L579.7,440.1 L563.7,429.5 L554.4,435.8 Z"
  }), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M469.2,313.6 L468.3,318.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M480.2,346.2 L474.7,350.3 L453.6,365.7 L465.0,358.3 Z"
  }), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M465.0,358.3 L453.6,365.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M516.9,425.3 L517.5,429.9 L497.9,420.1 L497.2,415.5 Z"
  }), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M497.2,415.5 L497.9,420.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M502.1,469.5 L447.8,461.0 L507.3,424.3 L538.4,446.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M478.8,300.3 L475.3,303.1 L463.7,298.4 L467.1,295.7 Z"
  }), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M478.8,300.3 L475.3,303.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M433.3,390.1 L432.5,403.2 L414.7,392.5 L415.3,379.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M479.8,372.4 L478.5,378.5 L464.9,369.6 L466.1,363.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M470.7,309.7 L469.2,313.6 L457.8,308.5 L459.2,304.7 Z"
  }), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M415.3,379.7 L414.7,392.5"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M432.5,403.2 L414.7,392.5"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M470.7,309.7 L469.2,313.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M493.9,354.7 L488.5,358.9 L474.7,350.3 L480.2,346.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M538.7,443.1 L541.2,443.0 L523.6,433.7 L520.8,433.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M475.3,303.1 L472.7,306.2 L461.2,301.4 L463.7,298.4 Z"
  }), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M480.2,346.2 L474.7,350.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M472.7,306.2 L470.7,309.7 L459.2,304.7 L461.2,301.4 Z"
  }), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M475.3,303.1 L472.7,306.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M559.0,363.4 L556.2,363.3 L540.8,350.3 L543.9,350.3 Z"
  }), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M472.7,306.2 L470.7,309.7"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M472.7,306.2 L461.2,301.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#0e0e0e"
    },
    d: "M539.8,366.9 L543.3,363.8 L545.0,359.8 L544.7,355.1 L542.6,350.0 L538.8,344.8 L533.4,339.7 L526.8,334.9 L519.3,330.8 L511.3,327.4 L503.1,325.0 L495.2,323.5 L488.0,323.2 L481.6,324.0 L476.5,325.9 L472.9,328.7 L471.0,332.5 L470.9,336.9 L472.6,341.8 L476.1,347.0 L481.1,352.2 L487.6,357.1 L495.2,361.5 L503.4,365.2 L512.0,367.9 L520.3,369.4 L527.9,369.8 L534.6,368.9 Z"
  }), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M543.9,350.3 L540.8,350.3"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M539.8,366.9 C541.2,366.0 542.4,364.9 543.3,363.8 C544.2,362.6 544.7,361.2 545.0,359.8 C545.2,358.3 545.1,356.7 544.7,355.1 C544.3,353.5 543.6,351.7 542.6,350.0 C541.6,348.3 540.3,346.5 538.8,344.8 C537.2,343.1 535.4,341.3 533.4,339.7 C531.4,338.1 529.1,336.4 526.8,334.9 C524.4,333.5 521.9,332.0 519.3,330.8 C516.7,329.5 514.0,328.4 511.3,327.4 C508.6,326.4 505.8,325.6 503.1,325.0 C500.5,324.3 497.8,323.8 495.2,323.5 C492.7,323.2 490.2,323.1 488.0,323.2 C485.7,323.3 483.5,323.6 481.6,324.0 C479.7,324.4 478.0,325.1 476.5,325.9 C475.1,326.6 473.9,327.6 472.9,328.7 C472.0,329.8 471.4,331.1 471.0,332.5 C470.7,333.8 470.6,335.3 470.9,336.9 C471.2,338.4 471.7,340.1 472.6,341.8 C473.5,343.5 474.6,345.3 476.1,347.0 C477.5,348.7 479.2,350.5 481.1,352.2 C483.1,353.9 485.3,355.6 487.6,357.1 C490.0,358.7 492.6,360.2 495.2,361.5 C497.8,362.9 500.6,364.1 503.4,365.2 C506.2,366.2 509.1,367.2 512.0,367.9 C514.8,368.6 517.6,369.1 520.3,369.4 C522.9,369.7 525.6,369.9 527.9,369.8 C530.3,369.7 532.6,369.4 534.6,368.9 C536.5,368.4 538.3,367.7 539.8,366.9 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M453.6,365.7 L445.5,372.0 L427.7,361.9 L435.9,355.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M590.0,422.1 L591.3,410.9 L576.3,398.0 L575.0,410.1 Z"
  }), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M435.9,355.7 L427.7,361.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M481.8,367.4 L479.8,372.4 L466.1,363.6 L468.1,358.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M488.5,358.9 L484.6,363.0 L470.9,354.3 L474.7,350.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232222",
      stroke: "#232222",
      strokeWidth: 0.8
    },
    d: "M474.7,350.3 L470.9,354.3 L445.5,372.0 L453.6,365.7 Z"
  }), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M474.7,350.3 L470.9,354.3"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M474.7,350.3 L453.6,365.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M484.6,363.0 L481.8,367.4 L468.1,358.7 L470.9,354.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M466.1,363.6 L464.9,369.6 L433.3,390.1 L435.6,383.7 Z"
  }), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M481.8,367.4 L468.1,358.7"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M466.1,363.6 L464.9,369.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M536.9,442.0 L538.7,443.1 L520.8,433.8 L518.8,432.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M577.1,386.0 L576.8,381.6 L562.0,367.7 L562.4,372.5 Z"
  }), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M538.7,443.1 L520.8,433.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M470.9,354.3 L468.1,358.7 L439.7,377.9 L445.5,372.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M556.2,363.3 L552.2,364.7 L536.2,351.9 L540.8,350.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M468.1,358.7 L466.1,363.6 L435.6,383.7 L439.7,377.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M498.2,388.7 L497.4,402.4 L477.8,392.5 L478.5,378.5 Z"
  }), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M470.9,354.3 L468.1,358.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M445.5,372.0 L439.7,377.9 L421.7,367.7 L427.7,361.9 Z"
  }), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M540.8,350.3 L536.2,351.9"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M468.1,358.7 L466.1,363.6"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M468.1,358.7 L439.7,377.9"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M497.4,402.4 L477.8,392.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M562.6,451.2 L571.2,445.9 L554.4,435.8 L544.9,441.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M435.6,383.7 L433.3,390.1 L415.3,379.7 L417.6,373.5 Z"
  }), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M427.7,361.9 L421.7,367.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#101010"
    },
    d: "M459.9,394.6 L435.2,408.9 L434.2,401.1 L434.1,384.0 L438.8,377.1 L460.3,365.0 L461.2,370.9 Z"
  }), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M417.6,373.5 L415.3,379.7"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M459.9,394.6 C455.5,400.9 439.5,407.8 435.2,408.9 C430.9,410.0 434.3,405.2 434.2,401.1 C434.0,396.9 433.3,388.0 434.1,384.0 C434.9,380.0 434.4,380.3 438.8,377.1 C443.1,373.9 456.5,366.0 460.3,365.0 C464.0,364.0 461.3,365.9 461.2,370.9 C461.1,375.8 464.2,388.2 459.9,394.6 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M439.7,377.9 L435.6,383.7 L417.6,373.5 L421.7,367.7 Z"
  }), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M421.7,367.7 L417.6,373.5"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M439.7,377.9 L421.7,367.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M524.3,358.5 L512.2,365.9 L493.9,354.7 L507.4,346.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M517.3,412.5 L516.9,425.3 L497.2,415.5 L497.4,402.4 Z"
  }), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M524.3,358.5 L507.4,346.7"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M497.4,402.4 L497.2,415.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M535.8,439.5 L536.9,442.0 L518.8,432.5 L517.5,429.9 Z"
  }), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M536.9,442.0 L518.8,432.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M576.8,381.6 L575.8,378.9 L560.8,364.9 L562.0,367.7 Z"
  }), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "tube-outer",
    d: "M441.1,340.4 C441.1,338.3 439.4,329.6 441.4,327.7 C443.4,325.7 446.9,326.9 453.0,328.7 C459.0,330.5 468.3,336.2 477.6,338.3 C486.9,340.5 499.2,342.0 508.7,341.6 C518.1,341.3 528.5,339.7 534.3,336.4 C540.1,333.2 542.9,327.2 543.5,322.0 C544.2,316.7 542.1,309.8 538.2,304.9 C534.4,300.0 525.5,294.6 520.3,292.5 C515.2,290.5 510.2,290.1 507.4,292.5 C504.6,294.8 504.2,304.3 503.5,306.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M601.3,445.4 L603.0,442.4 L587.4,430.7 L585.6,434.0 Z"
  }), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "tube-inner",
    d: "M441.1,340.4 C441.1,338.3 439.4,329.6 441.4,327.7 C443.4,325.7 446.9,326.9 453.0,328.7 C459.0,330.5 468.3,336.2 477.6,338.3 C486.9,340.5 499.2,342.0 508.7,341.6 C518.1,341.3 528.5,339.7 534.3,336.4 C540.1,333.2 542.9,327.2 543.5,322.0 C544.2,316.7 542.1,309.8 538.2,304.9 C534.4,300.0 525.5,294.6 520.3,292.5 C515.2,290.5 510.2,290.1 507.4,292.5 C504.6,294.8 504.2,304.3 503.5,306.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M599.1,448.1 L601.3,445.4 L585.6,434.0 L583.1,437.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M603.0,442.4 L604.4,438.9 L588.9,426.9 L587.4,430.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M596.0,451.0 L599.1,448.1 L583.1,437.0 L579.7,440.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M559.3,452.6 L562.6,451.2 L544.9,441.6 L541.2,443.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M591.3,410.9 L592.2,399.8 L577.1,386.0 L576.3,398.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M604.4,438.9 L605.4,434.5 L590.0,422.1 L588.9,426.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M552.2,364.7 L541.6,370.6 L524.3,358.5 L536.2,351.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M535.3,435.3 L535.8,439.5 L517.5,429.9 L516.9,425.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M575.8,378.9 L574.1,377.6 L559.0,363.4 L560.8,364.9 Z"
  }), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M536.2,351.9 L524.3,358.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272626",
      stroke: "#272626",
      strokeWidth: 0.8
    },
    d: "M499.4,382.7 L498.2,388.7 L478.5,378.5 L479.8,372.4 Z"
  }), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M575.8,378.9 L560.8,364.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M512.2,365.9 L507.3,369.8 L488.5,358.9 L493.9,354.7 Z"
  }), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M557.3,478.2 L606.6,445.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M588.4,456.3 L596.0,451.0 L579.7,440.1 L571.2,445.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M557.0,452.7 L559.3,452.6 L541.2,443.0 L538.7,443.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M501.2,377.9 L499.4,382.7 L479.8,372.4 L481.8,367.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M507.3,369.8 L503.8,373.7 L484.6,363.0 L488.5,358.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M574.1,377.6 L571.6,377.5 L556.2,363.3 L559.0,363.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M503.8,373.7 L501.2,377.9 L481.8,367.4 L484.6,363.0 Z"
  }), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M501.2,377.9 L481.8,367.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M605.4,434.5 L606.8,424.2 L591.3,410.9 L590.0,422.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M518.3,399.1 L517.3,412.5 L497.4,402.4 L498.2,388.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M555.4,451.6 L557.0,452.7 L538.7,443.1 L536.9,442.0 Z"
  }), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M498.2,388.7 L497.4,402.4"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M517.3,412.5 L497.4,402.4"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M536.9,442.0 L538.7,443.1"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M557.0,452.7 L538.7,443.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M592.2,399.8 L592.0,395.7 L576.8,381.6 L577.1,386.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M557.3,478.2 L502.1,469.5 L538.4,446.2 L570.9,469.1 Z"
  }), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M657.2,414.1 L603.9,398.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M571.6,377.5 L567.9,378.8 L552.2,364.7 L556.2,363.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M535.8,423.3 L535.3,435.3 L516.9,425.3 L517.3,412.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M580.7,461.2 L588.4,456.3 L571.2,445.9 L562.6,451.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M541.6,370.6 L530.9,377.3 L512.2,365.9 L524.3,358.5 Z"
  }), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M658.7,414.5 L640.7,467.6"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M524.3,358.5 L512.2,365.9"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M541.6,370.6 L524.3,358.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M554.4,449.3 L555.4,451.6 L536.9,442.0 L535.8,439.5 Z"
  }), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M662.3,389.8 L593.8,398.5"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M535.8,439.5 L536.9,442.0"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M555.4,451.6 L536.9,442.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M592.0,395.7 L591.1,393.3 L575.8,378.9 L576.8,381.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M519.4,393.3 L518.3,399.1 L498.2,388.7 L499.4,382.7 Z"
  }), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M499.4,382.7 L498.2,388.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M554.1,445.4 L554.4,449.3 L535.8,439.5 L535.3,435.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M577.7,462.4 L580.7,461.2 L562.6,451.2 L559.3,452.6 Z"
  }), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M535.3,435.3 L535.8,439.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M567.9,378.8 L558.3,384.3 L541.6,370.6 L552.2,364.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M591.1,393.3 L589.6,392.1 L574.1,377.6 L575.8,378.9 Z"
  }), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M575.8,378.9 L574.1,377.6"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M591.1,393.3 L575.8,378.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M606.8,424.2 L607.7,414.0 L592.2,399.8 L591.3,410.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M530.9,377.3 L526.6,380.9 L507.3,369.8 L512.2,365.9 Z"
  }), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M512.2,365.9 L507.3,369.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M621.1,458.9 L622.7,456.3 L603.0,442.4 L601.3,445.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M619.1,461.3 L621.1,458.9 L601.3,445.4 L599.1,448.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M521.1,388.6 L519.4,393.3 L499.4,382.7 L501.2,377.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M622.7,456.3 L623.9,453.3 L604.4,438.9 L603.0,442.4 Z"
  }), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M501.2,377.9 L499.4,382.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M616.4,463.8 L619.1,461.3 L599.1,448.1 L596.0,451.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M526.6,380.9 L523.4,384.6 L503.8,373.7 L507.3,369.8 Z"
  }), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M507.3,369.8 L503.8,373.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M523.4,384.6 L521.1,388.6 L501.2,377.9 L503.8,373.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M575.7,462.5 L577.7,462.4 L559.3,452.6 L557.0,452.7 Z"
  }), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M503.8,373.7 L501.2,377.9"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M521.1,388.6 L501.2,377.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M589.6,392.1 L587.4,392.0 L571.6,377.5 L574.1,377.6 Z"
  }), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M574.1,377.6 L571.6,377.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M623.9,453.3 L624.8,449.5 L605.4,434.5 L604.4,438.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M536.9,410.9 L535.8,423.3 L517.3,412.5 L518.3,399.1 Z"
  }), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M535.8,423.3 L517.3,412.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M609.7,468.7 L616.4,463.8 L596.0,451.0 L588.4,456.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M574.3,461.5 L575.7,462.5 L557.0,452.7 L555.4,451.6 Z"
  }), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M575.7,462.5 L557.0,452.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M554.7,434.4 L554.1,445.4 L535.3,435.3 L535.8,423.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M587.4,392.0 L584.1,393.2 L567.9,378.8 L571.6,377.5 Z"
  }), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M535.8,423.3 L535.3,435.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M607.7,414.0 L607.5,410.2 L592.0,395.7 L592.2,399.8 Z"
  }), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M571.6,377.5 L567.9,378.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M558.3,384.3 L548.6,390.6 L530.9,377.3 L541.6,370.6 Z"
  }), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M558.3,384.3 L541.6,370.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M624.8,449.5 L626.1,440.7 L606.8,424.2 L605.4,434.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M573.5,459.4 L574.3,461.5 L555.4,451.6 L554.4,449.3 Z"
  }), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M574.3,461.5 L555.4,451.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M607.5,410.2 L606.8,408.0 L591.1,393.3 L592.0,395.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M538.0,405.4 L536.9,410.9 L518.3,399.1 L519.4,393.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M602.9,473.1 L609.7,468.7 L588.4,456.3 L580.7,461.2 Z"
  }), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M486.1,370.0 L466.9,372.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M584.1,393.2 L575.4,398.3 L558.3,384.3 L567.9,378.8 Z"
  }), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M567.9,378.8 L558.3,384.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M548.6,390.6 L544.6,394.0 L526.6,380.9 L530.9,377.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M573.3,455.8 L573.5,459.4 L554.4,449.3 L554.1,445.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M539.6,401.1 L538.0,405.4 L519.4,393.3 L521.1,388.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M606.8,408.0 L605.5,406.9 L589.6,392.1 L591.1,393.3 Z"
  }), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M606.8,408.0 L591.1,393.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M544.6,394.0 L541.7,397.4 L523.4,384.6 L526.6,380.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M541.7,397.4 L539.6,401.1 L521.1,388.6 L523.4,384.6 Z"
  }), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M539.6,401.1 L521.1,388.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M555.8,422.9 L554.7,434.4 L535.8,423.3 L536.9,410.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M600.3,474.3 L602.9,473.1 L580.7,461.2 L577.7,462.4 Z"
  }), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M536.9,410.9 L535.8,423.3"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M554.7,434.4 L535.8,423.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M626.1,440.7 L627.0,432.0 L607.7,414.0 L606.8,424.2 Z"
  }), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M662.3,389.8 L642.8,429.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M605.5,406.9 L603.5,406.8 L587.4,392.0 L589.6,392.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M822.8,495.0 L826.9,479.4 L808.4,457.2 L770.1,434.2 L762.3,457.7 Z"
  }), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M822.8,495.0 L826.9,479.4 L808.4,457.2 L770.1,434.2 L762.3,457.7 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M790.8,466.2 L798.0,459.9 L779.2,444.0 L772.0,450.2 Z"
  }), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "tube-outer",
    d: "M534.3,336.4 C535.7,339.2 540.0,346.4 542.8,352.9 C545.5,359.4 549.5,371.6 550.8,375.4"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "tube-inner",
    d: "M534.3,336.4 C535.7,339.2 540.0,346.4 542.8,352.9 C545.5,359.4 549.5,371.6 550.8,375.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M598.5,474.4 L600.3,474.3 L577.7,462.4 L575.7,462.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M574.0,445.7 L573.3,455.8 L554.1,445.4 L554.7,434.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M575.4,398.3 L566.5,404.2 L548.6,390.6 L558.3,384.3 Z"
  }), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M558.3,384.3 L548.6,390.6"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M575.4,398.3 L558.3,384.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M603.5,406.8 L600.5,407.9 L584.1,393.2 L587.4,392.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M641.6,472.9 L642.9,470.6 L622.7,456.3 L621.1,458.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M639.8,475.0 L641.6,472.9 L621.1,458.9 L619.1,461.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M642.9,470.6 L644.0,468.1 L623.9,453.3 L622.7,456.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M597.3,473.6 L598.5,474.4 L575.7,462.5 L574.3,461.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M803.1,481.4 L810.1,475.5 L791.0,460.2 L783.9,466.1 Z"
  }), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M574.3,461.5 L575.7,462.5"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M598.5,474.4 L575.7,462.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M637.5,477.2 L639.8,475.0 L619.1,461.3 L616.4,463.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M627.0,432.0 L626.9,428.9 L607.5,410.2 L607.7,414.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M556.9,417.9 L555.8,422.9 L536.9,410.9 L538.0,405.4 Z"
  }), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M538.0,405.4 L536.9,410.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M644.0,468.1 L644.9,465.0 L624.8,449.5 L623.9,453.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M783.5,472.5 L790.8,466.2 L772.0,450.2 L764.7,456.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M566.5,404.2 L562.9,407.3 L544.6,394.0 L548.6,390.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M596.6,471.9 L597.3,473.6 L574.3,461.5 L573.5,459.4 Z"
  }), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M548.6,390.6 L544.6,394.0"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M573.5,459.4 L574.3,461.5"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M597.3,473.6 L574.3,461.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M558.4,413.9 L556.9,417.9 L538.0,405.4 L539.6,401.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M600.5,407.9 L592.8,412.6 L575.4,398.3 L584.1,393.2 Z"
  }), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M539.6,401.1 L538.0,405.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M631.6,481.5 L637.5,477.2 L616.4,463.8 L609.7,468.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M626.9,428.9 L626.3,427.0 L606.8,408.0 L607.5,410.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M562.9,407.3 L560.3,410.5 L541.7,397.4 L544.6,394.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M815.4,496.8 L822.4,491.1 L802.9,476.5 L795.9,482.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M560.3,410.5 L558.4,413.9 L539.6,401.1 L541.7,397.4 Z"
  }), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M544.6,394.0 L541.7,397.4"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M541.7,397.4 L539.6,401.1"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M558.4,413.9 L539.6,401.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M466.8,374.3 L452.2,381.5 L450.3,372.4 L465.1,365.2 Z"
  }), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M466.8,374.3 L452.2,381.5 L450.3,372.4 L465.1,365.2 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M644.9,465.0 L646.0,457.7 L626.1,440.7 L624.8,449.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M596.4,468.8 L596.6,471.9 L573.5,459.4 L573.3,455.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M795.9,487.4 L803.1,481.4 L783.9,466.1 L776.8,471.9 Z"
  }), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M573.3,455.8 L573.5,459.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M575.1,435.1 L574.0,445.7 L554.7,434.4 L555.8,422.9 Z"
  }), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M574.0,445.7 L554.7,434.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M626.3,427.0 L625.1,426.2 L605.5,406.9 L606.8,408.0 Z"
  }), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M606.8,408.0 L605.5,406.9"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M626.3,427.0 L606.8,408.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M776.2,478.8 L783.5,472.5 L764.7,456.3 L757.4,462.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M625.8,485.4 L631.6,481.5 L609.7,468.7 L602.9,473.1 Z"
  }), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M536.0,497.0 L551.8,450.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M625.1,426.2 L623.4,426.2 L603.5,406.8 L605.5,406.9 Z"
  }), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M605.5,406.9 L603.5,406.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282727",
      stroke: "#282727",
      strokeWidth: 0.8
    },
    d: "M592.8,412.6 L584.9,418.0 L566.5,404.2 L575.4,398.3 Z"
  }), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M592.8,412.6 L575.4,398.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M808.5,502.5 L815.4,496.8 L795.9,482.1 L788.9,487.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M597.2,460.2 L596.4,468.8 L573.3,455.8 L574.0,445.7 Z"
  }), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M574.0,445.7 L573.3,455.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M646.0,457.7 L646.9,450.6 L627.0,432.0 L626.1,440.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M576.2,430.5 L575.1,435.1 L555.8,422.9 L556.9,417.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252524",
      stroke: "#252524",
      strokeWidth: 0.8
    },
    d: "M623.4,426.2 L620.8,427.3 L600.5,407.9 L603.5,406.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M788.7,493.5 L795.9,487.4 L776.8,471.9 L769.5,477.9 Z"
  }), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M603.5,406.8 L600.5,407.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M623.5,486.5 L625.8,485.4 L602.9,473.1 L600.3,474.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M768.8,485.3 L776.2,478.8 L757.4,462.6 L749.9,468.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M584.9,418.0 L581.7,420.9 L562.9,407.3 L566.5,404.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M577.5,426.9 L576.2,430.5 L556.9,417.9 L558.4,413.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M622.0,486.7 L623.5,486.5 L600.3,474.3 L598.5,474.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a2a",
      stroke: "#2a2a2a",
      strokeWidth: 0.8
    },
    d: "M581.7,420.9 L579.3,423.7 L560.3,410.5 L562.9,407.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M579.3,423.7 L577.5,426.9 L558.4,413.9 L560.3,410.5 Z"
  }), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M577.5,426.9 L558.4,413.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M620.8,427.3 L614.0,431.6 L592.8,412.6 L600.5,407.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M646.9,450.6 L646.8,448.1 L626.9,428.9 L627.0,432.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M801.4,508.3 L808.5,502.5 L788.9,487.6 L781.8,493.3 Z"
  }), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M600.5,407.9 L592.8,412.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M621.0,486.1 L622.0,486.7 L598.5,474.4 L597.3,473.6 Z"
  }), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M622.0,486.7 L598.5,474.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M781.5,499.6 L788.7,493.5 L769.5,477.9 L762.2,483.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M662.7,487.6 L663.8,485.7 L642.9,470.6 L641.6,472.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M661.2,489.3 L662.7,487.6 L641.6,472.9 L639.8,475.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M761.3,491.8 L768.8,485.3 L749.9,468.9 L742.5,475.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M663.8,485.7 L664.8,483.7 L644.0,468.1 L642.9,470.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M598.3,451.3 L597.2,460.2 L574.0,445.7 L575.1,435.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M646.8,448.1 L646.3,446.6 L626.3,427.0 L626.9,428.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M620.4,484.7 L621.0,486.1 L597.3,473.6 L596.6,471.9 Z"
  }), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M575.1,435.1 L574.0,445.7"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M597.2,460.2 L574.0,445.7"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M621.0,486.1 L597.3,473.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M659.2,491.2 L661.2,489.3 L639.8,475.0 L637.5,477.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M664.8,483.7 L665.5,481.1 L644.9,465.0 L644.0,468.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M646.3,446.6 L645.3,445.9 L625.1,426.2 L626.3,427.0 Z"
  }), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M646.3,446.6 L626.3,427.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M620.3,482.2 L620.4,484.7 L596.6,471.9 L596.4,468.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M614.0,431.6 L607.0,436.4 L584.9,418.0 L592.8,412.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M654.2,494.9 L659.2,491.2 L637.5,477.2 L631.6,481.5 Z"
  }), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M592.8,412.6 L584.9,418.0"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M614.0,431.6 L592.8,412.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M794.2,514.1 L801.4,508.3 L781.8,493.3 L774.6,499.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M665.5,481.1 L666.5,475.4 L646.0,457.7 L644.9,465.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222121",
      stroke: "#222121",
      strokeWidth: 0.8
    },
    d: "M645.3,445.9 L643.8,446.0 L623.4,426.2 L625.1,426.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M599.3,447.3 L598.3,451.3 L575.1,435.1 L576.2,430.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M774.1,505.8 L781.5,499.6 L762.2,483.9 L754.9,489.9 Z"
  }), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M576.2,430.5 L575.1,435.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M753.8,498.3 L761.3,491.8 L742.5,475.2 L734.9,481.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292929",
      stroke: "#292929",
      strokeWidth: 0.8
    },
    d: "M607.0,436.4 L604.2,439.0 L581.7,420.9 L584.9,418.0 Z"
  }), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M584.9,418.0 L581.7,420.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M600.5,444.2 L599.3,447.3 L576.2,430.5 L577.5,426.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M643.8,446.0 L641.6,447.1 L620.8,427.3 L623.4,426.2 Z"
  }), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M577.5,426.9 L576.2,430.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M649.3,498.4 L654.2,494.9 L631.6,481.5 L625.8,485.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M621.0,475.1 L620.3,482.2 L596.4,468.8 L597.2,460.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2a2a",
      stroke: "#2b2a2a",
      strokeWidth: 0.8
    },
    d: "M604.2,439.0 L602.1,441.5 L579.3,423.7 L581.7,420.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M602.1,441.5 L600.5,444.2 L577.5,426.9 L579.3,423.7 Z"
  }), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M581.7,420.9 L579.3,423.7"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M579.3,423.7 L577.5,426.9"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M600.5,444.2 L577.5,426.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M666.5,475.4 L667.3,469.8 L646.9,450.6 L646.0,457.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M787.0,520.0 L794.2,514.1 L774.6,499.0 L767.4,504.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M647.4,499.3 L649.3,498.4 L625.8,485.4 L623.5,486.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M641.6,447.1 L635.7,450.9 L614.0,431.6 L620.8,427.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M766.7,512.1 L774.1,505.8 L754.9,489.9 L747.4,496.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M746.1,505.0 L753.8,498.3 L734.9,481.7 L727.2,488.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M646.1,499.6 L647.4,499.3 L623.5,486.5 L622.0,486.7 Z"
  }), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M538.2,494.0 L570.7,419.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M667.3,469.8 L667.2,467.8 L646.8,448.1 L646.9,450.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242423",
      stroke: "#242423",
      strokeWidth: 0.8
    },
    d: "M622.1,467.8 L621.0,475.1 L597.2,460.2 L598.3,451.3 Z"
  }), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M536.0,497.0 L613.9,486.3"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M621.0,475.1 L597.2,460.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M645.3,499.2 L646.1,499.6 L622.0,486.7 L621.0,486.1 Z"
  }), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M621.0,486.1 L622.0,486.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M667.2,467.8 L666.8,466.7 L646.3,446.6 L646.8,448.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M635.7,450.9 L629.6,455.2 L607.0,436.4 L614.0,431.6 Z"
  }), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M635.7,450.9 L614.0,431.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M779.7,526.0 L787.0,520.0 L767.4,504.7 L760.0,510.5 Z"
  }), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M537.7,471.6 L560.7,419.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1d1d",
      stroke: "#1e1d1d",
      strokeWidth: 0.8
    },
    d: "M644.8,498.1 L645.3,499.2 L621.0,486.1 L620.4,484.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M738.4,511.6 L746.1,505.0 L727.2,488.1 L719.5,494.7 Z"
  }), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M620.4,484.7 L621.0,486.1"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M645.3,499.2 L621.0,486.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M759.2,518.4 L766.7,512.1 L747.4,496.0 L739.9,502.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M666.8,466.7 L666.0,466.2 L645.3,445.9 L646.3,446.6 Z"
  }), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M646.3,446.6 L645.3,445.9"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M666.8,466.7 L646.3,446.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M622.9,464.5 L622.1,467.8 L598.3,451.3 L599.3,447.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M684.5,502.7 L685.5,501.3 L663.8,485.7 L662.7,487.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M644.7,496.2 L644.8,498.1 L620.4,484.7 L620.3,482.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M683.3,504.1 L684.5,502.7 L662.7,487.6 L661.2,489.3 Z"
  }), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M620.3,482.2 L620.4,484.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M685.5,501.3 L686.2,499.7 L664.8,483.7 L663.8,485.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292929",
      stroke: "#292929",
      strokeWidth: 0.8
    },
    d: "M629.6,455.2 L627.2,457.5 L604.2,439.0 L607.0,436.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M666.0,466.2 L664.7,466.4 L643.8,446.0 L645.3,445.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282828",
      stroke: "#282828",
      strokeWidth: 0.8
    },
    d: "M624.0,461.9 L622.9,464.5 L599.3,447.3 L600.5,444.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M681.6,505.7 L683.3,504.1 L661.2,489.3 L659.2,491.2 Z"
  }), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M645.3,445.9 L643.8,446.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M686.2,499.7 L686.8,497.9 L665.5,481.1 L664.8,483.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2a2a",
      stroke: "#2b2a2a",
      strokeWidth: 0.8
    },
    d: "M627.2,457.5 L625.4,459.6 L602.1,441.5 L604.2,439.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M625.4,459.6 L624.0,461.9 L600.5,444.2 L602.1,441.5 Z"
  }), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M624.0,461.9 L600.5,444.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#252525",
      stroke: "#252525",
      strokeWidth: 0.8
    },
    d: "M664.7,466.4 L662.8,467.3 L641.6,447.1 L643.8,446.0 Z"
  }), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M643.8,446.0 L641.6,447.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M677.6,508.8 L681.6,505.7 L659.2,491.2 L654.2,494.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M686.8,497.9 L687.6,493.6 L666.5,475.4 L665.5,481.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2b2a",
      stroke: "#2b2b2a",
      strokeWidth: 0.8
    },
    d: "M730.7,518.3 L738.4,511.6 L719.5,494.7 L711.8,501.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M645.4,490.6 L644.7,496.2 L620.3,482.2 L621.0,475.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M772.3,532.0 L779.7,526.0 L760.0,510.5 L752.6,516.4 Z"
  }), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M621.0,475.1 L620.3,482.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M751.6,524.8 L759.2,518.4 L739.9,502.2 L732.3,508.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M662.8,467.3 L657.8,470.8 L635.7,450.9 L641.6,447.1 Z"
  }), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M641.6,447.1 L635.7,450.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M673.5,511.7 L677.6,508.8 L654.2,494.9 L649.3,498.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M687.6,493.6 L688.3,489.5 L667.3,469.8 L666.5,475.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M646.3,484.8 L645.4,490.6 L621.0,475.1 L622.1,467.8 Z"
  }), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M622.1,467.8 L621.0,475.1"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M645.4,490.6 L621.0,475.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M672.0,512.6 L673.5,511.7 L649.3,498.4 L647.4,499.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M723.0,524.3 L730.7,518.3 L711.8,501.2 L704.0,507.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M743.9,531.2 L751.6,524.8 L732.3,508.5 L724.6,514.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M657.8,470.8 L652.8,474.5 L629.6,455.2 L635.7,450.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M764.9,538.1 L772.3,532.0 L752.6,516.4 L745.1,522.4 Z"
  }), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M635.7,450.9 L629.6,455.2"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M657.8,470.8 L635.7,450.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M688.3,489.5 L688.2,488.1 L667.2,467.8 L667.3,469.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M670.9,512.9 L672.0,512.6 L647.4,499.3 L646.1,499.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M647.1,482.2 L646.3,484.8 L622.1,467.8 L622.9,464.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M688.2,488.1 L687.9,487.3 L666.8,466.7 L667.2,467.8 Z"
  }), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M622.9,464.5 L622.1,467.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M670.3,512.7 L670.9,512.9 L646.1,499.6 L645.3,499.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M652.8,474.5 L650.7,476.4 L627.2,457.5 L629.6,455.2 Z"
  }), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M629.6,455.2 L627.2,457.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292828",
      stroke: "#292828",
      strokeWidth: 0.8
    },
    d: "M648.0,480.1 L647.1,482.2 L622.9,464.5 L624.0,461.9 Z"
  }), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M624.0,461.9 L622.9,464.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1d1d",
      stroke: "#1e1d1d",
      strokeWidth: 0.8
    },
    d: "M687.9,487.3 L687.2,487.1 L666.0,466.2 L666.8,466.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a2a",
      stroke: "#2a2a2a",
      strokeWidth: 0.8
    },
    d: "M650.7,476.4 L649.2,478.2 L625.4,459.6 L627.2,457.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M649.2,478.2 L648.0,480.1 L624.0,461.9 L625.4,459.6 Z"
  }), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M687.9,487.3 L666.8,466.7"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M627.2,457.5 L625.4,459.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M669.9,511.9 L670.3,512.7 L645.3,499.2 L644.8,498.1 Z"
  }), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M625.4,459.6 L624.0,461.9"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M648.0,480.1 L624.0,461.9"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M670.3,512.7 L645.3,499.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M687.2,487.1 L686.2,487.3 L664.7,466.4 L666.0,466.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M669.8,510.5 L669.9,511.9 L644.8,498.1 L644.7,496.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M715.2,530.4 L723.0,524.3 L704.0,507.1 L696.2,513.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M736.3,537.3 L743.9,531.2 L724.6,514.7 L716.9,520.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M757.3,544.3 L764.9,538.1 L745.1,522.4 L737.6,528.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262525",
      stroke: "#262525",
      strokeWidth: 0.8
    },
    d: "M686.2,487.3 L684.6,488.2 L662.8,467.3 L664.7,466.4 Z"
  }), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M537.7,471.6 L611.6,450.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M703.8,516.1 L704.5,515.2 L685.5,501.3 L684.5,502.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M704.5,515.2 L705.0,514.1 L686.2,499.7 L685.5,501.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M702.9,517.1 L703.8,516.1 L684.5,502.7 L683.3,504.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M670.4,506.4 L669.8,510.5 L644.7,496.2 L645.4,490.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M705.0,514.1 L705.5,512.8 L686.8,497.9 L686.2,499.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M701.7,518.2 L702.9,517.1 L683.3,504.1 L681.6,505.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M684.6,488.2 L680.6,491.0 L657.8,470.8 L662.8,467.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M705.5,512.8 L706.1,510.1 L687.6,493.6 L686.8,497.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M698.8,520.6 L701.7,518.2 L681.6,505.7 L677.6,508.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M707.4,536.6 L715.2,530.4 L696.2,513.0 L688.3,519.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M728.5,543.5 L736.3,537.3 L716.9,520.7 L709.1,526.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M671.2,502.1 L670.4,506.4 L645.4,490.6 L646.3,484.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M749.7,550.5 L757.3,544.3 L737.6,528.4 L729.9,534.5 Z"
  }), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M670.4,506.4 L645.4,490.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M680.6,491.0 L676.4,494.2 L652.8,474.5 L657.8,470.8 Z"
  }), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M680.6,491.0 L657.8,470.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M706.1,510.1 L706.5,507.4 L688.3,489.5 L687.6,493.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M695.9,522.7 L698.8,520.6 L677.6,508.8 L673.5,511.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262626",
      stroke: "#262626",
      strokeWidth: 0.8
    },
    d: "M671.8,500.2 L671.2,502.1 L646.3,484.8 L647.1,482.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M676.4,494.2 L674.7,495.7 L650.7,476.4 L652.8,474.5 Z"
  }), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M704.1,515.3 L706.8,536.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M706.5,507.4 L706.5,506.5 L688.2,488.1 L688.3,489.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M694.8,523.4 L695.9,522.7 L673.5,511.7 L672.0,512.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M672.5,498.6 L671.8,500.2 L647.1,482.2 L648.0,480.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M674.7,495.7 L673.5,497.2 L649.2,478.2 L650.7,476.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a2a",
      stroke: "#2a2a2a",
      strokeWidth: 0.8
    },
    d: "M673.5,497.2 L672.5,498.6 L648.0,480.1 L649.2,478.2 Z"
  }), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M672.5,498.6 L648.0,480.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M706.5,506.5 L706.2,506.0 L687.9,487.3 L688.2,488.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M694.0,523.7 L694.8,523.4 L672.0,512.6 L670.9,512.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M464.2,478.6 L464.6,473.7 L465.6,469.4 L467.3,465.6 L469.5,462.6 L472.3,460.2 L507.1,438.5 L510.5,436.9 L514.4,436.0 L518.7,436.0 L523.4,436.9 L528.3,438.5 L533.4,441.0 L538.5,444.3 L543.7,448.3 L548.7,452.9 L553.6,458.2 L554.4,459.1 L558.5,464.2 L562.2,469.7 L565.5,475.4 L568.4,481.2 L569.2,482.9 L571.7,489.4 L573.7,495.8 L574.9,502.0 L575.5,507.8 L575.3,513.2 L574.5,518.1 L573.0,522.3 L570.9,525.8 L568.1,528.6 L534.2,552.6 L531.0,554.5 L527.4,555.6 L523.4,555.9 L519.0,555.3 L514.4,553.9 L509.6,551.7 L504.7,548.9 L499.8,545.3 L497.3,543.4 L493.0,539.6 L488.7,535.4 L484.7,530.7 L480.9,525.7 L477.4,520.4 L474.2,515.0 L471.5,509.4 L469.2,503.8 L467.4,498.3 L466.1,493.0 L465.3,489.5 L464.4,483.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M540.9,537.3 L540.9,531.9 L575.5,507.8 L575.3,513.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1f1f1f",
      stroke: "#1f1f1f",
      strokeWidth: 0.8
    },
    d: "M540.9,531.9 L540.3,526.0 L574.9,502.0 L575.5,507.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M540.3,526.0 L538.9,519.7 L573.7,495.8 L574.9,502.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M538.9,519.7 L536.9,513.2 L571.7,489.4 L573.7,495.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222221",
      stroke: "#222221",
      strokeWidth: 0.8
    },
    d: "M536.9,513.2 L534.2,506.6 L569.2,482.9 L571.7,489.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232222",
      stroke: "#232222",
      strokeWidth: 0.8
    },
    d: "M534.2,506.6 L531.0,499.9 L566.0,476.4 L569.2,482.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M531.0,499.9 L527.2,493.4 L562.3,470.0 L566.0,476.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M527.2,493.4 L523.0,487.1 L558.1,463.9 L562.3,470.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M523.0,487.1 L518.4,481.2 L553.6,458.2 L558.1,463.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232323",
      stroke: "#232323",
      strokeWidth: 0.8
    },
    d: "M518.4,481.2 L513.5,475.8 L548.7,452.9 L553.6,458.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M513.5,475.8 L508.4,471.0 L543.7,448.3 L548.7,452.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M508.4,471.0 L503.3,466.8 L538.5,444.3 L543.7,448.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M503.3,466.8 L498.1,463.4 L533.4,441.0 L538.5,444.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212121",
      stroke: "#212121",
      strokeWidth: 0.8
    },
    d: "M498.1,463.4 L493.1,460.8 L528.3,438.5 L533.4,441.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212020",
      stroke: "#212020",
      strokeWidth: 0.8
    },
    d: "M493.1,460.8 L488.2,459.0 L523.4,436.9 L528.3,438.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#201f1f",
      stroke: "#201f1f",
      strokeWidth: 0.8
    },
    d: "M488.2,459.0 L483.7,458.0 L518.7,436.0 L523.4,436.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M483.7,458.0 L479.4,457.9 L514.4,436.0 L518.7,436.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M479.4,457.9 L475.6,458.7 L510.5,436.9 L514.4,436.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1c",
      stroke: "#1c1c1c",
      strokeWidth: 0.8
    },
    d: "M475.6,458.7 L472.3,460.2 L507.1,438.5 L510.5,436.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#191919",
      stroke: "#191919",
      strokeWidth: 0.8
    },
    d: "M534.2,552.6 L536.8,549.9 L570.9,525.8 L568.1,528.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M536.8,549.9 L538.8,546.4 L573.0,522.3 L570.9,525.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1c1b",
      stroke: "#1c1c1b",
      strokeWidth: 0.8
    },
    d: "M538.8,546.4 L540.2,542.2 L574.5,518.1 L573.0,522.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M540.2,542.2 L540.9,537.3 L575.3,513.2 L574.5,518.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1e1e1e",
      stroke: "#1e1e1e",
      strokeWidth: 0.8
    },
    d: "M706.2,506.0 L705.7,505.9 L687.2,487.1 L687.9,487.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M693.5,523.6 L694.0,523.7 L670.9,512.9 L670.3,512.7 Z"
  }), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M540.9,537.3 L575.3,513.2"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M538.9,519.7 L573.7,495.8"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M531.0,499.9 L566.0,476.4"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M518.4,481.2 L553.6,458.2"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M503.3,466.8 L538.5,444.3"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M488.2,459.0 L523.4,436.9"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M475.6,458.7 L510.5,436.9"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M536.8,549.9 L570.9,525.8"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M687.9,487.3 L687.2,487.1"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M706.2,506.0 L687.9,487.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1d",
      stroke: "#1d1d1d",
      strokeWidth: 0.8
    },
    d: "M534.1,536.2 L534.1,531.3 L533.5,526.0 L532.3,520.3 L530.4,514.5 L528.0,508.5 L525.1,502.5 L521.7,496.7 L517.9,491.1 L513.8,485.8 L509.4,480.9 L504.9,476.5 L500.3,472.8 L495.7,469.7 L491.1,467.3 L486.8,465.6 L482.7,464.7 L478.9,464.6 L475.4,465.3 L472.4,466.6 L469.9,468.7 L467.9,471.5 L466.4,474.8 L465.5,478.7 L465.1,483.1 L465.3,487.9 L466.1,493.0 L467.4,498.3 L469.2,503.8 L471.5,509.4 L474.2,515.0 L477.4,520.4 L480.9,525.7 L484.7,530.7 L488.7,535.4 L493.0,539.6 L497.3,543.4 L501.7,546.6 L506.1,549.2 L510.4,551.2 L514.6,552.4 L518.5,552.9 L522.1,552.7 L525.3,551.7 L528.2,550.0 L530.5,547.5 L532.3,544.3 L533.5,540.5 Z"
  }), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M534.1,536.2 C534.2,534.6 534.2,533.0 534.1,531.3 C534.0,529.6 533.8,527.8 533.5,526.0 C533.2,524.2 532.8,522.3 532.3,520.3 C531.8,518.4 531.1,516.5 530.4,514.5 C529.7,512.5 528.9,510.5 528.0,508.5 C527.1,506.5 526.2,504.5 525.1,502.5 C524.1,500.6 522.9,498.6 521.7,496.7 C520.5,494.8 519.2,492.9 517.9,491.1 C516.6,489.2 515.2,487.5 513.8,485.8 C512.4,484.1 510.9,482.4 509.4,480.9 C508.0,479.4 506.4,477.9 504.9,476.5 C503.4,475.2 501.8,473.9 500.3,472.8 C498.7,471.6 497.2,470.6 495.7,469.7 C494.1,468.8 492.6,468.0 491.1,467.3 C489.7,466.6 488.2,466.1 486.8,465.6 C485.4,465.2 484.0,464.9 482.7,464.7 C481.3,464.6 480.1,464.5 478.9,464.6 C477.7,464.7 476.5,464.9 475.4,465.3 C474.4,465.6 473.4,466.1 472.4,466.6 C471.5,467.2 470.7,467.9 469.9,468.7 C469.2,469.5 468.5,470.4 467.9,471.5 C467.3,472.5 466.8,473.6 466.4,474.8 C466.0,476.0 465.7,477.3 465.5,478.7 C465.3,480.1 465.2,481.6 465.1,483.1 C465.1,484.6 465.2,486.2 465.3,487.9 C465.5,489.5 465.7,491.2 466.1,493.0 C466.4,494.7 466.8,496.5 467.4,498.3 C467.9,500.1 468.5,502.0 469.2,503.8 C469.9,505.7 470.6,507.5 471.5,509.4 C472.3,511.2 473.2,513.1 474.2,515.0 C475.2,516.8 476.2,518.6 477.4,520.4 C478.5,522.2 479.6,524.0 480.9,525.7 C482.1,527.4 483.4,529.1 484.7,530.7 C486.0,532.3 487.3,533.9 488.7,535.4 C490.1,536.9 491.5,538.3 493.0,539.6 C494.4,541.0 495.9,542.2 497.3,543.4 C498.8,544.6 500.3,545.6 501.7,546.6 C503.2,547.6 504.7,548.5 506.1,549.2 C507.6,550.0 509.0,550.6 510.4,551.2 C511.8,551.7 513.2,552.1 514.6,552.4 C515.9,552.7 517.2,552.9 518.5,552.9 C519.7,553.0 521.0,552.9 522.1,552.7 C523.2,552.5 524.3,552.1 525.3,551.7 C526.4,551.2 527.3,550.7 528.2,550.0 C529.0,549.3 529.8,548.4 530.5,547.5 C531.2,546.6 531.8,545.5 532.3,544.3 C532.8,543.2 533.2,541.9 533.5,540.5 C533.8,539.2 534.0,537.7 534.1,536.2 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M699.4,542.8 L707.4,536.6 L688.3,519.0 L680.4,525.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#222222",
      stroke: "#222222",
      strokeWidth: 0.8
    },
    d: "M522.9,527.6 L522.9,524.2 L522.5,520.6 L521.6,516.7 L520.3,512.7 L518.7,508.7 L516.7,504.6 L514.4,500.6 L511.8,496.8 L509.0,493.2 L506.0,489.8 L503.0,486.8 L499.8,484.2 L496.6,482.1 L493.5,480.4 L490.5,479.2 L487.7,478.6 L485.1,478.5 L482.7,478.9 L480.6,479.8 L478.8,481.2 L477.4,483.0 L476.4,485.3 L475.7,488.0 L475.4,491.0 L475.5,494.3 L476.0,497.8 L476.9,501.6 L478.2,505.4 L479.8,509.3 L481.7,513.1 L483.9,516.9 L486.3,520.6 L489.0,524.1 L491.8,527.3 L494.7,530.3 L497.8,532.9 L500.8,535.1 L503.9,536.8 L506.8,538.2 L509.7,539.0 L512.4,539.3 L514.8,539.1 L517.0,538.4 L519.0,537.1 L520.5,535.4 L521.7,533.2 L522.5,530.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M720.7,549.8 L728.5,543.5 L709.1,526.7 L701.3,532.8 Z"
  }), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M522.9,527.6 C523.0,526.5 523.0,525.4 522.9,524.2 C522.8,523.0 522.7,521.8 522.5,520.6 C522.2,519.3 522.0,518.0 521.6,516.7 C521.3,515.4 520.8,514.1 520.3,512.7 C519.9,511.4 519.3,510.0 518.7,508.7 C518.1,507.3 517.4,505.9 516.7,504.6 C516.0,503.3 515.2,501.9 514.4,500.6 C513.6,499.3 512.7,498.0 511.8,496.8 C510.9,495.5 510.0,494.3 509.0,493.2 C508.1,492.0 507.1,490.9 506.0,489.8 C505.0,488.8 504.0,487.8 503.0,486.8 C501.9,485.9 500.9,485.0 499.8,484.2 C498.7,483.4 497.7,482.7 496.6,482.1 C495.6,481.4 494.6,480.9 493.5,480.4 C492.5,479.9 491.5,479.5 490.5,479.2 C489.6,478.9 488.6,478.7 487.7,478.6 C486.8,478.5 485.9,478.4 485.1,478.5 C484.2,478.5 483.4,478.6 482.7,478.9 C481.9,479.1 481.2,479.4 480.6,479.8 C480.0,480.1 479.4,480.6 478.8,481.2 C478.3,481.7 477.8,482.3 477.4,483.0 C477.0,483.7 476.6,484.5 476.4,485.3 C476.1,486.1 475.8,487.0 475.7,488.0 C475.5,488.9 475.4,489.9 475.4,491.0 C475.4,492.1 475.4,493.2 475.5,494.3 C475.6,495.4 475.8,496.6 476.0,497.8 C476.3,499.0 476.6,500.3 476.9,501.6 C477.3,502.8 477.7,504.1 478.2,505.4 C478.6,506.7 479.2,508.0 479.8,509.3 C480.3,510.6 481.0,511.9 481.7,513.1 C482.3,514.4 483.1,515.7 483.9,516.9 C484.6,518.2 485.5,519.4 486.3,520.6 C487.2,521.8 488.0,523.0 489.0,524.1 C489.9,525.2 490.8,526.3 491.8,527.3 C492.7,528.4 493.7,529.4 494.7,530.3 C495.7,531.2 496.8,532.1 497.8,532.9 C498.8,533.7 499.8,534.4 500.8,535.1 C501.8,535.7 502.9,536.3 503.9,536.8 C504.9,537.4 505.9,537.8 506.8,538.2 C507.8,538.5 508.8,538.8 509.7,539.0 C510.6,539.2 511.5,539.3 512.4,539.3 C513.2,539.3 514.1,539.2 514.8,539.1 C515.6,538.9 516.4,538.7 517.0,538.4 C517.7,538.0 518.4,537.6 519.0,537.1 C519.5,536.6 520.1,536.1 520.5,535.4 C521.0,534.7 521.4,534.0 521.7,533.2 C522.1,532.4 522.3,531.5 522.5,530.6 C522.7,529.6 522.9,528.6 522.9,527.6 Z"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M518.2,523.9 C518.2,523.1 518.2,522.1 518.2,521.2 C518.1,520.3 518.0,519.3 517.8,518.3 C517.6,517.3 517.4,516.2 517.1,515.2 C516.8,514.1 516.5,513.1 516.1,512.0 C515.7,510.9 515.3,509.8 514.8,508.7 C514.3,507.6 513.7,506.5 513.2,505.5 C512.6,504.4 512.0,503.3 511.3,502.3 C510.7,501.2 510.0,500.2 509.3,499.2 C508.5,498.2 507.8,497.2 507.0,496.3 C506.2,495.3 505.4,494.4 504.6,493.6 C503.8,492.7 503.0,491.9 502.1,491.2 C501.3,490.4 500.4,489.7 499.6,489.1 C498.8,488.5 497.9,487.9 497.1,487.4 C496.2,486.8 495.4,486.4 494.6,486.0 C493.7,485.6 492.9,485.3 492.1,485.0 C491.4,484.8 490.6,484.6 489.9,484.5 C489.1,484.4 488.4,484.4 487.7,484.4 C487.1,484.4 486.4,484.5 485.8,484.7 C485.2,484.9 484.6,485.1 484.1,485.4 C483.6,485.7 483.1,486.1 482.7,486.5 C482.2,487.0 481.9,487.5 481.5,488.0 C481.2,488.6 480.9,489.2 480.7,489.8 C480.4,490.5 480.2,491.2 480.1,492.0 C480.0,492.8 479.9,493.6 479.9,494.4 C479.8,495.3 479.9,496.2 480.0,497.1 C480.0,498.0 480.2,499.0 480.4,500.0 C480.6,500.9 480.8,501.9 481.1,503.0 C481.4,504.0 481.7,505.0 482.1,506.1 C482.5,507.1 482.9,508.2 483.4,509.2 C483.8,510.3 484.4,511.3 484.9,512.3 C485.5,513.4 486.1,514.4 486.7,515.4 C487.3,516.4 488.0,517.4 488.7,518.4 C489.4,519.4 490.1,520.3 490.8,521.2 C491.6,522.1 492.3,523.0 493.1,523.8 C493.9,524.7 494.7,525.5 495.5,526.2 C496.3,527.0 497.1,527.7 498.0,528.3 C498.8,529.0 499.6,529.5 500.4,530.1 C501.3,530.6 502.1,531.1 502.9,531.5 C503.7,531.9 504.5,532.3 505.3,532.5 C506.1,532.8 506.8,533.0 507.6,533.2 C508.3,533.3 509.1,533.4 509.7,533.4 C510.4,533.4 511.1,533.4 511.7,533.3 C512.4,533.1 513.0,532.9 513.5,532.7 C514.1,532.4 514.6,532.0 515.0,531.6 C515.5,531.2 515.9,530.8 516.3,530.2 C516.6,529.7 517.0,529.1 517.2,528.5 C517.5,527.8 517.7,527.1 517.9,526.3 C518.0,525.6 518.1,524.8 518.2,523.9 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M742.0,556.8 L749.7,550.5 L729.9,534.5 L722.2,540.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#0e0e0e"
    },
    d: "M503.4,512.5 L503.4,511.9 L503.3,511.2 L503.1,510.4 L502.9,509.7 L502.6,508.9 L502.2,508.1 L501.7,507.4 L501.2,506.7 L500.7,506.0 L500.2,505.3 L499.6,504.7 L499.0,504.2 L498.4,503.8 L497.8,503.5 L497.2,503.3 L496.6,503.1 L496.1,503.1 L495.7,503.1 L495.2,503.3 L494.9,503.6 L494.6,503.9 L494.4,504.3 L494.2,504.9 L494.2,505.4 L494.2,506.1 L494.3,506.8 L494.5,507.5 L494.7,508.3 L495.0,509.0 L495.4,509.8 L495.8,510.5 L496.3,511.3 L496.8,511.9 L497.4,512.6 L498.0,513.2 L498.6,513.7 L499.2,514.1 L499.8,514.4 L500.3,514.7 L500.9,514.8 L501.4,514.9 L501.9,514.8 L502.3,514.6 L502.7,514.4 L502.9,514.0 L503.2,513.6 L503.3,513.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#232322",
      stroke: "#232322",
      strokeWidth: 0.8
    },
    d: "M705.7,505.9 L705.0,506.1 L686.2,487.3 L687.2,487.1 Z"
  }), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M503.4,512.5 C503.4,512.3 503.4,512.1 503.4,511.9 C503.4,511.6 503.3,511.4 503.3,511.2 C503.2,510.9 503.2,510.7 503.1,510.4 C503.0,510.2 503.0,509.9 502.9,509.7 C502.8,509.4 502.7,509.2 502.6,508.9 C502.4,508.7 502.3,508.4 502.2,508.1 C502.0,507.9 501.9,507.6 501.7,507.4 C501.6,507.1 501.4,506.9 501.2,506.7 C501.1,506.4 500.9,506.2 500.7,506.0 C500.5,505.7 500.3,505.5 500.2,505.3 C500.0,505.1 499.8,504.9 499.6,504.7 C499.4,504.6 499.2,504.4 499.0,504.2 C498.8,504.1 498.6,504.0 498.4,503.8 C498.2,503.7 498.0,503.6 497.8,503.5 C497.6,503.4 497.4,503.3 497.2,503.3 C497.0,503.2 496.8,503.1 496.6,503.1 C496.5,503.1 496.3,503.1 496.1,503.1 C496.0,503.1 495.8,503.1 495.7,503.1 C495.5,503.2 495.4,503.2 495.2,503.3 C495.1,503.4 495.0,503.5 494.9,503.6 C494.8,503.7 494.7,503.8 494.6,503.9 C494.5,504.0 494.4,504.2 494.4,504.3 C494.3,504.5 494.3,504.7 494.2,504.9 C494.2,505.0 494.2,505.2 494.2,505.4 C494.2,505.6 494.2,505.9 494.2,506.1 C494.2,506.3 494.3,506.5 494.3,506.8 C494.3,507.0 494.4,507.3 494.5,507.5 C494.5,507.8 494.6,508.0 494.7,508.3 C494.8,508.5 494.9,508.8 495.0,509.0 C495.1,509.3 495.3,509.5 495.4,509.8 C495.5,510.0 495.7,510.3 495.8,510.5 C496.0,510.8 496.1,511.0 496.3,511.3 C496.5,511.5 496.7,511.7 496.8,511.9 C497.0,512.2 497.2,512.4 497.4,512.6 C497.6,512.8 497.8,513.0 498.0,513.2 C498.2,513.3 498.4,513.5 498.6,513.7 C498.8,513.8 499.0,514.0 499.2,514.1 C499.4,514.2 499.6,514.3 499.8,514.4 C500.0,514.5 500.2,514.6 500.3,514.7 C500.5,514.7 500.7,514.8 500.9,514.8 C501.1,514.8 501.2,514.9 501.4,514.9 C501.6,514.8 501.7,514.8 501.9,514.8 C502.0,514.8 502.2,514.7 502.3,514.6 C502.4,514.6 502.5,514.5 502.7,514.4 C502.8,514.3 502.9,514.2 502.9,514.0 C503.0,513.9 503.1,513.8 503.2,513.6 C503.2,513.5 503.3,513.3 503.3,513.1 C503.3,512.9 503.4,512.7 503.4,512.5 Z"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M518.2,523.9 L504.2,513.1"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M513.2,505.5 L502.7,508.0"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M499.6,489.1 L499.0,503.5"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M485.8,484.7 L495.1,502.2"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M479.9,494.4 L493.4,504.9"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M484.9,512.3 L494.8,509.9"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M498.0,528.3 L498.5,514.4"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M511.7,533.3 L502.4,515.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1d1d1c",
      stroke: "#1d1d1c",
      strokeWidth: 0.8
    },
    d: "M693.2,523.1 L693.5,523.6 L670.3,512.7 L669.9,511.9 Z"
  }), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M464.2,478.6 L464.6,473.7 L465.6,469.4 L467.3,465.6 L469.5,462.6 L472.3,460.2 L507.1,438.5 L510.5,436.9 L514.4,436.0 L518.7,436.0 L523.4,436.9 L528.3,438.5 L533.4,441.0 L538.5,444.3 L543.7,448.3 L548.7,452.9 L553.6,458.2 L554.4,459.1 L558.5,464.2 L562.2,469.7 L565.5,475.4 L568.4,481.2 L569.2,482.9 L571.7,489.4 L573.7,495.8 L574.9,502.0 L575.5,507.8 L575.3,513.2 L574.5,518.1 L573.0,522.3 L570.9,525.8 L568.1,528.6 L534.2,552.6 L531.0,554.5 L527.4,555.6 L523.4,555.9 L519.0,555.3 L514.4,553.9 L509.6,551.7 L504.7,548.9 L499.8,545.3 L497.3,543.4 L493.0,539.6 L488.7,535.4 L484.7,530.7 L480.9,525.7 L477.4,520.4 L474.2,515.0 L471.5,509.4 L469.2,503.8 L467.4,498.3 L466.1,493.0 L465.3,489.5 L464.4,483.9 Z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M687.2,487.1 L686.2,487.3"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M669.9,511.9 L670.3,512.7"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M693.5,523.6 L670.3,512.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M705.0,506.1 L703.9,506.8 L684.6,488.2 L686.2,487.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#212120",
      stroke: "#212120",
      strokeWidth: 0.8
    },
    d: "M693.2,522.2 L693.2,523.1 L669.9,511.9 L669.8,510.5 Z"
  }), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M686.2,487.3 L684.6,488.2"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M669.8,510.5 L669.9,511.9"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M695.5,521.9 L698.3,543.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M703.9,506.8 L700.9,509.0 L680.6,491.0 L684.6,488.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M693.6,519.6 L693.2,522.2 L669.8,510.5 L670.4,506.4 Z"
  }), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M684.6,488.2 L680.6,491.0"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M670.4,506.4 L669.8,510.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M691.4,549.1 L699.4,542.8 L680.4,525.1 L672.3,531.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M712.8,556.1 L720.7,549.8 L701.3,532.8 L693.3,539.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M700.9,509.0 L698.0,511.3 L676.4,494.2 L680.6,491.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M734.2,563.2 L742.0,556.8 L722.2,540.6 L714.3,546.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M694.2,516.7 L693.6,519.6 L670.4,506.4 L671.2,502.1 Z"
  }), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M680.6,491.0 L676.4,494.2"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M700.9,509.0 L680.6,491.0"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M671.2,502.1 L670.4,506.4"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M693.6,519.6 L670.4,506.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M723.7,530.0 L724.1,529.5 L704.5,515.2 L703.8,516.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M724.1,529.5 L724.4,528.9 L705.0,514.1 L704.5,515.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M723.2,530.6 L723.7,530.0 L703.8,516.1 L702.9,517.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M724.4,528.9 L724.7,528.3 L705.5,512.8 L705.0,514.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M722.5,531.2 L723.2,530.6 L702.9,517.1 L701.7,518.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M698.0,511.3 L696.7,512.4 L674.7,495.7 L676.4,494.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M694.6,515.5 L694.2,516.7 L671.2,502.1 L671.8,500.2 Z"
  }), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M676.4,494.2 L674.7,495.7"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M671.8,500.2 L671.2,502.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M696.7,512.4 L695.9,513.4 L673.5,497.2 L674.7,495.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M695.2,514.4 L694.6,515.5 L671.8,500.2 L672.5,498.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M724.7,528.3 L725.0,527.0 L706.1,510.1 L705.5,512.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2a2a",
      stroke: "#2b2a2a",
      strokeWidth: 0.8
    },
    d: "M695.9,513.4 L695.2,514.4 L672.5,498.6 L673.5,497.2 Z"
  }), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M674.7,495.7 L673.5,497.2"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M672.5,498.6 L671.8,500.2"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M673.5,497.2 L672.5,498.6"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M695.2,514.4 L672.5,498.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M720.7,532.7 L722.5,531.2 L701.7,518.2 L698.8,520.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M725.0,527.0 L725.2,525.7 L706.5,507.4 L706.1,510.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M718.9,534.1 L720.7,532.7 L698.8,520.6 L695.9,522.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M725.2,525.7 L725.2,525.3 L706.5,506.5 L706.5,507.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M683.3,555.4 L691.4,549.1 L672.3,531.2 L664.1,537.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M725.2,525.3 L725.0,525.2 L706.2,506.0 L706.5,506.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M704.8,562.5 L712.8,556.1 L693.3,539.0 L685.3,545.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M718.2,534.5 L718.9,534.1 L695.9,522.7 L694.8,523.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M726.3,569.7 L734.2,563.2 L714.3,546.8 L706.4,553.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#20201f",
      stroke: "#20201f",
      strokeWidth: 0.8
    },
    d: "M725.0,525.2 L724.7,525.2 L705.7,505.9 L706.2,506.0 Z"
  }), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M725.0,525.2 L724.7,525.2"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M725.0,525.2 L706.2,506.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M717.7,534.7 L718.2,534.5 L694.8,523.4 L694.0,523.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M724.7,525.2 L724.2,525.4 L705.0,506.1 L705.7,505.9 Z"
  }), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M724.7,525.2 L724.2,525.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1a1a1a",
      stroke: "#1a1a1a",
      strokeWidth: 0.8
    },
    d: "M717.4,534.8 L717.7,534.7 L694.0,523.7 L693.5,523.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#262625",
      stroke: "#262625",
      strokeWidth: 0.8
    },
    d: "M724.2,525.4 L723.5,525.9 L703.9,506.8 L705.0,506.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#1c1b1b",
      stroke: "#1c1b1b",
      strokeWidth: 0.8
    },
    d: "M717.2,534.6 L717.4,534.8 L693.5,523.6 L693.2,523.1 Z"
  }), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M724.2,525.4 L723.5,525.9"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M717.2,534.6 L717.4,534.8"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M717.4,534.8 L693.5,523.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M717.2,534.2 L717.2,534.6 L693.2,523.1 L693.2,522.2 Z"
  }), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M717.2,534.2 L717.2,534.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272727",
      stroke: "#272727",
      strokeWidth: 0.8
    },
    d: "M723.5,525.9 L721.7,527.3 L700.9,509.0 L703.9,506.8 Z"
  }), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M723.5,525.9 L721.7,527.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242323",
      stroke: "#242323",
      strokeWidth: 0.8
    },
    d: "M717.4,533.0 L717.2,534.2 L693.2,522.2 L693.6,519.6 Z"
  }), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M717.4,533.0 L717.2,534.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#282827",
      stroke: "#282827",
      strokeWidth: 0.8
    },
    d: "M721.7,527.3 L719.9,528.7 L698.0,511.3 L700.9,509.0 Z"
  }), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M721.7,527.3 L719.9,528.7"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M721.7,527.3 L700.9,509.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#242424",
      stroke: "#242424",
      strokeWidth: 0.8
    },
    d: "M717.7,531.7 L717.4,533.0 L693.6,519.6 L694.2,516.7 Z"
  }), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M717.7,531.7 L717.4,533.0"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M717.4,533.0 L693.6,519.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M696.7,569.0 L704.8,562.5 L685.3,545.3 L677.1,551.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M675.2,561.2 L683.3,555.4 L664.1,537.4 L656.0,542.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M718.3,576.2 L726.3,569.7 L706.4,553.1 L698.4,559.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M719.9,528.7 L719.2,529.4 L696.7,512.4 L698.0,511.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#272726",
      stroke: "#272726",
      strokeWidth: 0.8
    },
    d: "M717.9,531.0 L717.7,531.7 L694.2,516.7 L694.6,515.5 Z"
  }), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M719.9,528.7 L719.2,529.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2a29",
      stroke: "#2a2a29",
      strokeWidth: 0.8
    },
    d: "M719.2,529.4 L718.6,530.0 L695.9,513.4 L696.7,512.4 Z"
  }), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M717.9,531.0 L717.7,531.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M718.2,530.5 L717.9,531.0 L694.6,515.5 L695.2,514.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2b2a2a",
      stroke: "#2b2a2a",
      strokeWidth: 0.8
    },
    d: "M718.6,530.0 L718.2,530.5 L695.2,514.4 L695.9,513.4 Z"
  }), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M719.2,529.4 L718.6,530.0"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M718.2,530.5 L717.9,531.0"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M718.6,530.0 L718.2,530.5"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "ln-ghost",
    d: "M718.2,530.5 L695.2,514.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292929",
      stroke: "#292929",
      strokeWidth: 0.8
    },
    d: "M688.5,575.2 L696.7,569.0 L677.1,551.6 L669.0,557.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M710.2,582.8 L718.3,576.2 L698.4,559.5 L690.3,565.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M667.0,566.9 L675.2,561.2 L656.0,542.9 L647.8,548.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M702.1,589.5 L710.2,582.8 L690.3,565.9 L682.1,572.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M680.3,581.5 L688.5,575.2 L669.0,557.6 L660.7,563.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M658.7,572.6 L667.0,566.9 L647.8,548.5 L639.4,554.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M693.8,596.2 L702.1,589.5 L682.1,572.4 L673.8,579.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M672.0,587.8 L680.3,581.5 L660.7,563.7 L652.4,569.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M650.3,578.5 L658.7,572.6 L639.4,554.1 L631.0,559.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M685.4,603.1 L693.8,596.2 L673.8,579.0 L665.4,585.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M663.6,594.1 L672.0,587.8 L652.4,569.8 L643.9,576.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M641.8,584.4 L650.3,578.5 L631.0,559.7 L622.4,565.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M677.0,610.0 L685.4,603.1 L665.4,585.7 L656.9,592.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M655.0,600.6 L663.6,594.1 L643.9,576.0 L635.3,582.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M633.2,590.4 L641.8,584.4 L622.4,565.5 L613.8,571.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M668.4,617.0 L677.0,610.0 L656.9,592.4 L648.4,599.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M646.4,607.1 L655.0,600.6 L635.3,582.3 L626.7,588.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M624.4,596.5 L633.2,590.4 L613.8,571.3 L605.0,577.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M659.7,624.1 L668.4,617.0 L648.4,599.2 L639.7,606.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M637.6,613.8 L646.4,607.1 L626.7,588.6 L617.9,595.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M615.6,602.6 L624.4,596.5 L605.0,577.2 L596.1,583.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M651.0,631.2 L659.7,624.1 L639.7,606.1 L630.9,613.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M628.8,620.5 L637.6,613.8 L617.9,595.1 L609.0,601.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M606.6,608.9 L615.6,602.6 L596.1,583.1 L587.1,589.2 Z"
  }), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M606.6,608.9 C608.1,607.8 612.6,604.7 615.6,602.6 C618.5,600.6 621.5,598.5 624.4,596.5 C627.3,594.4 630.3,592.4 633.2,590.4 C636.0,588.4 638.9,586.4 641.8,584.4 C644.6,582.4 647.5,580.4 650.3,578.5 C653.1,576.5 655.9,574.6 658.7,572.6 C661.5,570.7 664.2,568.8 667.0,566.9 C669.7,564.9 672.4,563.1 675.2,561.2 C677.9,559.3 680.6,557.5 683.3,555.4 C686.0,553.4 688.7,551.2 691.4,549.1 C694.1,547.0 696.8,544.9 699.4,542.8 C702.1,540.7 704.7,538.6 707.4,536.6 C710.0,534.5 712.6,532.4 715.2,530.4 C717.8,528.4 720.4,526.3 723.0,524.3 C725.6,522.3 728.1,520.4 730.7,518.3 C733.3,516.2 735.9,513.9 738.4,511.6 C741.0,509.4 743.6,507.2 746.1,505.0 C748.7,502.7 751.2,500.5 753.8,498.3 C756.3,496.1 758.8,493.9 761.3,491.8 C763.8,489.6 766.3,487.4 768.8,485.3 C771.3,483.1 773.7,481.0 776.2,478.8 C778.6,476.7 781.1,474.6 783.5,472.5 C785.9,470.4 788.4,468.2 790.8,466.2 C793.2,464.1 796.8,460.9 798.0,459.9"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M587.1,589.2 C588.6,588.2 593.1,585.1 596.1,583.1 C599.1,581.1 602.1,579.2 605.0,577.2 C608.0,575.2 610.9,573.2 613.8,571.3 C616.7,569.3 619.6,567.4 622.4,565.5 C625.3,563.5 628.2,561.6 631.0,559.7 C633.8,557.8 636.6,555.9 639.4,554.1 C642.2,552.2 645.0,550.3 647.8,548.5 C650.5,546.6 653.3,544.8 656.0,542.9 C658.7,541.1 661.4,539.3 664.1,537.4 C666.9,535.4 669.6,533.2 672.3,531.2 C675.0,529.1 677.7,527.1 680.4,525.1 C683.0,523.0 685.7,521.0 688.3,519.0 C691.0,517.0 693.6,515.0 696.2,513.0 C698.9,511.0 701.5,509.0 704.0,507.1 C706.6,505.1 709.2,503.3 711.8,501.2 C714.3,499.1 717.0,496.9 719.5,494.7 C722.1,492.5 724.7,490.3 727.2,488.1 C729.8,486.0 732.4,483.8 734.9,481.7 C737.4,479.5 739.9,477.4 742.5,475.2 C745.0,473.1 747.5,471.0 749.9,468.9 C752.4,466.8 754.9,464.7 757.4,462.6 C759.8,460.5 762.3,458.4 764.7,456.3 C767.2,454.3 769.6,452.2 772.0,450.2 C774.4,448.1 778.0,445.1 779.2,444.0"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M606.6,608.9 L587.1,589.2"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M798.0,459.9 L779.2,444.0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M642.1,638.5 L651.0,631.2 L630.9,613.1 L622.0,620.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#292928",
      stroke: "#292928",
      strokeWidth: 0.8
    },
    d: "M619.8,627.3 L628.8,620.5 L609.0,601.6 L600.0,608.2 Z"
  }), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M619.8,627.3 C621.3,626.1 625.8,622.7 628.8,620.5 C631.7,618.2 634.7,616.0 637.6,613.8 C640.6,611.5 643.5,609.3 646.4,607.1 C649.3,605.0 652.2,602.8 655.0,600.6 C657.9,598.4 660.7,596.3 663.6,594.1 C666.4,592.0 669.2,589.9 672.0,587.8 C674.8,585.6 677.6,583.5 680.3,581.5 C683.1,579.4 685.8,577.3 688.5,575.2 C691.3,573.2 694.0,571.1 696.7,569.0 C699.4,566.9 702.1,564.7 704.8,562.5 C707.5,560.4 710.1,558.3 712.8,556.1 C715.4,554.0 718.1,551.9 720.7,549.8 C723.3,547.7 725.9,545.6 728.5,543.5 C731.1,541.5 733.7,539.4 736.3,537.3 C738.8,535.3 741.4,533.3 743.9,531.2 C746.5,529.1 749.1,526.9 751.6,524.8 C754.1,522.7 756.7,520.5 759.2,518.4 C761.7,516.3 764.2,514.2 766.7,512.1 C769.2,510.0 771.6,507.9 774.1,505.8 C776.6,503.7 779.0,501.7 781.5,499.6 C783.9,497.6 786.3,495.5 788.7,493.5 C791.1,491.5 793.5,489.4 795.9,487.4 C798.3,485.4 800.7,483.4 803.1,481.4 C805.4,479.4 808.9,476.5 810.1,475.5"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M600.0,608.2 C601.5,607.1 606.0,603.8 609.0,601.6 C612.0,599.4 615.0,597.2 617.9,595.1 C620.8,592.9 623.8,590.8 626.7,588.6 C629.6,586.5 632.5,584.4 635.3,582.3 C638.2,580.2 641.1,578.1 643.9,576.0 C646.7,573.9 649.6,571.8 652.4,569.8 C655.2,567.7 658.0,565.7 660.7,563.7 C663.5,561.6 666.2,559.6 669.0,557.6 C671.7,555.6 674.4,553.6 677.1,551.6 C679.9,549.5 682.6,547.4 685.3,545.3 C688.0,543.2 690.7,541.1 693.3,539.0 C696.0,536.9 698.6,534.9 701.3,532.8 C703.9,530.8 706.5,528.8 709.1,526.7 C711.7,524.7 714.3,522.7 716.9,520.7 C719.5,518.7 722.0,516.8 724.6,514.7 C727.2,512.7 729.7,510.5 732.3,508.5 C734.8,506.4 737.4,504.3 739.9,502.2 C742.4,500.1 744.9,498.1 747.4,496.0 C749.9,494.0 752.4,491.9 754.9,489.9 C757.3,487.9 759.8,485.9 762.2,483.9 C764.7,481.9 767.1,479.9 769.5,477.9 C772.0,475.9 774.4,473.9 776.8,471.9 C779.2,470.0 781.5,468.0 783.9,466.1 C786.3,464.1 789.8,461.2 791.0,460.2"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M619.8,627.3 L600.0,608.2"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M810.1,475.5 L791.0,460.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#202020",
      stroke: "#202020",
      strokeWidth: 0.8
    },
    d: "M633.9,650.0 L636.3,634.0 L616.3,607.5 L577.4,577.4 L572.5,601.3 Z"
  }), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M633.9,650.0 L636.3,634.0 L616.3,607.5 L577.4,577.4 L572.5,601.3 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "solid",
    style: {
      fill: "#2a2929",
      stroke: "#2a2929",
      strokeWidth: 0.8
    },
    d: "M633.1,645.8 L642.1,638.5 L622.0,620.2 L613.0,627.3 Z"
  }), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M633.1,645.8 C634.6,644.6 639.1,640.9 642.1,638.5 C645.1,636.1 648.0,633.6 651.0,631.2 C653.9,628.8 656.8,626.4 659.7,624.1 C662.6,621.7 665.5,619.3 668.4,617.0 C671.3,614.6 674.1,612.3 677.0,610.0 C679.8,607.7 682.6,605.3 685.4,603.1 C688.2,600.8 691.0,598.5 693.8,596.2 C696.6,594.0 699.3,591.7 702.1,589.5 C704.8,587.2 707.5,585.0 710.2,582.8 C712.9,580.6 715.6,578.4 718.3,576.2 C721.0,574.0 723.7,571.8 726.3,569.7 C728.9,567.5 731.6,565.3 734.2,563.2 C736.8,561.1 739.4,558.9 742.0,556.8 C744.6,554.7 747.2,552.6 749.7,550.5 C752.3,548.4 754.8,546.3 757.3,544.3 C759.9,542.2 762.4,540.2 764.9,538.1 C767.4,536.1 769.9,534.0 772.3,532.0 C774.8,530.0 777.3,528.0 779.7,526.0 C782.2,524.0 784.6,522.0 787.0,520.0 C789.4,518.0 791.9,516.1 794.2,514.1 C796.6,512.2 799.0,510.2 801.4,508.3 C803.8,506.3 806.1,504.4 808.5,502.5 C810.8,500.6 813.1,498.7 815.4,496.8 C817.8,494.9 821.2,492.1 822.4,491.1"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "ln",
    d: "M613.0,627.3 C614.5,626.1 619.0,622.5 622.0,620.2 C625.0,617.8 627.9,615.5 630.9,613.1 C633.8,610.8 636.8,608.4 639.7,606.1 C642.6,603.8 645.5,601.5 648.4,599.2 C651.2,596.9 654.1,594.7 656.9,592.4 C659.8,590.2 662.6,587.9 665.4,585.7 C668.2,583.4 671.0,581.2 673.8,579.0 C676.6,576.8 679.4,574.6 682.1,572.4 C684.9,570.3 687.6,568.1 690.3,565.9 C693.0,563.8 695.7,561.6 698.4,559.5 C701.1,557.4 703.8,555.2 706.4,553.1 C709.1,551.0 711.7,548.9 714.3,546.8 C717.0,544.8 719.6,542.7 722.2,540.6 C724.8,538.6 727.3,536.5 729.9,534.5 C732.5,532.4 735.0,530.4 737.6,528.4 C740.1,526.4 742.6,524.4 745.1,522.4 C747.7,520.4 750.1,518.4 752.6,516.4 C755.1,514.5 757.6,512.5 760.0,510.5 C762.5,508.6 764.9,506.7 767.4,504.7 C769.8,502.8 772.2,500.9 774.6,499.0 C777.0,497.1 779.4,495.2 781.8,493.3 C784.2,491.4 786.5,489.5 788.9,487.6 C791.2,485.8 793.6,483.9 795.9,482.1 C798.2,480.2 801.7,477.5 802.9,476.5"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M633.1,645.8 L613.0,627.3"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "ln-fine",
    d: "M822.4,491.1 L802.9,476.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 185.1,
    cy: 161.9,
    r: 2.6
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M185.1,161.9 L162.5,133.9 L73.7,133.9"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 76.7,
    y: 126.9
  }, "REAR WING")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 405,
    cy: 264,
    r: 2.6
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M405.0,264.0 L422.3,232.4 L538.7,232.4"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 425.3,
    y: 225.4
  }, "ENGINE COVER")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 484.9,
    cy: 299.6,
    r: 2.6
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M484.9,299.6 L507.3,271.5 L632.9,271.5"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 510.3,
    y: 264.5
  }, "AIRBOX INTAKE")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 477.6,
    cy: 338.3,
    r: 2.6
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M477.6,338.3 L583.5,317.1 L626.3,317.1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 586.5,
    y: 310.1
  }, "HALO")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 553.6,
    cy: 455.8,
    r: 2.6
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M553.6,455.8 L664.1,323.9 L817.3,323.9"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 667.1,
    y: 316.9
  }, "FRONT SUSPENSION")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 680.5,
    cy: 491.6,
    r: 2.6
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M680.5,491.6 L785.7,557.2 L874.5,557.2"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 788.7,
    y: 550.2
  }, "NOSE CONE")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 636.9,
    cy: 618.5,
    r: 2.6
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M636.9,618.5 L668.3,659.9 L766.3,659.9"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 671.3,
    y: 652.9
  }, "FRONT WING")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 501.2,
    cy: 537.3,
    r: 2.6
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M501.2,537.3 L489.4,587.9 L391.4,587.9"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 394.4,
    y: 580.9
  }, "FRONT TYRE")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 445.9,
    cy: 388,
    r: 2.6
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M445.9,388.0 L378.5,450.5 L252.9,450.5"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 255.9,
    y: 443.5
  }, "SIDEPOD INLET")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 345.6,
    cy: 392.3,
    r: 2.6
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M345.6,392.3 L296.1,408.2 L244.1,408.2"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 247.1,
    y: 401.2
  }, "FLOOR")), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 195.1,
    cy: 278.1,
    r: 2.6
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M195.1,278.1 L160.3,287.3 L71.5,287.3"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 74.5,
    y: 280.3
  }, "REAR TYRE")), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "lbl-dot",
    cx: 193.7,
    cy: 225.6,
    r: 2.6
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "lbl-line",
    d: "M193.7,225.6 L157.8,222.9 L78.2,222.9"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-text",
    x: 81.2,
    y: 215.9
  }, "DIFFUSER")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "lbl-title",
    x: 473,
    y: 712,
    textAnchor: "middle"
  }, "FIG. 1 - OPEN-WHEEL RACE CAR, 3/4 FRONT VIEW")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1Blueprint);
export default __webpack_public_path__ + "static/media/f1-blueprint.899e0c0b66170a220d23b854a77b2526.svg";
export { ForwardRef as ReactComponent };